export default {
  translations: {
    default: {
      available: 'available',
      staySafe: 'Stay safe with Protexxa',
      bookDemo: 'Book a demo',
      watchVideo: 'Watch the video',
      logout: 'Logout',
      GoDashboard: 'Go to Dashboard',
      completeProfile: 'Complete your profile',
      login: 'Login',
      individuals: 'For Individuals',
      emailVerified: 'E-mail address verified',
      add: 'Add',
      primary: 'Primary',
      email: 'Email',
      placeHolderEmail: 'john.doe@gmail.com',
      change: 'Change',
      profile: 'Profile',
      yes: 'Yes',
      no: 'No',
      cancel: 'Cancel',
      apply: 'Apply',
      ok: 'Ok',
      or: 'OR',
      delete: 'Delete',
      remove: 'Remove',
      learnMore: 'Learn More',
      gotIt: ' Got it',
      saveChanges: 'Save Changes',
      back: 'Back',
      next: 'Next',
      backToHomePage: 'Back to Home Page',
      previous: 'Previous',
      finish: 'Finish',
      contactSupport: 'Contact Support',
      contactSupportShort: 'Contact us',
      ignore: 'Ignore',
      promotion: 'Get your Personal Cyber Assessment today $49.99',
      translationAlert: 'Translation in progress.',
      placeHolderPhoneCountry: 'Select',
      placeHolderPhone: '(234) 567-8910',
      expand: 'Expand',
      collapse: 'Collapse',
      viewMore: 'View More',
      viewLess: 'View Less',
      maintenanceNotification:
        'Maintenance is scheduled for Monday, Sept 16th, 5-6 PM EST. The system will be unavailable during this time.',
      scanAlert: {
        onGoing:
          'Your scan is ongoing, and results will be updated on your dashboard in real time. You’ll be notified once the scan is complete, which may take up to 48 hours.',
        hasError:
          "Your scan could not be completed due to a server issue. Please click the 'Retry Scan' button to try again.",
        notBeCompleted: 'Scan could not be completed.',
        retryScan: 'Retry Scan',
        serverError: 'Your score could not be displayed due to a server error.',
      },
      profileMenu: {
        adminAccount: 'Admin Account',
        personalAccount: 'Personal account',
        logout: 'Log out',
      },
      appSidebar: {
        dashboard: 'Dashboard',
        findings: 'Findings',
        users: 'Users',
        scanLogs: 'Scan Logs',
        bulkScans: 'Bulk Scans',
        training: 'Training',
        integration: 'Integration',
        settings: 'Settings',
        CYBERMATCH: 'Job Matching',
        jobMatching: 'Job Matching',
        new: 'New',
      },
      adminBanner: {
        fragments: {
          youReViewing: "You're viewing the ",
          adminDashboardAs: ' admin dashboard as a ',
          superAdmin: 'Super Admin',
        },
        button: { backToCompany: 'Back to Companies' },
      },
      search: 'Search',
      emptyState: {
        table: {
          title: 'No data found',
          description: 'There is nothing to display right now.',
        },
      },
    },
    filters: {
      all: 'All',
      riskLevel: 'Risk levels',
      deepScanStatus: 'Deep scan status',
      deactivatedBy: 'Deactivated by',
      deactivatedAt: 'Date',
    },
    riskLevels: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
      pending: 'Pending',
    },
    deepScanStatus: {
      NOT_STARTED: 'Not Started',
      INVITED: 'Invited',
      NOT_INVITED: 'Not invited',
      INITIATED: 'Initiated',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
      PROCESSING: 'Processing',
      SCANNING: 'Scanning',
      UNAVAILABLE_SEATS: 'Unavailable seats',
      IMPORTANT: 'Important',
      CRITICAL: 'Critical',
    },
    universalTableComponent: {
      searchPlaceholder: 'Search...',
      page: 'page',
    },
    homeScreenCards: {
      community: {
        nameTitle: 'Protexxa Defender',
        namePlan: 'Community',
        price: ['/charged', 'once'],
        priceMessage: 'one-time scan',
        button: 'Purchase Now',
        items: [
          'Includes a',
          'one-time',
          'scan that will identify if your accounts were the subject of a cybersecurity breach',
          'Provides detailed solutions to resolve each compromise identified',
        ],
      },
      business: {
        nameTitle: 'Protexxa Defender',
        namePlan: 'Business',
        price: 'Contact Us',
        button: 'Book a Demo',
        items: [
          'Empowers company members to improve their online security on a',
          'monthly',
          'basis',
          'Provides detailed solutions to resolve each compromise identified and steps to increase individual employee cyber health',
        ],
      },
    },
    concierge: {
      welcome: 'Welcome to the Protexxa Concierge',
      infoHeader:
        'We are on stand-by to assist you with your immediate cyber security needs, and provide support for using our platform. If you have any questions about your cyber score and the mitigation strategies that are presented to you, feel free to use this form to share your questions or concerns.',
      infoBody:
        'Also, you are using Protexxa´s first version of our personal cybersecurity protection platform. You may have questions or concerns about using our platform, or even suggestions and ideas for further improvement. We look forward to receiving your feedback.',
      infoFooter:
        'Please share with us your issue, request, and inquiry, and we will respond to you within 24 business hours.',
      team: 'The Protexxa Team',
      name: 'Contact Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      type: 'Type',
      description: 'Description',
      submit: 'Submit',
      errorName: 'Full name is required',
      errorEmail: 'Email is required',
      errorPhone: 'Phone is required',
      errorCompany: 'Company is required',
      errorDescription: 'Description is required',
      errorType: 'Type is required',
      namePlaceholder: 'Insert your full name',
      emailPlaceholder: 'Insert your e-mail address',
      phonePlaceholder: '+0 (00) 000-0000',
      companyPlaceholder: "Insert your company's name",
      typePlaceholder: 'Please select issue type',
      descriptionPlaceholder: 'Write us a message',
      types: {
        none: '--None--',
        technicalissue: 'Technical Issue',
        feedback: 'Feedback',
        billing: 'Billing',
        generalinquiry: 'General Inquiry',
        mycybersecurityscore: 'My Cybersecurity Score',
      },
      salesforce: {
        welcome: 'Welcome to the Protexxa Concierge',
        infoHeader:
          "We are here to assist you with your immediate cyber security needs and provide comprehensive support. If you have any questions about your cyber score, the mitigation strategies presented, or about navigating our platform, we're here to help.",
        infoBody:
          "We continuously strive to improve. Whether you have suggestions for improvement, concerns, or any other ideas, we're eager to hear from you.",
        infoFooter:
          "Please share your issue, request, or inquiry with us, and we'll ensure a response within 24 business hours.",
        team1: 'Warm regards,',
        team2: 'The Protexxa Team',
      },
    },
    companyAdmin: {
      welcome: 'Welcome to the Protexxa community!',
      info1:
        "Build your personal profile to find out if you are a victim of any cyber breaches or have security blind spots, or visit your company's dashboard to learn more about its cyber health.",
      info2:
        'Rest assured, any information you provide, including the results of your assessment, are treated with the utmost confidentiality and will not be shared with anyone else.',
      menu: 'Go to Company Dashboard',
      profile: 'Build My Profile',
      yourJourneyEnhanced: 'Your journey to enhanced cyber health starts here.',
      permissionsTitle: 'As an <b>admin</b>, your current permissions allow you to:',
      permissionsList: [
        'see company dashboard',
        'run a new bulk scan',
        'send alert to users',
        'invite users for deep scan',
      ],
      dashboardInfo:
        'You can access your <b>company’s health dashboard</b> to monitor both company-wide and user-specific cyber health, and take necessary actions, or <b>build your personal Defender profile</b>.',
    },
    companyOnboarding: {
      lockedTitle: 'Company setup is in progress...',
      lockedMessage:
        "Another admin is currently onboarding your company to Defender. Once setup is complete, you'll get access to the company dashboard. In the meantime, you can continue with your personal account.",
      logout: 'Log out',
      personalDashboard: 'Go to personal dashboard',
    },
    companyDashboard: {
      tables: {
        users: {
          title: 'There is no data for users',
          description:
            "Upload your employee data to unlock detailed insights about your users' cyber health.",
          buttonLabel: 'Upload employee data',
        },
        findings: {
          title: 'There is no data for findings',
          description:
            "Upload your employee data to unlock detailed insights about your users' cyber health.",
          buttonLabel: 'Upload employee data',
        },
        departments: {
          title: 'There is no data for departments',
          description:
            "Update your employee data with their departments to unlock detailed insights about your departments' cyber health.",
          buttonLabel: 'Update employee data',
        },
        executives: {
          title: 'There is no data for executives',
          description:
            "Update your employee data with their roles to unlock detailed insights about your departments' cyber health.",
          buttonLabel: 'Update employee data',
        },
        customTable: {
          title: 'No results found for your current filters',
          description: 'Try adjusting the filters to see more data.',
          buttonLabel: 'Update employee data',
        },
      },
      users: 'Users',
      menuHeader: 'Dashboard',
      menuDashboard: 'Company Dashboard',
      menuReport: 'Personal Report',
      menuInvite: 'Invite Users',
      threatsIndicators: 'Indicators of Compromise',
      threatsLeaks: 'Potential Leaks or Breaches',
      threatsCyber: 'Cyber Hygiene',
      threatsControls: 'Controls Not in Place',
      companyScore: 'Company Score',
      companyScoreDescription: 'This shows the Average Protexxa Score trend over time.',
      companyScoreDescriptionLearnMore: 'Learn More',
      userCyberScore: 'User Cyber Score',
      userCyberScoreDescription:
        'Range of scores from individual scans performed by users of your company.',
      trendDescription:
        'This component displays the latest company score status. Your company score is updated monthly, when a new user joins your company, or if one of your users scores change.',
      trendUpArrow: 'Upward arrow: your score has improved.',
      trendDownArrow: 'Downward arrow: your score has decreased.',
      trendDoubleArrow: 'Double arrow: No change, the score remains the same.',
      scoreHighest: 'Highest',
      scoreAverage: 'Average',
      scoreLowest: 'Lowest',
      lastScanHappenedIn: 'Last scan happened in:',
      nextScanSchedulefor: 'Next scan scheduled for:',
      recommendedAction: 'Recommended Action',
      review: 'Review',
      reviewActivity: 'Review Activity',
      gotIt: 'Got it',
      criticalAreas: 'Critical Areas',
      criticalAreasDescription: 'These items could expose you and your company to a cyber attack.',
      threatsIdentified: 'threats identified',
      importantAreas: 'Important Areas',
      importantAreasDescription:
        'Fixing these issues could have a major impact for your company’s safety.',
      noCriticalThreats: 'No critical threats',
      noImportantThreats: 'No important threats',
      areasOfStrength: 'Areas of Strength',
      areasOfStrengthDescription: 'These items help keep your company safe.',
      areasIdentified: 'areas identified',
      noAreasOfStrength: 'No strength threats',
      whyIsThisImportant: 'Why is this important?',
      findings: {
        externalFindings: 'External findings',
        internalFindings: 'Internal findings',
      },
      emptyState: {
        title: 'Uh oh! There is no data available to report on.',
        description: 'Invite more members to begin calculating your company score.',
        secondTitle: 'Your company score is almost ready.',
        secondDescription:
          'Once five or more members complete their personal scan, your company score will be available to view.',
        resendInvites: 'Resend Invites',
        succesInviteUsers: 'Invitations sent Successfully!',
      },
      inviteUsers: 'Invite Users',
      inviteUsersDescription:
        'Add users by sending them this link so they can create their account',
      inviteByEmail: {
        messages: {
          success: 'Email invites sent successfully.',
          error: 'Error sending email invites. Please try again later.',
        },
        placeholder:
          'Invite one or multiple users at the same time:\njohn@email.com, jane@email.com, adam@email.com',
        sendButton_zero: 'Send Invites',
        sendButton_one: 'Send {{count}} Invite',
        sendButton_other: 'Send {{count}} Invites',
        clearButton: 'Remove All',
        header: 'Invite by Email',
        invalidEmailMessage:
          'One or more invalid email addresses. Verify if all the information is correct and try again.',
      },
      totalSeats: 'Total Seats',
      totalSeatsDescription: 'Seats in current license',
      upgrade: 'Upgrade',
      seatsTooltip: 'Maximum number of users. Contact sales to upgrade.',
      userProfiles: 'Users Registered',
      usersProfilesDescription: 'Users that have created a profile',
      seatsConvertedToProfiles: 'of seats have been converted to user profiles.',
      seatsAvailable: 'seats available',
      userScans: 'Users Scanned',
      userScansDescriptions: 'Users aggregated in this dashboard',
      usersHaveNotScannedYet: 'users have not scanned yet',
      usersHaveCompletedTheirScan: 'of users have completed their scan',
      noIssues: 'No issues',
      changePasswordLeak: 'Have you changed your password after the leaks?',
      TwoFactor: 'Multi-Factor Authentication',
      TwoFactorDescription:
        'Improve your online safety by checking if the apps you selected when building your profile have that option, and start using multi-factor authentication to log in.',
      addressLeak: 'Address Leaked',
      addressLeakDescription: 'Your address was leaked in these sites',
      personageImage: ' Personal Image in Use',
      personalImageDescription: 'Your personal image was found in these sites',
      appPermision: 'Invasive Apps Permissions',
      appPermisionDescription: 'You are using some apps that can be harmful for your security',
      phoneLeak: 'Your phone number is registered in these sites',
      socialMedia: 'Private Social Media',
      socialMediaDescription:
        ' You don’t have all your social accounts set to private. Start improving your online safety by checking if the apps you selected when building your profile have options to secure your personal data.',
      downloadTemplate: 'Download Template',
      goToMarketplace: 'Go to Marketplace',
      scoreRange: {
        modalTitle: 'What does the score mean?',
        modalButton: 'Got it',
        a: '900 - 1000:  Your organization has excellent cyber hygiene or a limited radius of exposure. We encourage your continued focus and diligence. Always keep cyber protection at the forefront of your operations.',
        b: "800-899: Your organization's efforts are making a positive impact. There's still some room to further enhance your defenses. Keep up the good work and continue prioritizing cyber protection to strengthen your digital resilience.",
        c: '700 - 799: Your organization has very good online habits and are less likely to fall prey to cyber threats. Consider levelling up your cyber training to strengthen enterprise protection.',
        d: '600 - 699: Your organization has very good online habits and are less likely to fall prey to cyber threats. Consider levelling up your cyber training to strengthen enterprise protection.',
        e: '400 - 599: Your organization has a reasonable chance of being impacted by a cyber attack. Additional focus on your cyber hygiene is required. A few small changes will have a major impact for your company.',
        f: '0 - 399: Your organization has poor cyber hygiene, and you are in the highest risk category for compromise. Immediate focus on reducing the attack surface is required.',
      },
      legend: {
        title: 'Legend',
        lessThan50: 'Less than 50% users',
        atLeast50: 'At least 50% users',
        all00: '100% users',
        numberOfUsersWithIncidents: 'Number of Users With Incidents From the Most Recent Scan',
      },
      whatCanIDo: 'What can I do?',
      company: 'Company',
      personal: 'Personal',
      status: {
        completed: 'Completed',
        initiated: 'Initiated',
        notStarted: 'Not Started',
        invited: 'Invited',
        pending: 'Pending',
        notInvited: 'Not invited',
        failed: 'Failed',
        processing: 'Processing',
        scanning: 'Scanning',
        inProgress: 'In Progress',
        createdNoScan: 'Created (no scan)',
        unavailableSeats: 'Unavailable seats',
        important: 'Important',
        critical: 'Critical',
      },
      level: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical',
        pending: 'Pending',
      },
      bulkAction: {
        bulkAction: 'Bulk Action',
        alertUsers: 'Alert users',
        requestTakedown: 'Request takedown',
      },
      companyFindings: {
        allFindings: 'All external findings',
        allDomains: 'All company domains',
        allResults: 'All results',
        tableAriaLabel: 'Findings table',
        issuesCount_one: '{{count}} issue',
        issuesCount_other: '{{count}} issues',
        showingAllResults: 'Showing all results',
        showingAllCredentialLeaks: 'Showing all credential leaks',
        showingAllMentions: 'Showing name and email mentions',
        showingAllNameMentions: 'Showing all name mentions',
        showingAllEmailMentions: 'Showing all email mentions',
        listByIssue: 'List by Issue',
        listBySource: 'List by Source',
        credentials: 'Credential leaks',
        credentialsTooltip:
          'Findings in the scan with employee passwords and other credentials leaked.',
        passwordLeaks: 'Password leaks',
        malware: 'Malware',
        botnet: 'Botnet',
        nameAndEmailMentions: 'Name and email mentions',
        mentionsTooltip: 'Findings in the scan with employee names or emails mentioned.',
        namesExposed: 'Name mentions',
        namesExposedTooltip: 'Findings in the scan with employee names mentioned.',
        emailsExposed: 'Email mentions',
        emailsExposedTooltip: 'Findings in the scan with employee emails mentioned.',
        scanInProgressTitle: 'Scan is currently in progress...',
        scanInProgressSubtitle:
          'Your scan results will be displayed here once the scan is complete.',
        filters: {
          departments: 'Departments',
          threatLevel: 'Threat level',
          source: 'Source',
          dateOfExposure: 'Date of exposure',
          issue: 'Issue',
          allDates: 'All dates',
          last7Days: 'Last 7 days',
          last30Days: 'Last 30 days',
          last90Days: 'Last 90 days',
          passwordLeaks: 'Password leaks',
          botnetLeaks: 'Botnet Leaks',
          plainTextPassword: 'Plain-text password',
          nameExposure: 'Name mention',
          emailExposure: 'Email mention',
          low: 'Low',
          medium: 'Medium',
          high: 'High',
          pending: 'Pending',
          finance: 'Finance',
          marketing: 'Marketing',
          sales: 'Sales',
          technology: 'Technology',
          customerSuccess: 'Customer Success',
          all: 'All',
          allIssues: 'All issues',
          critical: 'Critical',
          important: 'Important',
          deepScanStatus: 'Deep scan status',
          bulkScanStatus: 'Status',
          date: 'Date Found',
          riskLevel: 'Risk level',
          users: 'Users',
          allUsers: 'All users',
          executives: 'Executives',
          rangeError: 'Invalid range',
        },
        tableHeader: {
          userAffected: 'User affected',
          breached: 'Breached',
          dateFound: 'Date found',
          sortedDescending: 'sorted descending',
          sortedAscending: 'sorted ascending',
          breachedTooltip: 'When the breach happened.',
          dateFoundTooltip: 'When this breach was last found by Protexxa Defender.',
        },
        tooltips: {
          alertUsers: 'Alert user',
          deepScan: 'Deep scan invite',
          requestTakedown: 'Request takedown',
          comingSoon: 'Coming soon',
        },
        description:
          'These are exposures that originate from potentially risky sources and would require immediate review and actions to escalate them.',
        internalDescription:
          'These are exposures that originate from your company domains and are marked safe. Threat-level escalation actions are disabled for these exposures.',
        listLabel: 'Here’s a list of exposures found for:',
        ofTotalExposures: 'of total exposures',
        riskLevelChange: {
          confirmTitle: 'Sure to continue?',
          confirmDescription: 'If you proceed, the risk level for this finding will be updated.',
          cancel: 'Cancel',
          proceed: 'Proceed',
          restoreToDefault: 'Restore to default',
        },
        downloadReport: {
          button: 'Download report',
          resultsFound: 'Results found from your company scans.',
          selectCompletedScheduledScan: 'Select any completed scheduled scan',
          downloadAsCsv: 'Download as CSV',
          latest: 'latest',
          loadScansError: 'Unable to load completed scheduled scans.',
          downloadSuccess: 'Report downloaded successfully.',
          downloadError: 'Unable to download selected scan report.',
        },
      },
      score: {
        scannedUsers: 'Active users',
        inProgress: {
          title: 'Scan is currently in progress...',
          description:
            'Your company’s cyber score results will be displayed here once the scan is complete.',
        },
      },
    },
    usersPage: {
      owner: 'Owner',
      admin: 'Admin',
      emptyStates: {
        admins: {
          title: 'There is no data for admins',
          description: 'Update your admin data with their roles to unlock detailed insights.',
          buttonLabel: 'Update admin data',
        },
        departments: {
          title: 'There is no data for departments',
          description:
            'Update your user data with their departments to unlock detailed insights about your departments’ cyber healths.',
          buttonLabel: 'Update user data',
        },
        allUsers: {
          title: 'There is no data for users',
          description:
            'Upload your user data to unlock detailed insights about your users’ cyber healths.',
          buttonLabel: 'Upload user data',
        },
        executives: {
          title: 'There is no data for executives',
          description:
            'Update your user data with their roles to unlock detailed insights about your departments’ cyber healths.',
          buttonLabel: 'Update user data',
        },
        default: 'Unavailable',
      },
      updateEmployees: {
        buttonLabel: 'Update employees',
        modal: {
          title: 'Update your employee list',
          subtitle:
            'Upload your latest workforce file to update your active employee directory. This will automatically add, update, or remove employees on the platform.',
          downloadSampleText: 'For a template on how to structure your data correctly,',
          downloadSampleLink: 'Download this sample file',
          downloadSample: 'Download the sample file',
          browseFile: 'Browse file',
          dragAndDrop: 'or drag and drop it here.',
          supportedFormats: 'Only CSV and XLS file formats are supported.',
          replaceFile: 'Replace file',
          previewFile: 'Preview file',
          uploading: 'uploading...',
          uploaded: 'uploaded',
          profilesUploaded: '{{count}} profiles were uploaded.',
          comparing: 'Comparing uploaded data with current users...',
          invalidFormat: 'Invalid file format. Only CSV and XLS files are supported.',
          noNewUsers: {
            title: 'No new users were found or missing.',
            description: 'Update your directory to be refreshed with the latest information.',
            button: 'Update employee list',
          },
          newUsersFound: {
            title:
              '{{count}} new users detected in the bulk scan file are not on your current employee list.',
            description:
              'You can scan the new users now or update the employee list only and include them in the next scheduled company scan.',
            viewProfiles: 'View profiles',
            scanButton: 'Update and scan users',
            skipButton: 'Skip scan, only update list',
          },
          missingUsers: {
            title:
              '{{count}} users from your current employee list are not in this bulk scan file.',
            description:
              'Review these users to continue to update your employee list. This will deactivate them and exclude them from future company scan reports',
            learnMore: 'Learn more)',
            viewProfiles: 'View profiles',
          },
          renamedUsers: {
            title: '{{count}} users detected in the uploaded bulk file have their names updated.',
            description:
              'You can scan these users now or update the employee list only and include them in the next scheduled company scan.',
            viewProfiles: 'View profiles',
          },
          confirmation: {
            title: 'Sure to continue?',
            body: 'Your employee list will be updated with this file, and missing users (from the list) will be deactivated.',
            cancel: 'Cancel',
            proceed: 'Proceed',
          },
          footer: {
            cancel: 'Cancel',
            updateEmployeeList: 'Update employee list',
          },
          errors: {
            fileTooLarge: 'File is too large. Maximum size is 5MB.',
            missingHeaders: 'File is missing required headers.',
            noRows: 'File has no data rows.',
            comparisonFailed: 'Failed to compare uploaded data. Please try again.',
            invalidFileContent:
              'Your file could not be processed. Please check that it matches the sample file template and try again.',
            updateFailed: 'Failed to update directory. Please try again.',
            scanFailed: 'Failed to start scan. Please try again.',
          },
          success: {
            updated: 'Your employee list has been successfully updated.',
            scanning:
              "Your scan is currently in progress. You'll be notified once the scan is complete.",
          },
        },
      },
      notAvailable: 'Not available',
      mfa: 'Multi-Factor Authentication (MFA)',
      cyberPlan: 'Cybersecurity Response Plan',
      training: 'Training',
      bulkAction: 'Bulk Action',
      allUsers: {
        tab: 'All users',
        active: {
          card: 'Active users',
          description: 'View and manage your active users within the platform',
          emptyState: {
            title: 'There are no active users',
            description:
              'Click on the ‘Update employees’ button below to add your employees and start monitoring their exposure and security risks.',
          },
        },
        inactive: {
          card: 'Inactive users',
          description: 'These users have been deactivated and are not currently monitored.',
          emptyState: {
            title: 'There are no inactive users',
            description: 'Deactivated users will appear here.',
          },
        },
        alertUsers: 'Alert users',
        deactivateUsers: 'Deactivate users',
        inviteToDeepScan: 'Invite to deep scan',
        reactivateUsers: 'Reactivate users',
        reactivateUser: 'Reactivate user',
        deleteUsers: 'Delete users',
        deleteUser: 'Delete user',
        queuedUsers: 'Queued users',
        queuedUsersDialog: {
          title: 'Queued users',
          description:
            'These users were recently added. They will be included in the next company scan and moved to Active users.',
          emptyState: {
            title: 'There are no queued users',
            description:
              'Click on the ‘Update employees’ button to add your employees and start monitoring their exposure and security risks.',
          },
        },
        deactivateUsersDialog: {
          title: 'Are you sure you want to deactivate these users?',
          titleSingle: 'Are you sure you want to deactivate this user?',
          description:
            'The users’s profiles and data will be removed from subsequent company scans and the users will be termed ‘Inactive’. Do you want to continue?',
          descriptionSingle:
            'The user’s profile and data will be removed from subsequent company scans and the user will be termed ‘Inactive’. Do you want to continue?',
          cancel: 'Cancel',
          confirm: 'Deactivate users',
          confirmSingle: 'Deactivate user',
        },
        deactivateUsersToast: {
          success_one: 'Successfully deactivated {{count}} user.',
          success_other: 'Successfully deactivated {{count}} users.',
          partial:
            'Deactivated {{successCount}} of {{total}} users. Skipped: {{skipped}}. Failed: {{failed}}.',
          partialWithError:
            'Deactivated {{successCount}} of {{total}} users. Skipped: {{skipped}}. Failed: {{failed}}. First error: {{error}}',
          error: 'Failed to deactivate users. {{error}}',
          errorFallback_one: 'Failed to deactivate {{count}} selected user.',
          errorFallback_other: 'Failed to deactivate {{count}} selected users.',
          catchError: 'Failed to deactivate selected users.',
        },
        reactivateUsersDialog: {
          titleSingle: 'Are you sure you want to reactivate this user?',
          titleMultiple: 'Are you sure you want to reactivate these users?',
          descriptionSingle:
            "The user's profile and data will be included in subsequent company scans and the user will be termed 'Active'. Do you want to continue?",
          descriptionMultiple:
            "The users' profiles and data will be included in subsequent company scans and the users will be termed 'Active'. Do you want to continue?",
          cancelSingle: 'Cancel',
          cancelMultiple: 'Cancel',
          confirmSingle: 'Reactivate user',
          confirmMultiple: 'Reactivate users',
        },
        reactivateUsersToast: {
          success_one: 'Successfully reactivated {{count}} user.',
          success_other: 'Successfully reactivated {{count}} users.',
          partial:
            'Reactivated {{successCount}} of {{total}} users. Skipped: {{skipped}}. Failed: {{failed}}.',
          partialWithError:
            'Reactivated {{successCount}} of {{total}} users. Skipped: {{skipped}}. Failed: {{failed}}. First error: {{error}}',
          error: 'Failed to reactivate users. {{error}}',
          errorFallback_one: 'Failed to reactivate {{count}} selected user.',
          errorFallback_other: 'Failed to reactivate {{count}} selected users.',
          catchError: 'Failed to reactivate selected users.',
        },
        deleteUsersDialog: {
          titleSingle: 'Are you sure you want to delete this user?',
          titleMultiple: 'Are you sure you want to delete these users?',
          alert: 'This action cannot be reversed!',
          descriptionSingle:
            "The user's profile data and settings will be permanently deleted from your company account permanently. Do you want to continue?",
          descriptionMultiple:
            "The users's profiles and related data will be permanently deleted. This action cannot be undone. Do you want to continue?",
          cancelSingle: 'Cancel',
          cancelMultiple: 'Cancel',
          confirmSingle: 'Delete user',
          confirmMultiple: 'Delete users',
        },
        deleteUsersToast: {
          success_one: 'Successfully deleted {{count}} user.',
          success_other: 'Successfully deleted {{count}} users.',
          partial:
            'Deleted {{successCount}} of {{total}} users. Skipped: {{skipped}}. Failed: {{failed}}.',
          partialWithError:
            'Deleted {{successCount}} of {{total}} users. Skipped: {{skipped}}. Failed: {{failed}}. First error: {{error}}',
          error: 'Failed to delete users. {{error}}',
          errorFallback_one: 'Failed to delete {{count}} selected user.',
          errorFallback_other: 'Failed to delete {{count}} selected users.',
          catchError: 'Failed to delete selected users.',
        },
      },
      departments: {
        tab: 'Departments',
        description: 'View and manage your departments within the platform',
        emptyState: {
          title: 'There are no departments',
          description:
            'Click on the ‘Update employees’ button below to add your employees and start monitoring their exposure and security risks.',
        },
      },
      tables: {
        headers: {
          users: 'Users',
          name: 'Name',
          nameDescription: 'First and Last names',
          title: 'Title',
          email: 'Email',
          department: 'Department',
          role: 'Role',
          deepScanStatus: 'Deep scan status',
          findings: 'Findings',
          findingsTooltip: {
            criticalFindings: 'Critical findings',
            highRiskFindings: 'High-risk findings',
            mediumRiskFindings: 'Medium-risk findings',
            lowRiskFindings: 'Low-risk findings',
            noFindings: 'No findings.',
            criticalRiskUsers: 'Critical risk users',
            highRiskUsers: 'High risk users',
            mediumRiskUsers: 'Medium risk users',
            lowRiskUsers: 'Low risk users',
            usersWithNoFindings: 'Users with no findings.',
          },
          riskLevels: 'Risk levels',
          usersByRiskLevels: 'Users by risk levels',
          deactivatedBy: 'Deactivated by',
          deactivatedAt: 'Deactivated on',
          actions: 'Actions',
          userCount: 'Users count',
        },
        unassigned: 'Unassigned',
        emptyState: {
          active: {
            title: 'There are no active users',
            description: 'There are no active users that match your current filters.',
          },
          inactive: {
            title: 'There are no inactive users',
            description: 'There are no inactive users that match your current filters.',
          },
        },
      },
      users: 'Users',
      actions: 'Actions',
      profile: {
        source: 'Source',
        details: 'Details',
        findings: 'Findings',
        email: 'Email:',
        dateAdded: 'Date added:',
        phone: 'Phone:',
        location: 'Location:',
        noInformation: 'No information',
        thisUser: 'this user',
        deepScanStatus: 'Deep scan status:',
        deepScanInitiated: 'Deep scan initiated:',
        protexxaScore: "User's Protexxa Score",
        low: 'Low Risk',
        medium: 'Medium Risk',
        high: 'High Risk',
        critical: 'Critical Risk',
        criticalRiskIssues: 'Critical risk issues',
        highRiskIssues: 'High risk issues',
        mediumRiskIssues: 'Medium risk issues',
        lowRiskIssues: 'Low risk issues',
        findingsSummary_one: 'issue was found for {{name}}',
        findingsSummary_other: 'issues were found for {{name}}',
        securityHabits: {
          title: 'Security habits',
          passwordManager: 'Password manager',
          multiFactorAuthentication: 'Multi-factor Authentication',
          incidentResponsePlan: 'Incident Response Plan',
          usingOne: 'Using one',
          enabled: 'Enabled',
          setUp: 'Set up',
          notSetUp: 'Not set up',
        },
        securityProfile: 'Security profile',
        userScanNavigation: 'User scan navigation',
        pending: 'Pending Risk',
        scoreDisclaimer:
          "Preliminary score based on limited data. User's full score will be updated after the deep scan is completed.",
        fromLastScan: 'from last scan',
        inviteDeepScan: 'Invite for deep scan',
        lastScan: 'Last scan:',
      },
      companyScan: {
        companyScan: 'Company scan',
        companyScanResults: 'Company scan results',
        info: 'From the company bulk scan initiated by the admin.',
        lastScan: 'Last scan:',
        nextScheduledScan: 'Next scheduled scan:',
        noIssuesFoundCompanyScan: 'There are no issues found for this user in the company scan.',
        notInvitedDescription:
          'Invite this user to run a deep scan across their personal accounts for an improved and better digital security.',
        inviteForDeepScan: 'Invite for deep scan',
        recommendations: {
          title: 'Recommendations',
          alertUser: 'Alert User',
          inviteDeepScanDescription:
            'Invite the user to run a deep scan immediately on their account to identify all compromised data.',
          alertUserDescription:
            'Alert this user and instruct them to reset their password on leaked accounts or report any websites exposing their data for takedown.',
          mfaTrainingDescription:
            'Share training materials to the user on how to setup MFA on their company accounts and strengthen their online security.',
          codes: {
            'verify-data-consent':
              'Alert this user to verify data consent and report if unauthorized.',
            'run-deep-scan': 'Prompt the user to run a deep scan for additional exposures.',
            'check-user-profile': 'View the user profile to check for other exposures.',
            'reset-leaked-passwords': 'Instruct the user to reset passwords on leaked accounts.',
            'check-similar-passwords': 'Check for issues with similar source',
          },
        },
      },
      discoveryTable: {
        recentDiscoveries: 'Recent discoveries',
        detail: 'Detail',
        threatLevel: 'Threat level',
        date: 'Date',
        searchPlaceholder: 'Enter source name to search',
        issueType: 'Issue',
        actions: 'Actions',
        modal: {
          title: {
            name: 'Name exposure',
            email: 'Email exposure',
            nameMention: 'Name mention',
            emailMention: 'Email mention',
            address: 'Address exposure',
            phone: 'Phone exposure',
            webdomain: 'Web domain exposure',
            credential: 'Credential leak',
            botnet: 'Botnet leak',
            default: 'Exposure',
          },
          notAvailable: 'Not available',
          notProvided: 'Not provided',
          dateFound: 'Date found:',
          dateFoundLabel: 'Date found',
          detailsTitle: 'Details',
          viewUserProfile: 'View user profile',
          showMore: 'Show more',
          showLess: 'Show less',
          close: 'Close',
          riskSuffix: 'risk',
          descriptionFallback:
            'No description provided. Some exposures only disclose basic fields such as the leaked data and breach date.',
          preview: {
            title: 'Leaked data preview',
            dataTitle: 'Data preview',
            email: 'Email',
            username: 'Username',
            password: 'Password',
            name: 'Name',
          },
          fields: {
            botnetFamily: 'Botnet family',
            dataTypesLeaked: 'Data types leaked',
            dataTypesExposed: 'Data types exposed',
          },
          previewDescription: {
            botnet:
              'Devices linked to botnet activity may be compromised and could be used to spread malware or launch attacks from within your network.',
            credentials: 'Exposed credentials are commonly reused across corporate systems.',
            name: 'Exposed names can be used for impersonation, social engineering, or targeted phishing attempts against your organization.',
            email:
              'Exposed email addresses increase the risk of phishing, credential stuffing, and targeted account compromise.',
          },
          exposure: {
            details: 'Exposure details',
            exposedData: 'Exposed data',
            date: 'Exposure date',
            source: 'Source',
            companyName: 'Company name',
            exposedDataTypes: {
              name: 'Name',
              email: 'Email',
              address: 'Address',
              phone: 'Phone',
            },
          },
          linkCopy: 'Link was copied to clipboard',
          leak: {
            details: 'Leak Details',
            type: 'Type',
            passwordLeak: 'Password Leak',
            leakedData: 'Leaked Data',
            breachDate: 'Breach Date',
            breachSource: 'Breach Source',
            impactedDomain: 'Impacted Domain',
            description: 'Description',
            date: 'Date of breach',
            breachName: 'Breach name:',
            breachDomain: 'Breach domain:',
          },
          recommendations: {
            title: 'Recommendations',
            alertUser: 'Alert user',
            alertUserDescription:
              'to verify if they consented to share their data with the website and, if not, report it immediately.',
            promptUser: 'Prompt the user',
            promptUserDescription:
              'to run a deep scan to uncover and report additional security exposures.',
          },
        },
        emptyState: 'There are no issues found for this user.',
      },
      deepScan: {
        deepScan: 'Deep scan',
        info: 'From the deep scan initiated by the user.',
        lastScan: 'Last scan: ',
        nextScan: 'Next scheduled scan:',
        totalExposures: 'Total exposures',
        takedownRequests: 'Takedown requests',
        unlockData: 'Unlock more insights with employee deep scan data',
        insights:
          "With insights from employees' deep scans, you can identify vulnerabilities and assess their personal cyber health compliance.",
        inviteDeepScan: 'Invite for deep scan',
        password: 'Password Compromised',
        email: 'Email exposures',
        address: 'Address exposures',
        name: 'Name exposures',
        image: 'Image exposures',
      },
      deepDepartments: {
        avgScore: 'Average Protexxa Score',
        trend: 'Protexxa score trend',
        overview: 'Overview',
        status: 'Deep scan status',
        users: 'Users',
        cyberPlan: 'Cybersecurity Plan',
        mfa: 'MFA Installs',
        training: 'Training',
        uniqueUsers: 'unique users',
        havePlan: 'have a cybersecurity response plan',
        usingMFA: 'are using multi-factor authentication',
        haveTraining: 'have completed training',
        noDataChartTitle: 'This section requires more data',
        noDataChartSubtitle:
          'Your score trend will be displayed after subsequent scans on your account.',
      },
      executives: 'Executives',
    },
    status: {
      completed: 'Completed',
      initiated: 'Initiated',
      notStarted: 'Not Started',
      invited: 'Invited',
      pending: 'Pending',
      active: 'Active',
      inactive: 'Inactive',
      ongoing: 'Ongoing',
    },
    modals: {
      publicDomains: {
        title: 'Web Domains - What to note',
        item1: 'Only company domains are allowed. Public domains will not be scanned.',
        item3: 'Once submitted, domains may not be changed or removed.',
        item2Title: 'Public domain',
        item2Description: 'is one that:',
        item2a:
          'is known to offer mass email registration to the general public without organizational affiliation requirements.',
        item2b: 'Anyone can register an email on, without needing to own or control the domain.',
        item2c: 'is operated by a public email service provider, usually free or very low cost.',
        item2d: 'is widely known and has massive user bases.',
        examplesTitle: 'Examples of public domains are:',
      },
      notifyUser: {
        title: 'Alert user',
        subtitle: 'Notify user to take action. Notifications will be sent via email.',
        messageTitle: 'Add custom message',
        messagePlaceholder: 'Enter your custom message here',
        shareTitle: 'Share training materials',
        optional: '(Optional)',
        shareUsers: 'Share link with the user(s)',
        selectLibrary: ' Select resource from Library',
        resource: 'Resource',
        cancel: 'Cancel',
        share: 'Send',
        bestPractices: 'Cybersecurity best practices',
      },
      inviteUser: {
        title: 'Invite user',
        subtitle: 'User will receive a notification via email to run a deep scan.',
        messageTitle: 'Add custom message',
        button: 'Send invite',
        copy: 'Copy link',
        copyTitle: 'You can also copy the invite link and share with the user.',
        inviteDefaultMessage:
          'You’ve been invited to set up your account on Defender and run a deep scan. This step is essential to ensure a secure onboarding process.',
        inviteSuccessMessage: 'User has been invited successfully!',
        inviteErrorMessage: 'There was an error inviting the user.',
        inviteDeepScan:
          'You’ve been invited to set up your account on Defender and run a deep scan.',
      },
      bulkAction: {
        title: 'Notify users',
        subtitle: 'Notify users to take action. Notifications will be sent via email.',
        buttons: {
          cancel: 'Cancel',
          next: 'Next',
          previous: 'Previous',
          share: 'Share',
          gotIt: 'Got it',
          removeAll: 'Remove all',
          sendInvites: 'Send invites',
        },
        selectInvite: {
          title: 'Invite users',
          step: 'Step 1: Select your recipients',
          filter: {
            users: 'Users',
            departments: 'Departments',
            executives: 'Executives',
          },
          searchPlaceholder: 'Search the name of users here',
          check: 'Send to all users',
          empty: 'Selected users will be displayed here',
          emptyList: 'No data available',
        },
        sendInvite: {
          step: 'Step 2: Enter message',
          message: 'Add custom message',
          placeholder: 'Enter your custom message here',
          share: {
            title: 'Share training materials',
            optional: '(Optional)',
            selectLibrary: 'Select resource from Library',
            shareLink: 'Share link with user(s)',
          },
          link: 'Link URL',
          linkPlaceholder: 'Paste link here',
        },
        success: {
          title: 'Notifications have been sent!',
          subtitle:
            'Your message has been successfully forwarded to the recipients email addresses.',
        },
      },
      bulkScanInvite: {
        manualInvite: 'Manual invite ',
        bulkInvite: 'Bulk invite',
        deepScan: 'Invite to deep scan',
        sendInvitations: 'Send invitations',
        sendInvitationsWithCount: 'Send {{count}} invites',
        comingSoon: 'This feature will be available soon.',
        success: {
          title: 'Invitations have been sent!',
          subtitle:
            "Your message has been successfully forwarded to the recipients' email addresses.",
        },
      },
      comingSoon: 'Coming soon',
    },
    companySettings: {
      profileToastError: 'Profile data not found',
      addAdminModal: {
        addSuccesMessage: 'Admin user has been added successfully, and the user has been notified.',
        revokeSuccesMessage:
          'User’s admin access has been removed successfully, and their status changed to ‘inactive’.',
        title: 'Add admin user',
        description: 'Search a user or add manually to grant admin access',
        searchUser: 'Search user',
        addUserManually: 'Add user manually',
        selectUser: 'Select user',
        enterUserEmail: "Enter user's email",
        emailLabel: 'Email',
        grantAccess: 'Grant access',
        cancel: 'Cancel',
        success:
          'Selected user will have full access to user management, scan initiation, takedown requests, and permissions, invite Company Admins, assign permissions, and run/view bulk scans and results.',
        error: 'Invalid email. Check the email and try again.',
        invalidEmail: 'Invalid email address',
        hasAlreadyAdminAccess: 'User already has admin access',
        enterUserEmailWithDomain: 'Enter user’s email (with company domain) here',
        searchUserPlaceholder: 'Search user by name or email',
      },
      revokeAdminAccessModal: {
        title: 'Remove admin access',
        confirmation:
          'Are you sure you want to continue? This user will lose access to the admin dashboard and all admin-related functions.',
        cancel: 'Cancel',
        remove: 'Remove access',
      },
      adminManagement: {
        title: 'Admin users',
        description:
          'Create and manage internal roles in your company, securely and independently to support compliance and security',
        name: 'Name',
        createdBy: 'Added By',
        updatedBy: 'Updated By',
        status: 'Status',
        removeAccess: 'Remove Access',
        owner: 'Owner',
      },
      adminStatus: {
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        invited: 'Invited',
        invitedExpired: 'Invite expired',
        invitedCancelled: 'Invite cancelled',
      },
      security: {
        title: 'Security settings',
        description:
          'Keep your account secure by updating your password or managing account access.',
        passwordChanged: 'Password changed successfully',
        updatePassword: {
          title: 'Update password',
          description: 'Your new password must be at least 12 characters and contain:',
          requirements: 'Your new password must be at least 12 characters and contain:',
          currentPassword: 'Current password',
          newPassword: 'New password',
          confirmPassword: 'Confirm new password',
          enterYourNewPassword: 'Enter your new password',
          enterYourCurrentPassword: 'Enter your current password',
          button: 'Update password',
          update: 'Update password',
          cancel: 'Cancel',
          passwordRequirements: 'Password Requirements',
          requirement: {
            length: 'At least 12 characters',
            uppercase: 'At least one uppercase letter',
            lowercase: 'At least one lowercase letter',
            special: 'At least 1 special character (^$*.[ ] { } ( ) ? -"!@#%&/, ><:;|_`~+=)',
          },
        },
        deleteAccount: {
          title: 'Delete account',
          description: 'Are you sure you want to delete your account?',
          warning:
            'This action will permanently remove all your data and revoke your access to the platform.',
          irreversible: 'This cannot be reversed.',
          button: 'Delete my account',
          success: 'Admin access revoked successfully. You will be logged out shortly.',
          error: 'Failed to delete account. Please try again.',
          modal: {
            title: 'Delete my account',
            confirmation: 'Sure you want to continue? Kindly confirm again.',
            irreversibleWarning: 'This action cannot be reversed.',
            cancel: 'Cancel',
            delete: 'Confirm delete account',
          },
        },
        validation: {
          currentPassword: {
            required: 'Current password is required',
          },
          newPassword: {
            required: 'New password is required',
            minLength: 'Password must be at least 12 characters',
            number: 'Password must contain at least one number',
            lowercase: 'Password must contain at least one lowercase letter',
            uppercase: 'Password must contain at least one uppercase letter',
            special: 'Password must contain at least one special character',
          },
          confirmPassword: {
            required: 'Confirm password is required',
            match: 'Passwords must match',
          },
        },
      },
      toasterMessage: 'Information updated successfully!',
      toasterMessageError: 'Error occurred while updating information!',
      numberOfSeats: 'Number of Seats',
      outOf: 'out of',
      deleteMyProfile: 'Delete My Profile',
      deleteInfo:
        'You will receive an email to confirm your decision. This will not end your subscription or payments and you will continue to be charged. You can cancel your subscription, or switch payment methods to keep the team active.',
      deleteWarning: 'This can’t be reversed.',
      deleteConfirmation: 'Delete My Profile',
      securityInformation: 'Security Information',
      securityEmail: 'Email:',
      securityPassword: 'Password:',
      requestMore: 'Request more',
      appsInUse: 'Apps in Use',
      domains: 'Domains',
      webDomains: 'Web Domains',
      addressStreet: 'Street',
      addressNumber: 'Number',
      addressCity: 'City',
      addressState: 'State / Province',
      addressZipCode: 'Zip Code/ Postal Code',
      addressCountry: 'Country',
      fullname: 'Full name',
      preferred: 'Preferred',
      personalInfo: 'Personal Information',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      undefined: 'Rather Not Say',
      verified: 'Verified',
      unverified: 'Unverified',
      addSecondaryEmail: 'Add secondary Email accounts',
      profilePhoto: 'Profile Photo',
      uploadPhoto: 'Upload your photo here',
      securityActions: 'Security Actions',
      twoMFAQuestion: 'Do you use 2 factor authentication on all your accounts?',
      twoMFADescription:
        'This helps determine if you are elevating your online protection and security.',
      passwordManagerQuestion: 'Do you use any password manager?',
      passwordManagerDescription:
        'This helps to determine if you are using best practices in storing your passwords in a digital vault that provides strong encryption protection from cyber criminals.',
      cyberResponsePlanQuestion: 'Do you have a Personal Cyber Incident Response Plan?',
      cyberResponsePlanDescription:
        'This helps determine if you can quickly and effectively respond to a cyber hack or breach.',
      cyberSecurityInsuranceQuestion: 'Do you have Cyber Security Insurance?',
      cyberSecurityInsuranceDescription:
        'This helps determine if you can benefit from additional protection and support in the event of a cyber incident or attack.',
      goToMarketplace: 'Go to Marketplace',
      downloadTemplate: 'Download Template',
      saveChanges: 'Save Changes',
      billingAddressChanged: 'Billing address changed',
      changeBillingEmail: 'Change Billing Email',
      billingActions: 'Billing Actions',
      billingEmailsAreSentTo: 'Billing emails are sent to:',
      changeEmail: 'Change Email',
      billingDetails: 'Billing Details',
      remainingSeats: 'Remaining Seats: ',
      addMore: 'Add More',
      cancelSubscription: 'Cancel Subscription',
      cancelSubscriptionInfo:
        'Cancelling your subscription will halt all access for you and your employees to the Protexxa platform. Contact the Protexxa Team to proceed.',
      domainRemoved: 'Domain removed with success',
      domainAdded: 'Domain added with success',
      maxDomains: 'Maximum of 4 domains allowed',
      notValidDomain: 'Empty or not a valid domain',
      publicDomainNotAllowed: 'Public domains are not allowed',
      duplicateDomain: 'This domain is already in use',
      industryChanged: 'Industry changed',
      companyDomains: 'Company Domains',
      companyProfile: 'Company Profile',
      companyName: 'Company Name',
      industry: 'Industry',
      uploadedLogo: 'Logo uploaded sucessfully',
      yourLogo: 'Your Logo',
      uploadYourLogoHere: 'Upload your logo here',
      imageFileSize: 'Your image should have a file size of 200kb and a height of 45px',
      validation: {
        fullname: {
          required: 'Full name is required',
        },
        address: {
          street: {
            pattern: 'Please remove special characters',
            required: 'Street is required',
          },
          number: {
            pattern: 'Please remove special characters',
            required: 'Number is required',
          },
          postalCode: {
            pattern: 'Please remove special characters',
            required: 'Zip code is required',
          },
          city: {
            pattern: 'Please remove special characters',
            required: 'City is required',
          },
          country: {
            required: 'Country is required',
          },
          state: {
            pattern: 'Please remove special characters',
            required: 'State / Province is required',
          },
        },
        birthDate: { required: 'Valid Date Of Birth is required' },
        gender: { required: 'Gender is required' },
        useMFA: { required: 'Answer is required' },
        haveResponsePlan: { required: 'Answer is required' },
      },
      batchScan: {
        title: 'Batch Scans',
        download: 'File downloaded successfully!',
        upload: 'File uploaded successfully!',
        button: {
          choose: 'Choose File',
          upload: 'Upload File',
        },
        status: {
          completed: 'Completed',
          inProgress: 'In Progress',
          error: 'Error',
        },
        table: {
          name: 'Name',
          status: 'Status',
          created: 'Created',
          finished: 'Finished',
          download: 'Download',
          empty: 'No data to display',
        },
      },
      accountSettings: {
        title: 'Company information',
        subtitle:
          'Manage your company details and domains to help secure and customize your organization’s experience.',
        saveButton: 'Save changes',
        avatar: {
          title: 'Company logo',
          upload: {
            title: 'Click here to upload your company logo',
            subtitle: 'Your image should have a file size of 200kb and a height of 45px',
          },
        },
        name: {
          title: 'Company name',
        },
        industry: {
          title: 'Industry',
          selectPlaceholder: 'Select industry',
        },
        domains: {
          title: 'Company domains',
          subtitle: 'Add your company domains',
          addButton: 'Add',
          readOnlyMessage: 'To update your company domains, contact',
          contactSupport: 'Protexxa Support',
        },
      },
    },
    companySignUp: {
      toastError: 'Invalid invite link',
      toastDuplicatedAccount: 'Your account has already been registered',
      companyOnBoarding: {
        navBar: {
          firstStep: {
            label: 'Company details',
            description: `Provide some details about your company`,
          },
          secondStep: {
            label: 'Employee details',
            description: 'Provide details about your employees in the company',
          },
          thirdStep: {
            label: 'Review and scan',
            description: `Review your details provided before running your first scan`,
          },
        },
        stepComponents: {
          firstStep: {
            fields: {
              companyName: 'Company Name',
              industry: 'Industry',
              webdomains: 'Web Domains',
              webDomainCaption: 'Enter your valid company domain. Public domains are not allowed.',
              webDomainCaptionWarning: 'Once submitted, domains may not be changed or removed.',
              addAnotherWebDomains: 'Add another domain',
              maximumDomains: 'Maximum of 4 domains allowed',
              domainsReadOnly:
                'Domains are read-only in onboarding. Contact Support to request changes.',
              termsAgreement: 'By clicking “Continue”, you agree with our',
              and: 'and',
              industries: {
                informationTechnology: 'Information Technology',
                healthCare: 'Health Care',
                financials: 'Financials',
                consumerDiscretionary: 'Consumer Discretionary',
                communicationServices: 'Communication Services',
                industrials: 'Industrials',
                consumerStaples: 'Consumer Staples',
                energy: 'Energy',
                utilities: 'Utilities',
                realEstate: 'Real Estate',
                materials: 'Materials',
                other: 'Other',
                nonProfit: 'Non Profit',
              },
              selectIndustry: 'Select your industry',
            },
          },
          secondStep: {
            fields: {
              uploadEmployeeData:
                'Upload your company’s employee data. Use the sample file as a template to structure your data correctly.',
              downloadSampleFile: 'Download sample file',
              uploadData: 'Upload data',
            },
          },
          thirdStep: {
            fields: {
              companyDetails: 'Company details',
              edit: 'Edit',
              companyName: 'Company name',
              industry: 'Industry',
              webDomains: 'Web domains',
              employeeDetails: 'Employee details',
              uploadedFile: 'Uploaded file',
              noFileUploaded: 'No file uploaded',
              preview: 'Preview',
              checkboxText:
                'Only company data will be scanned now. Personal data may be scanned later with consent, and admins will see only anonymized insights.',
              learnMore: 'Learn More',
              previousStep: 'Previous step',
              completeAndScan: 'Complete and Scan',
            },
          },
          previewComponent: {
            fields: {
              filePreviewTitle: 'File preview',
              filePreviewDescription:
                'Preview the first 10 profiles from your uploaded file to review the data structure.',
              tableHeaders: {
                name: 'Name',
                nameDetailed: '(First and Last names)',
                email: 'Email',
                department: 'Department',
                role: 'Role',
              },
            },
          },
          fileUploaded: {
            errors: {
              failedUpload: 'Failed to upload file. Please try again.',
              unsupportedFileType: 'Unsupported file type.',
              seatCountExceeded: 'Invalid seat count.',
              seatCountPopup:
                'The number of users in your file exceeds your licensed seat count. Please review your file and upload again.',
              requiredFile: 'File is required.',
              fileToolLarge: 'File is too large.',
              fileToolLargePopup: 'File is too large. Your file exceeded 5MB.',
              hasNoRows: 'The CSV file is empty and contains no rows.',
              missingHeaders: 'The file is missing required headers: ',
              missingHeadersPopup:
                'The file is missing required headers, please ensure the file is matching the sample template.',
            },
            browseFile: 'Browse file',
            dragDrop: 'or drag and drop it here',
            supportedFormats: 'Only CSV, XLSX supported',
            fileUploadedCompleted: '- 100% uploaded',
            uploading: 'uploading...',
            uploadAnother: 'Upload another',
            previewFile: 'Preview file',
            invalidFormat: 'Invalid file format. Only CSV or XLSX file formats supported.',
            profilesUploaded: '{{rowCount}} profiles have been uploaded',
          },
          stepsSchema: {
            firstStep: {
              title: 'Provide your company details',
              description: 'Set up your company details to get your company ready',
              validation: {
                companyName: {
                  required: 'Company name is required',
                },
                industry: {
                  required: 'Industry is required',
                },
                webDomains: {
                  url: 'Invalid web domain',
                  required: 'Web domain is required',
                  min: 'At least one web domain is required',
                  invalid: 'Invalid web domain',
                  publicDomainNotAllowed:
                    'This is a public domain. Only company domains are allowed.',
                },
              },
              buttons: { next: 'Next: Employee details' },
            },
            secondStep: {
              title: 'Provide your employee details',
              description:
                'Import your employee details to run a quick scan and get more qualitative results',
              buttons: {
                next: 'Next: Review and scan',
                previous: 'Previous step',
              },
            },
            thirdStep: {
              title: 'Review and confirm your details',
              description: 'Review your details to complete sign up and trigger your first scan.',
              validation: {
                employeeFile: {
                  required: 'Employee file is required',
                },
                confirmation: {
                  required: 'You must confirm before proceeding',
                },
              },
            },
          },
        },
        batchLoading: {
          title: 'Your scan is ongoing!',
          warningMessage:
            'This scan may take up to 24 hours. Once complete, your scan result will be available in the dashboard and you’ll be notified via mail.',
          warningMessageShort:
            'This scan may take up to 24 hours. Once complete, your scan result will be available in the dashboard and you’ll be notified via mail.',
          button: 'Go to dashboard',
        },
      },
    },
    companyInvalidInvite: {
      invalidInviteTitle: 'Invalid Invitation Link',
      invalidInviteOutdated:
        'The invitation link you accessed may be outdated, incorrect, or no longer available.',
      invalidInviteDoubleCheck:
        'Please double-check the URL or try again later. If you believe this is an error, please contact our support team for assistance.',
      invalidInviteThankYou: 'Thank you for your understanding.',
    },
    companyUsers: {
      unassigned: 'Unassigned',
      noRole: 'No role',
      admins: 'List of Members',
      addAdmin: 'Add admin',
      deleteUser: 'Delete User',
      accountCreated: 'Account Created',
      deleteInfo: 'Are you sure do you want to delete your account?',
      delete: 'Delete',
      name: 'Name',
      email: 'E-mail',
      editUser: 'Edit User',
      status: 'Status',
      showing: 'Showing',
      invited: 'Invited',
      removeSelected: 'Remove Selected',
      searchPlaceholder: 'Search by email',
      searchNewUser: 'search new user',
      sortNameAZ: 'Name [A-Z]',
      sortNameZA: 'Name [Z-A]',
      sortEmailAZ: 'Email [A-Z]',
      sortEmailZA: 'Email [Z-A]',
      scanCompleted: 'Scan Completed',
      scanIncomplete: 'Scan Incomplete',
      sortBy: 'Sort by:',
      subtitleAddAdminModal: 'Enter a valid email address to receive the invitation',
      editUserModal: {
        title: 'Edit User',
        resendInvite: 'Resend Invite',
        user: 'User',
        admin: 'Admin',
        name: 'Name',
        role: 'Role',
        validation: {
          email: 'Email is required',
        },
      },
      listofMembers: 'List of Members',
      subtitle: {
        left: 'out of',
        right: 'seats are occupied',
      },
      statusRounded: {
        registered: 'Registered',
        pending: 'Pending',
        completedProfile: 'Completed Profile',
      },
      deleteUserModal: {
        succesMessage: 'Account deleted!',
      },
      showingSelect: {
        allMembers: 'All Members',
        admins: 'Admins',
        users: 'Users',
      },
      statusSelect: {
        showingAll: 'Showing all',
        completedProfile: 'Completed Profile',
        registered: 'Registered',
        pending: 'Pending',
      },
      deleteUserTitle: 'Are you sure? ',
      deleteUserMessage:
        'If you proceed, all of this users’  information will be deleted, and they will loose access to the platform. This action cannot be reversed.',
      resendInvites: 'Resend Invites',
      inviteUsers: 'Invite Users',
      succesInviteUsers: 'Invitations Sent Successfully!',
      emptyStates: {
        inviteTable: 'You have no {{pageState}} invites to preview.',
      },
    },
    bulkScans: {
      noScanPerformed: 'No scans yet',
      title: 'View the log of your recent company scans',
      totalActiveUsers: 'Total active users',
      totalActivedUsers: {
        progressBar: '{{percentage}}% of {{totalNumber}} licensed seats',
      },
      recentBulkUploads: 'Recent bulk uploads',
      recentBulkUploadsSubText:
        'Admins can view past uploads and scan results here. Only new users with valid company emails are scanned—others follow their set scan cycle (e.g., monthly, bi-monthly).',
      recentBulkScansSubText:
        'Admins can view past bulk scans (scheduled or manual) and their results here.',
      runScan: 'Run bulk scan',
      upgrade: 'Upgrade',
      table: {
        bulkScanByDate: 'Scans by date',
        domains: 'Domains',
        usersScanned: 'Users scanned',
        type: 'Type',
        status: 'Status',
        downloadResult: 'Download result',
        filename: 'Name',
        uploadedUsers: 'Uploaded users',
        validUsers: 'Valid users',
        validUsersTooltip: 'The number of users within the bulk file with company domain emails.',
        uploadedBy: 'Uploaded by',
        uploaded: 'Uploaded',
        action: 'Action',
        downloadScanResult: 'Download scan result',
        tooltip: {
          title: 'A technical error occurred. Click the button below to try again.',
          button: 'Run bulk scan',
        },
      },
      search: {
        placeholder: 'Enter filename to search',
      },
      runScanModal: {
        title: 'Upload your employee details',
        description:
          'Import your employee details to run a quick scan and get more qualitative results',
        cancel: 'Cancel',
        startBulkScanError: 'Error starting bulk scan. Please try again later.',
        populateBulkScanError: 'Error populating bulk scan data. Please try again later.',
      },
      status: {
        all: 'All',
        pending: 'Pending',
        completed: 'Completed',
        failed: 'Failed',
        scanning: 'In Progress',
      },
      type: {
        by: 'by',
        manual: 'Manual',
        scheduled: 'Scheduled',
        tooltip: {
          parts: [
            { text: 'Manual scans', variant: 'bold' },
            { text: ' are started by an admin, while ', variant: 'regular' },
            { text: 'Scheduled scans', variant: 'bold' },
            { text: " run automatically based on your company's plan.", variant: 'regular' },
          ],
        },
      },
      toast: {
        successDownloadBulkScan: 'Your download has started automatically. Will be complete soon',
        errorDownloadBulkScan: 'Failed to download scan results',
      },
      expandedDetails: {
        tooltipInfo: '',
        fileUploaded: 'File uploaded',
        uploadedUsers: 'Uploaded users',
        validUsers: 'Valid users',
        scanStarted: 'Scan started',
        scanCompleted: 'Scan completed',
        uploadedBy: 'Uploaded by',
        scanTriggered: 'Scan triggered',
      },
      manualBy: 'Manual by',
      recentBulkScans: 'Recent scans',
      nextScheduledScan: 'Next scheduled scan',
      lastBulkScan: 'Last bulk scan',
    },
    home: {
      business: 'For Business',
      coming: 'Coming soon',
      message: 'Hello World!',
      active: 'Activate your greatest cybersecurity asset...',
      people: 'people',
      transformDigital:
        '90% of cyber hacks are caused by human error. Transform your digital protection today.',
      b2bsaas:
        'Protexxa is a B2B SaaS cybersecurity platform that leverages Artificial Intelligence to rapidly',
      identify: 'identify',
      evaluate: 'evaluate',
      predict: 'predict',
      and: 'and',
      resolveCyber: 'resolve cyber issues',
      forEmployees: 'for employees.',
      orService: 'Our Services',
      helpingDigitalSecurity: 'Helping you elevate digital security enterprise-wide',
      defender: 'Protexxa Defender',
      defenderDescription:
        'Take control and reduce cyber vulnerabilities with our AI-powered assessment and remediation solution.',
      consulting: 'Consulting',
      consultingDescription:
        'Strengthen cyber capabilities with strategic consulting, control testing and interactive tabletop exercises.',
      training: 'Training',
      trainingDescription:
        'Accelerate cyber confidence across your organization. Executives are targeted 12x more than employees.',
      getInTouch: 'Get in touch',
      learnMore: 'Learn more',
      vulnerableCompany: 'Do you know how vulnerable your company is to cyber attacks?',
      vulnerableCompanyDescription:
        'Cyber attacks are rapidly increasing. Since the onset of the COVID-19 pandemic cyber crime has quadrupled.',
      penetrated: 'corporate networks can be penetrated',
      human: 'cyber hacks are caused by human error',
      hacked: 'internet users have been hacked or breached',
      malware: 'smartphones or computers have malware',
      small: 'cyber attacks are aimed at small businesses',
      networks: 'cyber attacks on corporate networks since 2021',
      aboutUs: 'What are people saying about us',
      customers: 'A few words from our customers',
      partners: 'Trusted Partners',
      partnerships: 'Partnerships in place to keep you secure and supported',
      testimonials: {
        jane: 'We were shocked to learn that everyone on the team had private information for sale on the dark web. Protexxa helped us tighten up our security big time.',
        steve:
          'My company was hacked and we had 45 minutes to pay the ransom. I didn’t know who to call, so I paid. Now that we are Protexxa customers, we have playbooks and someone to call if it ever happens again… which I hope it won’t!',
        mohamed:
          'The cybersecurity training provided by Protexxa has changed the way we work at our company. Security is now embedded in all processes.',
      },
    },
    contact: {
      reachingOut: 'Thanks for reaching out',
      hereToHelp: `We're here to help, let's talk.`,
    },
    forgotPassword: {
      forgotPassword: 'Forgot Password',
      enterEmail:
        'Please enter the email address associated with your account and we will send a verification code to reset your password.',
      email: 'E-mail',
      sendCode: 'Send code',
      cancel: 'cancel',
      checkEmail: 'Please check your email and try again.',
      verification: 'Verification',
      securityCodePhoneNumber: 'We have sent the security code to the phone number',
      securityCodeEmail: 'We have sent the security code to the email',
      editNumber: 'Edit Phone Number',
      didntReceive: 'Didn’t receive the code?',
      resendCode: 'Resend the code',
      wrongCode: 'Wrong code',
      passwordChanged: 'Password changed succesfully',
      resetPassword: 'Reset Password',
      strongPassword: 'Set a strong password to keep your account secure',
      passwordRequirements: 'Password requirements',
      minimumCharacters: 'Minimum 12 characters',
      oneNumber: 'At least one number',
      oneUppercase: 'At least one uppercase letter',
      validation: {
        newPassword: {
          required: 'Password is required',
          min: 'Password is too short - should be 12 chars minimum.',
          matches:
            'Must Contain at least One Uppercase, One Lowercase, One Number and One Special Character',
        },
        confirmNewPassword: {
          required: 'Confirm password is required',
          oneOf: 'Both passwords need to be the same',
        },
      },
      networkError: 'Network error. Please check your internet connection.',
      somethingWentWrong: 'Something went wrong. Please try again later.',
      modal: {
        title: 'Unconfirmed account',
        subtitle:
          'Your account is not confirmed yet. Please confirm your account by logging in again or contact support for further assistance.',
        button: 'Home Page',
      },
    },
    integration: {
      message: {
        comingSoon:
          'Integrate your employee data seamlessly from your various third-party human resources platforms.',
      },
    },
    settings: {
      toasterMessage: 'Information updated successfully!',
      password: 'Password',
      emailUpdated: 'Emails updated!',
      maxEmails: 'Max emails reached',
      passwordChanged: 'Password Changed!',
      securityInformation: 'Security Information',
      saveChanges: 'Save Changes',
      add: 'Add',
      email: 'E-mail',
      primary: 'Primary',
      secondaryAccounts: 'Add secondary e-mail accounts',
      changePassword: 'Change Password',
      passwordRequirements: 'Password requirements',
      minimumCharacters: 'Minimum 12 characters',
      oneNumber: 'At least one number',
      oneUppercase: 'At least one uppercase letter',
      containsSpecial: 'Contains at least 1 special character',
      currentPassword: 'Current password',
      confirmPassword: 'Confirm new Password',
      deleteProfile: 'Delete my Profile',
      confirmDecision:
        'You will receive an email to confirm your decision. This will not end your subscription or payments and you will continue to be charged. You can cancel your subscription, or switch payment methods to keep the team active.',
      cantReversed: 'This can’t be reversed.',
      accountDeleted: 'Account deleted',
      deleteUser: 'Delete User',
      sureDelete1: 'Are you sure you want to delete your Protexxa account?',
      sureDelete2:
        'This action is irreversible and will permanently erase all your data. You will lose access to our services, including digital security monitoring and incident response plans.',
      sureDelete3:
        'Before proceeding, please contact our Concierge support who can address any concerns or provide assistance with your account.',
      appsInUse: 'Apps in Use',
      domains: 'Domains',
      webDomains: 'Web domains',
      securityActions: 'Security Actions',
      goToMarketplace: 'Go to Marketplace',
      downloadTemplate: 'Download Template',
      TowFactor: 'Do you use 2 factor authentication on all your accounts?',
      towFactorDescription:
        'This helps determine if you are elevating your online protection and security.',
      passwordManager: 'Do you use any password manager?',
      passwordManagerDescription:
        'This helps to determine if you are using best practices in storing your passwords in a digital vault that provides strong encryption protection from cyber criminals.',
      responsePlan: 'Do you have a Personal Cyber Incident Response Plan?',
      responsePlanDescription:
        'This helps determine if you can quickly and effectively respond to a cyber hack or breach.',
      securityInsurance: 'Do you have Cyber Security Insurance?',
      securityInsuranceDescription:
        'This helps determine if you can benefit from additional protection and support in the event of a cyber incident or attack.',
      notVerified: 'Not verified',
      resendVerificationButton: 'Resend verification',
      resendVerification: {
        success: 'Email successfully resent!',
        error: 'Unable to resend verification email. Please try again later.',
      },
      validation: {
        fullname: 'Full name is required',
        address: {
          street: {
            pattern: 'Please remove special characters',
            required: 'Street is required',
          },
          number: {
            pattern: 'Please remove special characters',
            required: 'Number is required',
          },
          postalCode: {
            pattern: 'Please remove special characters',
            required: 'Zip code is required',
          },
          city: {
            pattern: 'Please remove special characters',
            required: 'City is required',
          },
          country: 'Country is required',
          state: {
            pattern: 'Please remove special characters',
            required: 'State / Province is required',
          },
        },
        birthDate: 'Valid Date Of Birth is required',
        gender: 'Gender is required',
        useMFA: 'Answer is required',
        haveResponsePlan: 'Answer is required',
        currentPassword: 'Current password is required',
        newPassword: {
          required: 'New password is required',
          min: 'Password is too short - should be 12 chars minimum.',
          matches:
            'Must Contain at least One Uppercase, One Lowercase, One Number and One Special Character',
        },
        confirmPassword: {
          required: 'Confirm password is required',
          oneOf: 'Both passwords need to be the same',
        },
      },
    },
    dashboard: {
      welcomeBack: 'Welcome back, {{name}}',
      lastUpdatedAt: 'Last updated',
      overviewTitle: 'Overview',
      findingsTitle: 'Findings',
      trainingTitle: 'Training',
      updateEmployees: 'Update employees',
      downloadReport: 'Download report',
      toast: {
        downloadSuccess: 'Report downloaded successfully',
        downloadError: 'Failed to download report',
      },
      users: 'Users',
      password: 'Password',
      address: 'Address',
      emailAddress: 'Email address',
      phone: 'Phone',
      image: 'Image',
      adminOnboardingMessage:
        'Complete your onboarding and run your deep scan to view personalised cyberhealth dashboard',
      youreViewingCompanyDashboard: 'You’re viewing the company dashboard!',
      buildProfile: 'Build my Defender profile',
      instructionNewAdminSwitchAccounts:
        'Click on the profile icon in the top nav to switch between the company dashboard and your personal account.',
      importantAreasDescription:
        'Fixing these issues could have a major impact for your safety online.',
      areasOfStrengthDescription:
        'These items help keep your accounts safe. Keep up the good work.',
      criticalAreasDescription: 'These items could expose you to a cyber attack.',
      dashboard: 'Dashboard',
      companyDashboard: 'Company Dashboard',
      personalReport: 'Personal Report',
      checkAgain:
        'There is still pending data to generate an accurate score at this time. Please check again later.',
      pendingData: 'Pending Data',
      workingOn: `These are the information items we're still working on`,
      workingProvide:
        'We’re working to provide you with the most accurate information, please check again later.',
      pendingItems: 'Pending Items',
      identifyPotential: `We couldn't identify all potential threats at the moment. Please rescan for accurate information and final score.`,
      scanAgain: 'Scan Again',
      protexxaScore: 'Protexxa Score',
      scoreTooltip: 'You can improve your score by implementing the recommended actions!',
      outOf100: 'out of 1000',
      scanInProgress: 'Scan in progress...',
      scanningNotification:
        'This is your initial score. We are running a more thorough scan; expect to see an update shortly.',
      lastScan: 'Last scanned',
      nextScan: 'Next scan',
      remainingScans: 'You have no remaining scans.',
      repetPurchase: 'Repeat purchase',
      poor: 'Poor',
      good: 'Good',
      veryGood: 'Very Good',
      excellent: 'Excellent',
      scoreMeans: 'What the score means?',
      poorDescription:
        '0 - 399: You have poor cyber hygiene and are in the highest risk category for compromise. Immediate focus on reducing your attack surface is required. You can do it!',
      goodDesctipion:
        '400 - 599: You have a reasonable chance of being impacted by a cyber attack. Additional focus on your cyber hygiene is required. A few small changes will have a major  impact for you!',
      veryGoodDesctipion:
        '600 - 799: You have very good online habits and are less likely to fall prey to cyber threats. Consider levelling up your cyber hygiene. You are on the right track, keep going!',
      excellentDesctipion:
        '800 - 1000: You have excellent cyber hygiene or a limited radius of exposure. We encourage your continued focus and diligence, keep up the great work!',
      backtoDashboard: 'Back to Dashboard',
      passwordLeaked: 'Potential Password Leaked',
      changingPassword: 'Having trouble changing your password?',
      learnHow: 'Learn How',
      category: 'Category',
      whatMean: 'What does this mean?',
      warnDescription:
        ' Additional focus on your cyber hygiene is required as your company stands a chance of being impacted by a cyber attack.',
      scoreUpdateInfo: 'Your score will be updated at the end of every scheduled scan.',
      threats: 'Threats',
      yourAttention:
        'Your attention is needed to make sure your personal information remains private because some unusual activity was discovered while examining your web domain.',
      highSensitive:
        'There is a high chance that sensitive or personal information about your domain registration has been leaked.',
      recommendedAction: 'Recommend Action',
      checkRegistration:
        'Check out what’s publicly available about your domain registration or if your domain has been compromised in any way. You may need to contact your provider.',
      leakedInformation: 'Leaked Information',
      haventFixed: 'You haven’t fixed any issues yet.',
      noLonger: 'You no longer have any recently detected password leaks.',
      achangePassword: `Change your password and let us know that you've taken steps to secure your online accounts.`,
      scoreUpdate: 'When you update your information, it will be assessed',
      followingMonthlyScan: 'in your next monthly cybersecurity score evaluation.',
      reviewListLeaks: 'If you wish to review the list of leaks, click the button below.',
      fixLeaks: 'Review Fixed Leaks',
      dateLeak: 'Date of the leak',
      details: 'Details',
      yes: 'Yes',
      no: 'No',
      changeMyPassword: 'change my password',
      showing: 'Showing',
      detectedLeaks: 'Detected Leaks',
      fixedLeaks: 'Fixed Leaks',
      redefinePassword: 'Redefining your password',
      howRedefinePassword:
        "Most apps and websites follow a similar path for password redefinition, so we've compiled a list of pointers to help you find this option in all of your accounts.",
      learMore: 'Learn More',
      listSites:
        'If you are using any of the listed apps or websites, you can also click to view specific tutorials.',
      redefineLinkedin: 'Password Redefinition on Linkedin',
      redefineFacebook: 'Password Redefinition on Facebook',
      redefineMyFitnessPal: 'Password Redefinition on MyFitnessPal',
      redefineCanva: 'Password Redefinition on Canva',
      yourPersonalImageWasFound: 'Your personal image was found in',
      yourNameWasFound: 'Your name was exposed in',
      yourPhoneWasFound: 'Your phone number was exposed in',
      yourAddressWasLeaked: 'Your address was exposed in',
      yourEmailHaveBeenCompromised_0: 'We have identified',
      yourWebDomainsHaveBeenCompromised_0: 'We have identified',
      yourEmailHaveBeenCompromised: 'threats in your confirmed email accounts.',
      yourWebDomainsHaveBeenCompromised: 'threats in your web domains.',
      websites: 'websites',
      leaksFound: 'potential password leaks found for this email account.',
      leak: 'leak',
      leakSmall: 'leak',
      leaksSmall: 'leaks',
      notShowing: 'Not showing',
      fiveYearsAgo: 'from over 5 years ago.',
      showLeaks: 'Show Leaks',
      hideLeaks: 'Hide Leaks',
      company: 'Company',
      personal: 'Personal',
      leakWarning:
        'This list may change over time as we continue to search for your information online.',
      employees: 'Employees',
      low: 'Low',
      medium: 'Medium',
      moderate: 'Moderate',
      high: 'High',
      critical: 'Critical',
      name: 'Name',
      email: 'Email address',
      credential: 'Password',
      additionalInformationAboutThreatLevels:
        'Distribution of users based on the severity of issues detected during scans.',
      companyScanSummary: {
        title: 'Company scan summary',
      },
      dates: {
        yesterday: 'Yesterday',
        justNow: 'Just now',
      },
      employeeDeepScanSummary: {
        title: 'Deep scan summary',
        inviteForDeepScan: {
          title: 'Unlock more insights with users deep scan data',
          description:
            "With insights from your users' deep scans, you can identify vulnerabilities and assess their cyber health compliance.",
          buttons: {
            inviteForDeepScan: 'Invite users for deep scan',
            notifyUsers: 'Notify Users',
          },
        },
        conciergeCTA: {
          title: 'Unlock more insights with users deep scan data',
          description:
            "With aggregated insights from your users' deep scans, you can identify vulnerabilities and assess their cyber health compliance.",
          button: 'Activate Deep Scan module',
          prefillDescription:
            'I am interested in learning more about the Deep Scan module for my company.',
        },
        scanSummary: {
          title: 'Summary',
          description: 'Summary of users deep scans',
          cards: {
            registeredUsers: 'Registered users',
            scannedUsers: 'Active users',
            usersWithExposures: 'Compromised users',
            invitedUsers: 'Invited users',
          },
        },
      },
      highRiskDepartment: {
        departments: 'Departments',
        users: 'Users',
        usersTooltip: 'Number of users with the most severe risk in the department.',
        riskLevels: 'Risk levels',
        onGoing: {
          title: 'Risk level by departments',
          top5Departments: 'Top departments with highest risks',
          scanIsCurrentlyInProgress: 'Scan is currently in progress.',
          yourScanResultsWillBeDisplayed:
            'Your scan results will be displayed here once the scan is complete.',
        },
        noData: {
          thereIsNoDataForDepartments: 'There is no data for departments',
          updateYourEmployeeData:
            'Update your employee data with their departments to unlock insights on this chart ',
          updateEmployeeDataButton: 'Update employee data',
        },
      },
      threatLevelByUsers: {
        title: 'Risk level by users',
        subtitle: 'Distribution of users by security risk level',
        helpTooltip: 'Distribution of users based on the severity of issues detected during scans.',
        viewAll: 'View all',
        scanInProgress: {
          title: 'Scan is currently in progress.',
          description: 'Your scan results will be displayed here once the scan is complete.',
        },
        activeUsers: 'Active users with findings',
      },
      vulnerabilities: {
        onGoing: {
          title: 'Vulnerabilities',
          dashTitle: 'Findings',
          dashSubtitle: 'Issues identified from company scan',
          topPotencialLeaksOrBreanches: 'Top potential leaks or breaches',
          viewAll: 'View all',
          helpTooltip: 'Issues detected across your company domains',
          detectedAcrossCompanyDomains: 'Detected across your company domains',
          credentialLeaks: 'Credential leaks',
          namesExposed: 'Names exposed',
          emailsExposed: 'Emails exposed',
          issuesFound: 'issues found',
        },
      },
    },
    dashboardStrengthArea: {
      title: 'Areas of Strength',
      description: 'These items help keep you and your company safe.',
      noStrengthAreas: 'No strength areas',
      areasIdentified: 'areas identified',
      whyIsThisImportant: 'Why is this important?',
    },
    emailLeaks: {
      unverifiedEmail: {
        title: 'Verify your email to see more details',
        description1: 'We sent an email to ',
        description2:
          ". Just click on the button in that email to complete your sign up. If you don't see it, you may need to check your spam folder.",
        resendEmail: {
          buttonText: 'Resend Email',
          success: 'Email successfully resent!',
          error: 'Unable to resend verification email. Please try again later.',
        },
      },
    },
    marketplace: {
      marketplace: 'Marketplace',
      backtoDashboard: 'Back to Dashboard',
      internetSecuritySolutions: 'Internet Security Solutions',
      passwordManager: 'Password Manager',
      passwordManagerDescription:
        'NordPass password manager generates unique passwords and remembers them for you. You can access your passwords on any device or browser at any time.',
      passwordAction: 'Get it',
      encryptedCloud: 'Encrypted Cloud',
      encryptedCloudDescription:
        'NordLocker is a secure and easy-to-use cloud for your files, ideas, and memories. Encrypted at all times, your data is always within reach.',
      encryptedCloudAction: 'Get it',
      vpn: 'VPN',
      vpnDescription:
        'Renowned for its solid values, streamlined features, and excellent customer support, NordVPN is recognized by influential tech sites and IT security experts.',
      vpnAction: 'Get it',
      cybersecurity: 'Cybersecurity Response Plan',
      cybersecurityDescription:
        'Being prepared for an attack is essential for a quick response. A well-structured base from which to launch the response plan ensures minimal damage to the attacked entity.',
      cybersecurityAction: 'Download Template',
      cyberinsurance: 'Cyber Security Insurance',
      cyberinsuranceDescription:
        'Get comprehensive cyber insurance coverage for your loved ones so you are protected from identity theft, cyber attacks and cyber bullying.',
      cyberinsuranceAction: 'Get it',
      backgroundCheck: 'Background Check',
      backgroundCheckDescription:
        'Background checks are essential for safety, trust, legal compliance, and informed decision-making in personal, professional, and financial interactions.',
      backgroundCheckAction: 'Get it',
      mfa: 'MFA Authenticator',
      mfaDescription:
        'NordPass as an authenticator feature allows NordPass to be used as an authenticator to websites and applications that support multi-factor authentication (MFA)',
      mfaAction: 'Get it',
    },
    message: {
      welcomeToProtexxa: 'Welcome to the Protexxa community!',
      profile1:
        "Find out if you are a victim of any cyber breaches or have security blind spots. But first, let's build your profile.",
      profile2:
        'Rest assured, any information you provide, including the results of your assessment, are treated with the utmost confidentiality and will not be shared with anyone else.',
      buildProfile: 'Build My Profile',
      paymentFailed: 'Payment Failed',
      checkPayment:
        'We’re sorry, but your payment for this product was not successful. Please check your payment information and try again or contact customer support for assistance.',
      contactSupport: 'Contact Support',
      tryAgain: 'Try Again',
      getStarted: 'Get started! Complete your purchase.',
      completePayment: `We're excited to have you on board! To get started and begin assessing your online security, simply complete your purchase by clicking the button below.`,
      toCheckout: 'Go to Checkout',
      AlmostThere: 'Almost there!',
      processPayment:
        'Your payment is being processed and we’re getting everything ready for you. Please wait a moment while we complete your order. Thank you for choosing us.',
      verifyYourEmail: {
        title: 'Please verify your email',
        message1: "You're almost there! We sent an email to ",
        message2:
          'Just click on the button in that email to complete your sign up. If you don’t see it, you may need to check your spam folder.',
        resendEmailButton: 'Resend Email',
        resendEmail: {
          success: 'Email successfully resent!',
          error: 'Unable to resend verification email. Please try again later.',
        },
      },
      verifyingEmail: {
        success: 'Email verification succesful!',
        forbidden: 'The email you tried to verify is not associated with this account.',
        genericError: 'An error occured while veryifing your email. Please try again later.',
      },
      invalidEmailVerificationLink: {
        title: 'Invalid verification link',
        message:
          "The verification link may be incorrect, expired, or your email account is already verified. If it's still not verified, please click below for a new verification link or contact support.",
        contactSupport: 'Contact Support',
        resendEmailButton: 'Resend Verification',
        resendEmail: {
          success: 'Email successfully resent!',
          error: 'Unable to resend verification email. Please try again later.',
        },
      },
    },
    subscription: {
      availableScans: 'Available Scans',
      oneMonth: '1 monthly',
      creditsAccumulate:
        'scan included in your current plan. Purchase more anytime, credits accumulate.',
      scansRemaining: 'scans remaining',
      nextScan: 'Next scan',
      anotherPurchase: 'Scan by making another purchase.',
      repetPurchase: 'Repeat Purchase',
      currentPlan: 'Your Current Plan',
      defenderCommunity: 'Protexxa Defender Community',
      defenderCommunityValue: '49.99',
      updatePayment: 'Update Payment Details',
      billingHistory: 'Billing History',
      date: 'Date',
      amount: 'Amount',
      details: 'Details',
      status: 'Status',
      oneTime: 'Protexxa Defender, one-time scan',
      invoice: 'Invoice Details',
    },
    profile: {
      profile: 'Profile',
      profilePhoto: 'Profile Photo',
      change: 'Change',
      uploadPhoto: 'Upload your photo here',
      personalInformation: 'Personal Information',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      undefined: 'Rather Not Say',
      fullName: 'Full Name',
      primary: 'Primary',
      namePreferred: 'Preferred or formal name',
      address: 'Address',
      country: 'Country',
      street: 'Street',
      number: 'Number',
      city: 'City',
      zip: 'Zip Code/ Postal Code',
      state: 'State / Province',
    },
    footer: {
      message: 'Protecting Business, Protecting Lives.',
    },
    score: {
      gotoDashboard: 'Go to the dashboard',
      firstScan: 'Running your first scan',
      collectData: 'Collect your data',
      noScoreMessage: 'There is no score to display for now',
      scoreMessageF:
        'Your organization has poor cyber hygiene, and you are in the highest risk category for compromise. Immediate focus on reducing the attack surface is required. ',
      scoreMessageE:
        'Your organization has a reasonable chance of being impacted by a cyber attack. Additional focus on your cyber hygiene is required. A few small changes will have a major impact for your company.',
      scoreMessageD:
        'Your organization has very good online habits and are less likely to fall prey to cyber threats. Consider levelling up your cyber training to strengthen enterprise protection.',
      scoreMessageC:
        'Your organization has very good online habits and are less likely to fall prey to cyber threats. Consider levelling up your cyber training to strengthen enterprise protection.',
      scoreMessageB:
        'Your organization has excellent cyber hygiene or a limited radius of exposure. We encourage your continued focus and diligence. Always keep cyber protection at the forefront of your operations.',
      scoreMessageA:
        'Your organization has excellent cyber hygiene or a limited radius of exposure. We encourage your continued focus and diligence. Always keep cyber protection at the forefront of your operations.',
    },
    form: {
      informationImportant: 'Why is this information important?',
      webDomains: 'Web Domains',
      noDomain: 'I don’t own a web domain',
      noAvatar: 'Not now, I will upload a picture in my profile at a later time.',
      photoScore:
        'Note: we will not be able to scan for your images at this initial assessment, possibly impacting your cyber score.',
      profilePicture: 'Profile picture',
      camera: 'Camera',
      gallery: 'Gallery',
      uploadPicture: 'Upload a picture',
      takePhoto: 'Take a photo',
      takePicture: ' Take a picture',
      tips: 'Tips',
      photoBlurry: 'Make sure your photo is not blurry',
      goodLighting: 'Take in good lighting and take off your glasses',
      removeSelection: 'Remove Selection',
      selectAll: 'Select All',
      noSocialMedia: 'I do not have any social media account.',
      phoneNumber: 'Phone Number',
      name: 'Name',
      lastName: 'Last Name',
      gender: 'Gender',
      primaryEmail: 'Primary Email',
      primaryName: 'Primary Name',
      additionalEmail: ' Add additional email accounts or go to next',
      additionalEmailNew: 'Add up to 4 secondary email accounts',
      dateBirth: 'Date of birth',
      month: 'Month',
      alternateName: 'Add up to 4 names, preferred or formal',
      address: 'Address',
      country: 'Country',
      street: 'Street',
      number: 'Number',
      city: 'City',
      zip: 'Zip Code/ Postal Code',
      state: 'State / Province',
      otherName: 'Are you known by any other name?',
      otherNameDescription: `Given the range of possibilities, it is better for us to identify you with greater precision if we are aware of a known alias, nickname, or an alternate name you might've used.`,
      dateOfBirth: "What's your date of birth?",
      dateOfBirthDescription:
        'This helps identify you with greater precision and helps you to understand how demographics play a role in cyber crimes.',
      whatAddress: "What's your address?",
      whatAddressDescription:
        'This helps determine if your address has been compromised or exposed inappropriately.',
      genderWhat: `What's your gender?`,
      genderDescription: 'This helps determine the role of gender in cyber crimes.',
      secondaryEmail: 'Do you have any other email accounts?',
      secondaryEmailNew: 'If you have more than one email, add it below',
      secondaryEmailDescription:
        'The more emails you verify, the more information you’ll have about your safety online.',
      dontSecondaryEmail: 'I don’t have other email accounts',
      domain: 'What web domains do you currently own?',
      domainDescription:
        'This helps determine if your websites are compromised or being exploited by cyber criminals.',
      picture: 'Take a selfie or upload a picture',
      pictureDescription:
        'This helps determine if you are being impersonated or if your image is being used without your permission.',
      Auth: 'Do you use multi-factor authentication on all your accounts?',
      authNew: 'Do you have any of the following in place?',
      AuthDescription:
        'Multi-Factor Authentication (MFA) is an extra layer of security used to make sure that people trying to gain access to an online account are who they say they are. First, a user will enter their username and a password. Then, instead of immediately gaining access, they will be required to provide another piece of information.',
      BooleanFormResponsePlan: 'Incident Response Plan',
      BooleanFormCyberInsurance: 'Cybersecurity Insurance',
      BooleanFormPasswordManager: 'Password Manager',
      BooleanFormMFA: 'Multi-Factor Authentication (Such as MFA)',
      BooleanFormDesc:
        'This helps determine if you are elevating your online protection and security, and if you can quickly and effectively respond to a cyber hack or breach.',
      responsePlan: 'Do you have a Personal Cyber Incident Response Plan?',
      responsePlanDescription:
        'This helps determine if you can quickly and effectively respond to a cyber hack or breach.',
      topApps: 'These top 10 apps collect the most data about you. Select all those you use.',
      topAppsDescription:
        'This helps determine the likelihood and degree of risk for compromise based on the number and type of accounts you are using.',
      according: 'According to Clario, 2021',
      password: 'Do you use any password manager?',
      passwordDescription:
        'This helps to determine if you are using best practices in storing your passwords in a digital vault that provides strong encryption protection from cyber criminals.',
      insurance: 'Do you have Cyber Security Insurance?',
      insuranceDescription:
        'This helps determine whether your accounts are secure against cyber attacks and prepared to handle the financial risks of doing business online.',
      dontName: 'I don’t go by any other names',
      TwoFactorAuth: '2 Factor Authentication',
      cybersecurityPlan: 'Cybersecurity Response Plan',
      passwordManager: 'Password Manager',
      cybersecurityInsurance: 'Cybesrsecurity Insurance',
      validation: {
        email: 'Email is required',
        requiredField: 'This field is required.',
        name: 'Name is required',
        relationship: 'Relationship is required',
        dateBirth: 'Valid Date Of Birth is required',
        address: {
          specialChar: 'Please remove special characters',
          city: 'City is required',
          country: 'Country is required',
          zip: 'Zip code is required',
          number: 'Number is required',
          street: 'Street is required',
          state: 'State / Province is required',
        },
        gender: 'Gender is required',
        domain: 'Web domains is required',
        year: 'Year is required',
        month: 'Month is required',
        day: 'Day is required',
      },
      oldStepsValidation: {
        alternativeNames: {
          required: 'Name is required',
        },
        birthDate: {
          required: 'Valid Date Of Birth is required',
        },
        address: {
          street: {
            pattern: 'Please remove special characters',
            required: 'Street is required',
          },
          number: {
            pattern: 'Please remove special characters',
            required: 'Number is required',
          },
          postalCode: {
            pattern: 'Please remove special characters',
            required: 'Zip code is required',
          },
          city: {
            pattern: 'Please remove special characters',
            required: 'City is required',
          },
          country: {
            required: 'Country is required',
          },
          state: {
            pattern: 'Please remove special characters',
            required: 'State / Province is required',
          },
        },
        gender: {
          required: 'Gender is required',
        },
        secondaryEmails: {
          required: 'Email is required',
        },
        webDomains: {
          required: 'Web domains are required',
        },
        useMFA: {
          required: 'Answer is required',
        },
        haveResponsePlan: {
          required: 'Answer is required',
        },
        havePasswordManager: {
          required: 'Answer is required',
        },
        haveCyberSecurityInsurance: {
          required: 'Answer is required',
        },
      },
    },
    userThreats: {
      filter: {
        title: 'Showing:',
        content: {
          all: 'All',
          reported: 'Reported Issues',
          completed: 'Requests Completed',
          userReported: 'User Reported Leaks',
        },
      },
      severity: {
        leak: 'leak',
        exposure: 'exposure',
      },
      userActionModal: {
        title: ['Action Required For ', ' Takedown'],
        description:
          'Almost there! The host website sent you an email with instructions to get your unauthorized photo removed. If the email didn’t arrive or if you’re having trouble with the steps, contact Protexxa support and we’ll be here to help.',
        actions: {
          close: 'Close',
          support: 'Contact Support',
        },
      },
      differenceModal: {
        title: 'The difference between Leakage and Exposure',
        firstParagraph:
          'Those icons bellow are used to represent "data leaked" and "data exposed". It is important to tell apart those two concepts that are similar but there is a subtle difference in their connotations:',
        listItems: {
          leak: {
            title: 'Data Leaked: ',
            description:
              'This typically implies that data has been disclosed or made accessible to unauthorized parties without the consent of the data owner.',
          },
          exposure: {
            title: 'Data Exposed: ',
            description:
              "This generally refers to the state in which data is made visible or accessible to others, intentionally or unintentionally, but it doesn't necessarily imply that the data was accessed or obtained by unauthorized parties.",
          },
        },
        lastParagraph:
          'In essence, "data leaked" often implies a breach or unauthorized disclosure, while "data exposed" can encompass situations where data is made visible or accessible without necessary security measures, regardless of whether unauthorized access occurs.',
      },
      reportExposure: {
        caption: 'Is your information exposed on a website that’s not on this list?',
        button: 'Report Exposure',
        modal: {
          title: 'Report Exposure',
          subtitle:
            "Complete the form below to report any exposures that weren't identified in the scan.",
          exposureType: 'Exposure Type',
          website: 'Website',
          websitePlaceholder: 'Enter URL',
          errorWebsite: 'Please write a URL',
          context: 'Context',
          contextPlaceholder: 'Tell us more about this exposure',
          errorContext: 'Please write a context',
        },
        types: {
          address: 'Address',
          image: 'Image',
          phone: 'Phone',
          name: 'Name',
          email: 'Email',
        },
        validation: {
          type: 'Type is required',
          website: {
            desc: 'Website is required',
            min: 'You need to type a minimum of 8 chars',
            max: 'You went over the maximum number of chars (2000)',
            matches: 'The website is invalid',
          },
          context: {
            desc: 'Context is required',
            min: 'You need to type a minimum of 50 chars',
            max: 'You went over the maximum number of chars (2000)',
          },
        },
      },
      whatCanIDoModal: {
        title: 'What can I do to mitigate the situation and protect myself?',
        firstParagraph:
          'If your data has been leaked, there are several steps you can take to mitigate the situation and protect yourself:',
        listItems: {
          scope: {
            title: 'Assess the Scope: ',
            description:
              'Determine what specific data has been leaked and what potential impact it may have on you. This can include personal information, financial data, or any other sensitive information.',
          },
          notify: {
            title: 'Notify Relevant Parties: ',
            description:
              'If the leak involves a company or organization, report the incident to them immediately. They may have protocols in place for handling data breaches and can take steps to contain the situation.',
          },
          passwords: {
            title: 'Change Passwords: ',
            description:
              'If passwords were included in the leaked data or if you suspect unauthorized access to your accounts, change your passwords immediately. Use strong, unique passwords for each account.',
          },
          financialAccounts: {
            title: 'Monitor Financial Accounts: ',
            description:
              'Keep a close eye on your bank accounts, credit cards, and other financial accounts for any suspicious activity. Report any unauthorized transactions to your financial institution.',
          },
          MFA: {
            title: 'Enable Multi-Factor Authentication: ',
            description:
              'Where possible, enable multi-factor authentication on your accounts for an extra layer of security.',
          },
          credit: {
            title: 'Consider Credit Monitoring: ',
            description:
              'If the leaked data includes sensitive financial information, consider signing up for a credit monitoring service to watch for any unusual activity on your credit report.',
          },
          informed: {
            title: 'Stay Informed: ',
            description:
              'Follow updates from the organization that experienced the data leak for information on their response efforts and any steps you should take.',
          },
          cautious: {
            title: 'Be Cautious of Phishing Attempts: ',
            description:
              "Be vigilant for phishing emails or messages that may attempt to exploit the situation. Avoid clicking on links or providing personal information unless you are certain of the sender's legitimacy.",
          },
          advice: {
            title: 'Seek Legal Advice: ',
            description:
              'Depending on the circumstances and the severity of the data leak, you may want to consult with legal counsel to understand your rights and potential recourse.',
          },
          educate: {
            title: 'Educate Yourself: ',
            description:
              'Take this opportunity to learn more about data privacy and security best practices to better protect yourself in the future.',
          },
        },
        lastParagraph:
          'Remember, acting promptly and taking proactive steps can help minimize the impact of a data leak on your personal information and security.',
      },
      userReports: {
        dateOfLeak: 'Found on',
        notProvided: 'Not Provided',
        details: 'Details',
        exposure: 'exposure',
        description: 'Your have reported these websites',
      },
      fullname: {
        description: 'company users have their name exposed',
        recommendedAction:
          'Verify if your name is online without your consent. You may need some takedown or removal services.',
        strengthTitle: 'Name',
        strengthAreaText: "Your name wasn't exposed in any sites",
        reasonToBeImportant:
          'Criminals can use your personal information to open bank accounts, credit cards, benefits, and official documents in your name.',
        title: 'Name Exposed',
        details: {
          backToDashboard: 'Back to Dashboard',
          title: 'Name Exposed',
          subTitle1: 'Your name was found on ',
          subTitle2P: ' websites',
          subTitle2S: ' website',
          card: {
            dateOfLeak: 'Found on',
            details: 'Details',
            recommendedActionTitle: 'Recommended action',
            recommendedAction:
              'If your name is on this site without your consent, please report it so we can take action to have it removed. If you are ok with this information being live on this site, you can ignore it.',
            newRecommendedAction: {
              exposure: {
                statusCard: {
                  unsuccessful: {
                    statusTag: 'Removal Unsuccessful',
                    description: `The name cannot be removed. See details for common reasons why.`,
                    action: 'Details',
                  },
                  solved: {
                    statusTag: 'Solved',
                    description: `The name has been successfully removed.`,
                  },
                },
              },
            },
            notProvided: 'Not Provided',
          },
          translationAlert: 'Translation in progress.',
        },
      },
      address: {
        description: 'company users have their address exposed',
        recommendedAction:
          'Verify if your address is online without your consent. You may need some takedown or removal services.',
        strengthTitle: 'Address',
        strengthAreaText: 'Your address wasn’t exposed in any sites',
        reasonToBeImportant:
          'Online identity thieves may enter your name and address into a publicly searchable database to see what they can find about your financial life.',
        title: 'Address Exposed',
        details: {
          backToDashboard: 'Back to Dashboard',
          title: 'Address Exposed',
          titleCompromised: 'Address Compromised',
          subTitle1: 'Your address was found on ',
          subTitle2P: ' websites',
          subTitle2S: ' website',
          card: {
            dateOfLeak: 'Found on',
            details: 'Details',
            recommendedActionTitle: 'Recommended action',
            recommendedAction:
              'Verify if your address is online without your consent. You may need some takedown or removal services.',
            newRecommendedAction: {
              leakage: {
                description:
                  'This data leak stems from a known database breach, indicating your personal information may be at risk. Please read below for ways to safeguard yourself and your data online.',
                whatCanIDo: 'What can I do?',
              },
              exposure: {
                description:
                  'If your address is on this site without your consent, please report it so we can take action to have it removed. If you are ok with this information being live on this site, you can ignore it.',
                actions: {
                  report: 'Report',
                  ignore: 'Ignore',
                },
                statusCard: {
                  unsuccessful: {
                    statusTag: 'Removal Unsuccessful',
                    description: `The address cannot be removed. See details for common reasons why.`,
                    action: 'Details',
                  },
                  solved: {
                    statusTag: 'Solved',
                    description: `The address has been successfully removed.`,
                  },
                },
              },
            },
            notProvided: 'Not Provided',
          },
          translationAlert: 'Translation in progress.',
        },
      },
      phoneNumber: {
        description: 'company users have their phone number exposed',
        recommendedAction:
          'Verify if your phone number is online without your consent. You may need some takedown or removal services.',
        strengthTitle: 'Phone Number',
        strengthAreaText: 'Your phone number wasn’t exposed in any sites',
        reasonToBeImportant:
          'Once someone obtains your phone number, they could use social engineering or other techniques to find out more personal information about you.',
        title: 'Phone Number Exposed',
        details: {
          backToDashboard: 'Back to Dashboard',
          title: 'Phone Number Exposed',
          titleCompromised: 'Phone Number Compromised',
          subTitle1: 'Your phone number ',
          subTitle2: ' was found on ',
          subTitle3P: ' websites',
          subTitle3S: ' website',
          card: {
            dateOfLeak: 'Found on',
            details: 'Details',
            oldRecommendedAction:
              'Verify if your phone number is online without your consent. You may need some takedown or removal services.',
            recommendedActionTitle: 'Recommended action',
            recommendedAction: {
              leakage: {
                description:
                  'This data leak stems from a known database breach, indicating your personal information may be at risk. Please read below for ways to safeguard yourself and your data online.',
                whatCanIDo: 'What can I do?',
              },
              exposure: {
                description:
                  'If your phone number is on this site without your consent, please report it so we can take action to have it removed. If you are ok with this information being live on this site, you can ignore it.',
                actions: {
                  report: 'Report',
                  ignore: 'Ignore',
                },
                statusCard: {
                  received: {
                    statusTag: 'Request Received',
                    description: `We've received your request and will be processing it shortly.`,
                    action: 'Cancel',
                  },
                  inProgress: {
                    statusTag: 'In Progress',
                    description: `We've assigned your report to our team. We'll update you on your request status when there's a change.`,
                  },
                  unsuccessful: {
                    statusTag: 'Removal Unsuccessful',
                    description: `The phone number cannot be removed. See details for common reasons why.`,
                    action: 'Details',
                  },
                  solved: {
                    statusTag: 'Solved',
                    description: `The phone number has been successfully removed.`,
                  },
                  userAction: {
                    statusTag: 'Action Required',
                    description: `Click on 'Details' and we will email you the next steps to complete your request.`,
                    action: 'Details',
                  },
                  waitingFeedback: {
                    statusTag: 'In Progress',
                    description: `We've assigned your report to our team. We'll update you on your request status when there's a change.`,
                  },
                },
              },
            },
            notProvided: 'Not Provided',
          },
          translationAlert: 'Translation in progress.',
        },
      },
      email: {
        description: 'company users have a potential password leaked',
        recommendedAction: 'Log into your accounts at risk and change your password immediately.',
        strengthTitle: 'Passwords',
        strengthAreaText: 'None of your confirmed email accounts have been compromised',
        reasonToBeImportant:
          'Passwords are your first line of defense against unauthorized access to your computer and personal information.',
        title: 'Potential Password Leaked',
        footerButton: { title: 'Review Fixed Leaks' },
      },
      webDomains: {
        description: 'company users have a web domain leaked',
        recommendedAction:
          'Verify if your web domains were compromised. You may need to contact your provider to recover it.',
        strengthTitle: 'Web Domains',
        strengthAreaText: 'None of your web domains have been compromised',
        reasonToBeImportant:
          'If your web domains are compromised, you may face pharming attacks, also known as domain hijacking, in which your website traffic is redirected elsewhere in order to steal your sensitive data.',
        title: 'Web Domains Compromised',
        beenCompromised: 'of your web domains might have been compromised',
        leakedInformation: 'Leaked Information',
        exposedInformation: 'Exposed information',
      },
      image: {
        description: 'company users have their image being used online',
        recommendedAction:
          'Check if your image is being used online without your permission. If you have previously reported the issue, we will inform you once it’s been removed.',
        strengthTitle: 'Personal Image',
        strengthAreaText: 'Your personal image wasn’t found in any sites without your consent',
        reasonToBeImportant:
          'In addition to being stolen and used by strangers, many images, particularly those taken with smartphones, have location markers that allow viewers to determine the exact area where they were taken.',
        title: 'Personal Image in Use',
        component: {
          topMessageAlert:
            'This list may change over time as we continue to search for your exposure online.',
          notImageFound: 'We are looking for new images of you right now, please check out later',
          leftCard: {
            title: 'Personal Image in Use',
            subTitle: 'We have found the following images online based on your profile picture.',
            lastScanDate: 'Last scan',
            changePictureButton: 'Change Picture',
            warningText:
              "If you update your profile picture, we'll check for similar images in the following monthly scan.",
          },
          rightCard: {
            firstHalfTitle: 'Your personal image was found in',
            secondHalfTitle: 'websites',
            showing: 'Showing',
            select: {
              unattendedImages: 'Unattended Images',
              reportedImages: 'Reported Images',
              authorizedImages: 'Authorized Images',
            },
            card: {
              pending: 'Request Received',
              pendingMessage: "We've received your request and will be processing it shortly.",
              failed: 'Removal Unsuccessful',
              failedMessage: 'The image cannot be removed. See details for common reasons why.',
              removed: 'Removed',
              removedMessage: 'This image is no longer available on the website.',
              waiting: 'In Progress',
              waitingMessage:
                "We've assigned your report to our team. We'll update you on your request status when there's a change.",
              report: 'No, report',
              remove: 'Yes, mark as safe',
              requestDenied: 'Request Denied',
              requestDeniedMessage:
                'The image cannot be removed. See details for common reasons why.',
              accepted: 'In Progress',
              acceptedMessage:
                "We've assigned your report to our team. We'll update you on your request status when there's a change.",
              userAction: 'Action Required',
              userActionMessage:
                "Click on 'Details' and we will email you the  next steps to complete your image takedown request.",
              waitingFeedback: 'In Progress',
              waitingFeedbackMessage:
                "We've assigned your report to our team. We'll update you on your request status when there's a change.",
              solved: 'Solved',
              solvedMessage: 'This image has been successfully removed.',
              markAsSafe: 'Yes, Authorize',
              youAuthorized: 'Is this page authorized to use your image?',
              thisNotYouMessage: 'Are you not in this picture?',
              reportModal: {
                title: 'What is the issue with this image?',
                firstOption:
                  'The image is being used to impersonate me or misrepresent my identity.',
                secondOption: 'My image is being used for unauthorized purposes.',
                thirdOption: 'The image is defamatory or otherwise harmful to my reputation.',
                reportImageButton: 'Report Image',
                successfullyReported: 'Successfully reported!',
              },
              isNoteMeModal: {
                message:
                  'Confirm this isn’t your personal image and we will remove this finding from your reports. This action cannot be reversed',
                confirmAndRemoveButton: 'Confirm and remove',
              },
              succesUpdate: 'Successfully updated!',
              errorGetImages: 'There was an error getting the images',
              succesDeleted: 'Successfully deleted.',
            },
          },
          modal: {
            address: 'address',
            name: 'name',
            phone: 'phone',
            image: 'image',
            na: 'Details not provided',
            failedTitle: 'Unfortunately, we were unable to remove your ',
            close: 'close',
            delete: 'Delete Report',
            contact: 'Contact Support',
            ableToRemove: 'Were you able to remove it yourself?',
            solved: 'Problem Solved, Delete Report',
            removedTitle: 'Good news! Your image was removed.',
            userActionTitle: 'Action Needed in Reported Image Process',
            userActionBody: 'Please check your email for further instructions.',
            deniedTitle: 'Why was my report denied?',
            deniedSubtitle:
              'After careful consideration, our determination is based on the following explanations:',
            details: 'Details',
            checkTitle: {
              1: 'Consent Given',
              2: 'News and Reporting',
              3: 'User Error or Misidentification',
              4: 'Public Figures or Celebrities',
              5: 'Ownership Dispute',
            },
            checkDesc: {
              1: 'Our investigation suggests that the image might have been used with your permission. If you remember differently, you can share any proof you have with our support team.',
              2: "In some cases, the image was used for legitimate news stories or reporting. If you feel that this usage isn't appropriate, our support team can look into it more.",
              3: "Sometimes there can be mix-ups. Double-check if the reported images are really yours. If there's a mistake, let us know.",
              4: "Being well-known can affect how your images are used, especially in news or commentary. If you're worried about this, get in touch with our support team.",
              5: 'Our investigation showed conflicting claims about who owns the image. To sort this out, we need more evidence. If you have proof of ownership, please share it with our support team.',
            },
          },
        },
        reviewImagesFoundButton: 'Review Images Found',
      },
      useMFA: {
        description: 'You do not use Multi-Factor Authentication',
        recommendedAction:
          'MFA reduces the risks associated with compromised passwords immediately. Log into your other personal accounts and get that extra layer of protection.',
        strengthTitle: 'Multi-Factor Authentication (MFA)',
        strengthAreaText: 'You already use Multi-Factor Authentication. Good job!',
        reasonToBeImportant:
          'MFA reduces the risks associated with compromised passwords immediately. If a password is hacked, guessed, or phished, it is no longer sufficient to grant access: without second factor approval, a password is useless.',
        title: 'Multi-Factor Authentication (MFA)',
        tooltip: {
          part1:
            'Multi-Factor Authentication (MFA) adds extra security by requiring multiple verification steps to access an account or system.',
          part2:
            'MFA reduces the risks of compromised passwords by requiring a second verification step, making a password alone useless without additional approval.',
        },
      },
      haveResponsePlan: {
        description: 'You don’t have a Cybersecurity Response Plan!',
        recommendedActionOld:
          'Download our template and create your Response Plan as soon as possible.',
        recommendedAction:
          'Click the button below to create your own customized Response Plan and improve your cyber security.',
        strengthTitle: 'Cybersecurity Response Plan',
        strengthAreaText: 'You already have a Cybersecurity Response Plan! Good job!',
        reasonToBeImportant:
          'Being prepared for an attack is essential for quickly identifying and responding to one. ',
        title: 'Cybersecurity Response Plan',
        buttonText: 'Create My Cybersecurity Response Plan',
        buttonTextMobile: 'Create My Cyber Response Plan',
        viewResponsePlanButton: 'View Response Plans',
        tooltip: {
          part1:
            'A Cybersecurity Response Plan is a guide for handling and recovering from security threats or attacks quickly.',
          part2:
            'You can benefit from additional protection and support in the event of a cyber incident or attack.',
        },
      },
      top10Apps: {
        description_zero: '',
        description_other: 'You are using {{count}} of the 10 most invasive apps.',
        recommendedAction:
          'Delete unused apps and review app permissions regularly for those you still use to protect your information.',
        strengthTitle: 'Invasive Apps',
        strengthAreaText: "You're not using any of the 10 most invasive apps",
        reasonToBeImportant:
          'There is no way to avoid dangerous apps completely, but you should be cautious of those that feature a lot of ads and require invasive permissions. Always read the permissions and privacy policies before using any apps.',
        title: 'Invasive Apps',
        howTo: 'How to Change Your Privacy Settings',
        tooltip: {
          part1:
            'Invasive apps collect too much personal data or access your device without proper consent.',
          part2:
            "You can't fully avoid risky apps, but watch out for excessive ads, invasive permissions, and review policies first.",
        },
      },
      allSocialMediasInPrivate: {
        description: "You don't have all your social accounts set to private",
        recommendedAction:
          'Open your social media accounts, go to settings and set them to private immediately.',
        strengthTitle: 'Private Social Media',
        strengthAreaText: 'You have all your social accounts set to private',
        reasonToBeImportant:
          'Excessive information sharing on social media can lead to cyberstalking, live location disclosure, social profiling, phishing, identity theft, blackmail, and the disclosure of third-party personal information.',
        title: 'Private Social Media',
      },
      havePasswordManager: {
        description: 'You are not using a Password Manager to protect your accounts',
        recommendedAction:
          'By encrypting your logins so that they can only be accessible when you enter your master password, password managers keep your data secure.',
        strengthTitle: 'Password Manager',
        strengthAreaText: 'You are using a Password Manager to protect your accounts',
        reasonToBeImportant:
          'By encrypting your logins so that they can only be accessible when you enter your master password, password managers keep your data secure.',
        title: 'Password Manager',
        importantText: '',
        tooltip: {
          part1:
            'Password Manager securely stores and manages your passwords, helping you create and access unique passwords easily.',
          part2:
            'By encrypting your logins so that they can only be accessible when you enter your master password, password managers keep your data secure.',
        },
      },
      haveCyberSecurityInsurance: {
        description: 'You don’t have Cyber Security Insurance!',
        recommendedAction:
          'Secure Cyber Security Insurance to protect your assets. Protexxa partner referral coming soon!',
        strengthTitle: 'Cyber Security Insurance',
        strengthAreaText: 'You already have a Cyber Security Insurance! Good job!',
        reasonToBeImportant:
          'This aids in recouping the financial losses brought on by cyber-related occurrences and incidents.',
        title: 'Cyber Security Insurance',
        importantText: '',
      },
      emptyState: {
        phone: {
          all: 'you have no phone leaks to preview.',
          reported: 'you have no phone reports to preview.',
          completed: 'you have no phone exposures that have been fixed.',
          userReported: 'you have no phone reports to preview.',
        },
        name: {
          all: 'you have no name leaks to preview.',
          reported: 'you have no name reports to preview.',
          userReported: 'you have no name reports to preview.',
          completed: 'you have no name exposures that have been fixed.',
        },
        address: {
          all: 'you have no address leaks to preview.',
          reported: 'you have no address reports to preview.',
          userReported: 'you have no address reports to preview.',
          completed: 'you have no address exposures that have been fixed.',
        },
      },
    },
    companyThreats: {
      NAME: {
        title: 'Name',
        chartLabel: 'Name',
        strengthTitle: 'Name',
        recommendedAction:
          'Alert your user community to check their personal report and verify if name is online without their consent. They may need some takedown or removal services.',
        description: 'occurrences were discovered in your company’s user reports',
        strengthAreaText: 'None of your company users had their name leaked',
        reasonToBeImportant:
          'Criminals can use your personal information to open bank accounts, credit cards, benefits, and official documents in your name. They may do this to buy things in your name and charge them to your bank account.',
      },
      ADDRESS: {
        title: 'Address',
        chartLabel: 'Address',
        strengthTitle: 'Address',
        recommendedAction:
          'Alert your user community to check their personal report and verify if their address is online without their consent. They may need some takedown or removal services.',
        description: 'occurrences were discovered in your company’s user reports',
        strengthAreaText: 'None of your company users have their address leaked',
        reasonToBeImportant:
          'Knowing where your address appears online gives you an added layer of visibility. If someone has access to your address, they could use it for social engineering or other techniques to compromise your security.',
      },
      PHONE: {
        title: 'Phone Number',
        chartLabel: 'Phone Number',
        strengthTitle: 'Phone Numbers',
        recommendedAction:
          'Alert your user community to check their personal report and verify if their phone number is online without their consent. They may need some takedown or removal services.',
        description: 'occurrences were discovered in your company’s user reports',
        reasonToBeImportant:
          'Once someone obtains your phone number, they could use social engineering or other techniques to find out more personal information about you.',
        strengthAreaText: 'None of your company users have their phone number leaked',
      },
      EMAIL: {
        title: 'Password',
        chartLabel: 'Password',
        strengthTitle: 'Passwords',
        recommendedAction:
          'Alert your user community to check their personal report,  log into their respective accounts at risk and change their password immediately.',
        description: 'occurrences were discovered in your company’s user reports',
        reasonToBeImportant:
          'Passwords are your first line of defense against unauthorized access to your computer and personal information.',
        strengthAreaText: 'None of your company users have a compromised email account',
      },
      DOMAIN: {
        title: 'Website',
        chartLabel: 'Website',
        strengthTitle: 'Web Domains',
        recommendedAction:
          'Alert your user community to check their personal report and verify if their domain was compromised. They may need to contact their provider.',
        description: 'company users have a web domain compromised',
        reasonToBeImportant:
          'If your web domains are compromised, you may face pharming attacks, also known as domain hijacking, in which your website traffic is redirected elsewhere in order to steal your sensitive data.',
        strengthAreaText: 'None of your company users have a web domain compromised',
      },
      IMAGE: {
        title: 'Personal Image in Use',
        chartLabel: 'Image',
        strengthTitle: 'Personal Image',
        recommendedAction:
          'Alert your user community to check their personal report and verify if their personal image is online without their consent. They may need some takedown or removal services.',
        descriptionOnline: 'company users have their image being used online.',
        descriptionRemoval: 'company users have reported images in the process of removal.',
        reasonToBeImportant:
          'In addition to being stolen and used by strangers, many images, particularly those taken with smartphones, have location markers that allow viewers to determine the exact area where they were taken.',
        strengthAreaText: 'None of your company users have their image being used online',
        modal: {
          potentialThreat: 'Potential Threat',
          potentialThreatText: 'of your company users have their image being used online.',
          remediationActions: 'Remediation Actions',
          remediationActionsTextFirst: 'users have reported',
          remediationActionsTextSecond: 'images in the process of removal.',
          card: {
            pending: 'Pending approval or first contact with the website where the image was found',
            waiting: 'Waiting  for a response from the website where the image was found.',
          },
          recommendedAction: 'Recommended Action:',
          recommendedActionText:
            'Alert users who have not reported any unauthorized uses of their image or marked any findings as safe to promptly check their personal reports and take necessary action.',
        },
      },
      MFA: {
        title: 'Multi-Factor Authentication',
        chartLabel: 'MFA',
        strengthTitle: 'Multi-Factor Authentication',
        recommendedAction:
          'Alert your user community to check their personal report, log into their respective accounts at risk and get that extra layer of protection.',
        description: 'company users do not use Multi-Factor Authentication',
        reasonToBeImportant:
          'MFA reduces the risks associated with compromised passwords immediately. If a password is hacked, guessed, or phished, it is no longer sufficient to grant access: without second factor approval, a password is useless.',
        strengthAreaText: 'All of your company members use Multi-Factor Authentication',
      },
      CYBERSECURITY_PLAN: {
        title: 'Cybersecurity Response Plan',
        chartLabel: 'Response Plan',
        strengthTitle: 'Cybersecurity Response Plan',
        recommendedAction:
          'Alert your user community to check their personal report,  download our template and create their Response Plan as soon as possible.',
        description: 'company users don’t have a Cybersecurity Response Plan',
        reasonToBeImportant:
          'Being prepared for an attack is essential for quickly identifying and responding to one. A well-structured base from which to launch the response plan ensures minimal damage to the attacked entity.',
        strengthAreaText: 'All of your company users have a Cybersecurity Response Plan',
        moda: {
          potentialThreat: 'Potential Threat',
          strengthAreaText: 'of your company users don’t have a Cybersecurity Response Plan.',
          remediationActions: 'Remediation Actions',
          remediationActionsDescription:
            'users have started to run or completed their Response Plan actions.',
          recommendedAction: 'Recommended Action',
          recommendedActionDescription:
            'Alert your user community to check their personal reports, and create their own Response Plan as soon as possible.',
          complete: 'Completed',
          completeDescription:
            'Users have taken all necessary actions to complete their Response Plan.',
          inProgress: 'In Progress',
          inProgressDescription: 'Users are currently running a Response Plan.',
          aborted: 'Aborted',
          abortedDescription: 'User has started to run a Response Plan but decided to abort.',
        },
      },
      TOP_APPS: {
        title: 'Invasive Apps',
        strengthTitle: 'Invasive Apps',
        chartLabel: 'Invasive Apps',
        recommendedAction:
          'Alert your user community to check their personal report, remove apps that they don’t use often and review permissions on other apps.',
        description: 'company members use apps that could put them in danger',
        reasonToBeImportant:
          'There is no way to avoid dangerous apps completely, but you should be cautious of those that feature a lot of ads and require invasive permissions. Always read the permissions and privacy policies before using any apps.',
        strengthAreaText: 'None of your company members use apps that could put them in danger',
      },
      SOCIAL_MEDIA: {
        title: 'Private Social Media',
        chartLabel: 'Private Socials',
        strengthTitle: 'Private Social Media',
        recommendedAction:
          'Alert your user community to check their personal report, go to settings in their social media accounts and set them to private.',
        description: 'company users don’t have all their social accounts set to private',
        reasonToBeImportant:
          'Excessive information sharing on social media can lead to cyberstalking, live location disclosure, social profiling, phishing, identity theft, blackmail, and the disclosure of third-party personal information.',
        strengthAreaText: 'All company users have all their social accounts set to private',
      },
      PASSWORD_MANAGER: {
        title: 'Password Manager',
        chartLabel: 'Password Manager',
        strengthTitle: 'Password Manager',
        recommendedAction:
          'Alert your user community to check their personal report and acquire a Password Manager from the Marketplace page to protect their passwords.',
        description: 'company users do not use a Password Manager',
        reasonToBeImportant:
          'By encrypting your logins so that they can only be accessible when you enter your master password, password managers keep your data secure.',
        strengthAreaText: 'All of your company members use a Password Manager',
      },
      CYBERSECURITY_INSURANCE: {
        title: 'Cyber Security Insurance',
        chartLabel: 'Cybersecurity Insurance',
        strengthTitle: 'Cyber Security Insurance',
        recommendedAction:
          'Alert your user community to check their personal report and acquire Cyber Security insurance if necessary.',
        description: 'of your company members do not have Cyber Security Insurance',
        reasonToBeImportant:
          'You can benefit from additional protection and support in the event of a cyber incident or attack.',
        strengthAreaText: 'All of your company members have Cyber Security Insurance',
      },
    },
    top10apps: {
      facebookDescription:
        'As a social network, it depends on you giving access to all your details so it can recommend friends to you, let people know it’s your birthday, suggest groups for you to join and, most importantly, advertise to you.',
      tinderDescription:
        'Beyond trying to get you coupled up, Tinder also tracks how you use different social media platforms if you link your accounts.',
      instagramDescription:
        'The Facebook-owned app collects 69.23% of all available data, such as your hobbies, height, weight and sexual orientation.',
      tikDescription:
        'TikTok, which has launched many viral sensations, collects 46.15% of available data on you, including your facial recognition, voice data, and image library.',
      grindrDescription:
        'Grindr collects almost as much information as Tinder, with 58.97% stored as you look for love.',
      tescoDescription: 'Tesco collects personal data because it can be used to identify you.',
      myDescription:
        'MyFitnessPal collects information about you in a number of ways. “Personal Data” is any information that can be used to identify you, directly or indirectly, alone or together with other information.',
      uberDescription:
        'Uber says it does not sell customer data, but admits that the data is used to send targeted advertisements and other marketing and non-marketing communications to its users.',
      stravaDescription:
        'Strava is configured to upload all of your activity to the Strava feed. That means that if you do nothing, the app automatically shares your fitness data with the rest of the Strava community. ',
      spotifyDescription:
        'Spotify collects 35.90% of your data, tapping into your social media profiles to understand your interests and hobbies.',
    },
    socialMediaApps: {
      instagram: {
        description:
          'The Facebook-owned app collects 69.23% of all available data, such as your hobbies, height, weight and sexual orientation. Like its parent company, Instagram can use this information for advertising and recommending accounts you should follow.',
        securedMessage:
          'Only your current followers will be able to see your content when you secure it and make your Instagram account private.',
      },
      twitter: {
        description:
          'The Facebook-owned app collects 69.23% of all available data, such as your hobbies, height, weight and sexual orientation. Like its parent company, Instagram can use this information for advertising and recommending accounts you should follow.',
        securedMessage:
          'Only your current followers will be able to read your Tweets when you secure them and make your Twitter account private.',
      },
      tiktok: {
        description:
          'TikTok, which has launched many viral sensations, collects 46.15% of available data on you, including your facial recognition, voice data, and image library.',
        securedMessage:
          'Only your current followers will be able to see your content when you secure it and make your TikTok account private.',
      },
      facebook: {
        description:
          'As a social network, it depends on you giving access to all your details so it can recommend friends to you, let people know it’s your birthday, suggest groups for you to join and, most importantly, advertise to you.',
        securedMessage:
          'Only your current followers will be able to see your content when you secure it and make your TikTok account private.',
      },
    },
    tutorials2FA: {
      enabling2FA: 'Enabling Multi-Factor Authentication (MFA)',
      description2FA:
        'MFA reduces the risks associated with compromised passwords immediately. Log into all of your personal accounts and get that extra layer of protection.',
      tiktok: {
        title: "Enabling TikTok's Multi-Factor Authentication",
        platform: 'Mobile',
        instructions: {
          steps: [
            {
              openTiktok: 'Open your TikTok profile;',
              viewOptions: 'Click on the menu icon on the top right corner to view the options;',
              openSettings: `On the menu, click on “Settings and privacy”;`,
              openSecurityOption:
                'On the Settings and Privacy page, click on the “Security” option.',
            },
            {
              open2step: 'On the Security page, click on 2-step verification;',
              enableAuthenticator:
                'On the 2-step verification page, click to check "phone” and/or ”authenticator";',
              turnOnButton: 'Click on the "Turn on” button.',
            },
            {
              followInstructions: 'Follow the instructions to add the security factors;',
              checkMessage: 'Guarantee that you see the ”on” status and the success message.',
            },
          ],
        },
      },
      facebook: {
        title: 'Enable multi-factor authentication to your Facebook account',
        subtitle: 'What version of Facebook are you using?',
        web: {
          title: "Enabling Facebook's Multi-Factor Authentication",
          platform: 'Website',
          instructions: {
            steps: [
              {
                facebookLogin: 'Log in to your Facebook account account using your web browser;',
                openMenu:
                  'At the top bar, click on your profile picture to open the dropdown menu;',
                openPrivacySettings: 'Click on “Setting & privacy”;',
                openSettings: 'Then click on "Settings” to open the settings page.',
              },
              {
                enterAccountsCenter: `Click on Meta's Accounts Center banner.`,
              },
              {
                selectPassword: `In Meta's Account Center, on the left side panel, select "Password and security";`,
                select2FA:
                  'In the section "Login and recovery” select "Multi-factor authentication.',
              },
              {
                selectAccount: "Select Facebook account (among the list of your Meta's accounts);",
                selectSecurityMethod:
                  'Select one of the options as a security method and follow the instructions to add the chosen method as your second authentication.',
                checkMessage:
                  'Guarantee that you see a ”Two-factor authentication is on” message by the end of the process.',
              },
            ],
          },
        },

        mobile: {
          title: "Enabling Facebook's Multi-Factor Authentication",
          platform: 'Mobile',
          instructions: [
            {
              openApp: 'Open the app and log into your account;',
              clickAvatar:
                'In the menu, at the bottom of the page, click on the icon with your picture;',
              openSettings: 'On the Menu page, click on the "cog” icon to open the settings.',
            },
            {
              enterAccountsCenter: `On the Settings & privacy page, click in the "Meta's Accounts Center” banner.`,
            },
            {
              openPasswordSecurity:
                'On the Accounts Center page, click on “Password and security”;',
              select2FA: 'On the Password and security page, choose "Multi-factor authentication.',
            },
            {
              selectAccount: "Select Facebook account (among the list of your Meta's accounts);",
              selectSecurityMethod:
                'Select one of the options as a security method, click "Next” and follow the instructions to add the chosen method as your second authentication;',
              checkMessage:
                'Guarantee that you see a ”Two-factor authentication is on” message by the end of the process.',
            },
          ],
        },
      },
      uber: {
        title: 'Enable multi-factor authentication to your Uber account.',
        subtitle: 'What version of Uber are you using?',
        web: {
          title: "Enabling Uber's Multi-Factor Authentication",
          platform: 'Website',
          instructions: {
            steps: [
              {
                accountPage: 'Go to your account page;',
                securityTab: 'Click on "security” tab in the left side panel.',
              },
              {
                twoStepsVerfication: `In the Security tab, select ”2-step verification".`,
              },
              {
                getStarted: `Click on "Get Started” and follow the verification process;`,
                clickNext: `Select one of the options as a security method, click "Next” and follow the instructions to add the chosen method as your second authentication;`,
                guarantee: `Guarantee that you see a ”Two-factor authentication is on” message by the end of the process.`,
              },
            ],
          },
        },
        mobile: {
          title: "Enabling Uber's Multi-Factor Authentication",
          platform: 'Mobile',
          instructions: {
            steps: [
              {
                openAccount:
                  'Open your Uber app and tap the "Account" tab located in the bottom right corner of the navigation bar;',
                enterProfile:
                  'Click on your profile picture, located next to your name at the top of the page.',
              },
              {
                enterSecurity: 'In your Uber account, select the tab "Security";',
                select2FA: 'In the Security tab, select ”2-step verification".',
              },
              {
                getStarted: 'Click on "Get Started” and follow the verification process;',
                selectSecurityMethod:
                  'Select one of the options as a security method, click "Next” and follow the instructions to add the chosen method as your second authentication;',
                checkMessage:
                  'Guarantee that you see a ”Two-factor authentication is on” message by the end of the process.',
              },
            ],
          },
        },
      },
      instagram: {
        title: 'Enable multi-factor authentication to your Instagram account',
        subtitle: 'What version of Instagram are you using?',
        web: {
          title: "Enabling Instagram's Multi-Factor Authentication",
          platform: 'Website',
          instructions: {
            steps: [
              {
                instagramLogin: 'Log in to your Instagram account account using your web browser;',
                openMore: 'On the bottom of the sidebar, click on “More” to see the options;',
                openSettings: 'Click on “Settings” to open the Settings Page;',
                openMetaCenter: "On Settings, Click on Meta's Account Center banner.",
              },
              {
                selectSecurity: `In Meta's Account Center, on the left side panel, select "Password and security";`,
                select2FA:
                  'In the section "Login and recovery” select "Multi-factor authentication.',
              },
              {
                selectInstagramAccount:
                  "Select Instagram account (among the list of your Meta's accounts);",
                selectSecurityMethod:
                  'Select one of the options as a security method and follow the instructions to add the chosen method as your second authentication.',
                checkMessage:
                  'Guarantee that you see a ”Two-factor authentication is on” message by the end of the process.',
              },
            ],
          },
        },
        mobile: {
          title: "Enabling Instagram's Multi-Factor Authentication",
          platform: 'Mobile',
          instructions: [
            {
              openInstagram: 'Open your Instagram profile;',
              enterOptions: 'Click on the Menu icon on the top right corner to view the options;',
              enterAccountCenter:
                "Click on “Account Center” to open the Meta's Account Center page.",
            },
            {
              enterPasswordSecurity:
                'On the Accounts Center page, click on “Password and security”;',
              select2FA: 'On the Password and security page, choose "Multi-factor authentication.',
            },
            {
              selectInstagramAccount:
                "Select Instagram account (among the list of your Meta's accounts);",
              selectSecurityMethod:
                'Select one of the options as a security method, click "Next” and follow the instructions to add the chosen method as your second authentication;',
              checkMessage:
                'Guarantee that you see a ”Two-factor authentication is on” message by the end of the process.',
            },
          ],
        },
      },
    },
    changePasswordTutorials: {
      canva: {
        title: 'Resetting your password on Canva',
        subtitle: 'What version of Canva are you using?',
        web: {
          title: 'Resetting your password on Canva',
          platform: 'Website',
          step1: [
            'Go to Canva.com',
            'Click on the Settings icon on the top right corner, next to the “Create a design” button;',
            'On the sidebar menu, select the “Login & security” option.',
          ],
          step2: [
            'Under Login, next to “Password” click on “Update”;',
            'Enter your existing password to confirm it.',
          ],
          step3: [
            'Enter your new password;',
            'Re-enter your new password to confirm it;',
            'Click on “Save”.',
          ],
        },
        mobile: {
          title: 'Resetting your password on Canva',
          platform: 'Mobile App',
          step1: [
            'Log into your account;',
            'On the navigation bar, at the bottom, select the “Menu” option;',
            'Scroll down and click on “Settings”.',
          ],
          step2: [
            'Click on “Login & security”;',
            'Under Login, next to “Password” click on “Update”.',
          ],
          step3: [
            'Enter your existing password and click on “Confirm Password”;',
            'After the confirmation, enter your new password;',
            'Re-type your new password to confirm it;',
            'Click on “Save”.',
          ],
        },
      },
      facebook: {
        title: 'Resetting your password on Facebook',
        subtitle: 'What version of Facebook are you using?',
        web: {
          title: 'Resetting your password on Facebook',
          platform: 'Website',
          step1: [
            'Log into your account;',
            'Click on your profile picture, on the top right corner;',
            'Select the “Settings & Privacy” option.',
          ],
          step2: [
            'Select the "Settings” option on the menu.',
            'On the Settings page, select the "Security and login" option on the sidebar',
          ],
          step3: ['Under "Login", click on "Edit" on the Change Password item'],
          step4: [
            'Enter your current password;',
            'Enter your new password;',
            'Re-enter your new password to confirm it;',
            'Click on  “Save changes.',
          ],
        },
        mobile: {
          title: 'Resetting your password on Facebook',
          platform: 'Mobile App',
          step1: [
            'Log into your account;',
            'Select the last item to the right on the navigation icons;',
            'Click on the “Settings” icon;',
          ],
          step2: ['Under Account, select the “Password and security” option.'],
          step3: [
            'Under Password and Security, look for the “Login” section;',
            'Under Login, click on “Change password”;',
            'Enter your current password;',
            'Enter your new password;',
            'Re-enter your new password to confirm it;',
            'Click on “Update password”.',
          ],
        },
      },
      generic: {
        title: 'Resetting your password on websites and apps',
        web: {
          step1: [
            'Navigate to the <b>Settings Page</b> usign the <b>Menu</b> icon:',
            'The icon is generally made up of three lines stacked on top of each other;',
            'It is most commonly found at the <b>upper right corner</b> of a website`s header, although it may also appear at the <b>bottom bar</b> of mobile apps;',
            'After opening the <b>Settings Page</b>, check for <b>Security</b> or <b>Login</b> options to discover the <b>Password</b> settings and follow the instructions.',
          ],
          step2: [
            'Navigate to the Settings Page using your Profile menu:',
            'In case you haven`t yet submitted a <b>profile image</b>, look for a generic <b>circle with your initials</b> or a <b>silhouette icon</b>;',
            'It is most commonly found at the <b>upper right corner</b> of a website`s header, although it may also appear at the <b>bottom bar</b> of mobile apps;',
            'After you`ve opened the menu, navigate to the <b>Settings Page</b>, check for <b>Security</b> or <b>Login</b> options to discover the <b>Password</b> options and follow the instructions.',
          ],
        },
      },
      linkedin: {
        title: 'Resetting your password on LinkedIn',
        subtitle: 'What version of LinkedIn are you using?',
        web: {
          title: 'Resetting your password on LinkedIn',
          platform: 'Website',
          step1: [
            'Log into your account;',
            'Click on your profile picture, on the top right corner;',
            'Select the “Settings & Privacy” option.',
          ],
          step2: [
            'Select the “Sign in & security option on the sidebar;',
            'Under “Account access”, click on “Change password”.',
          ],
          step3: [
            'Enter your current passoword;',
            'Enter your new password. LinkedIn offers tips on how to choose a strong one;',
            'Make sure you check the “Require all devices to sign in” box. This will help keep your account safe on every device you might be logged in;',
            'Click on  “Save password”.',
          ],
        },
        mobile: {
          title: 'Resetting your password on LinkedIn',
          platform: 'Mobile App',
          step1: [
            'Log into your account;',
            'Click on your profile picture, on the top left corner;',
            'Select the “Settings” option at the botton of the menu.',
          ],
          step2: [
            'Select the “Sign in & security option;',
            'Under “Account access”, click on “Change password”.',
          ],
          step3: [
            'Enter your current passoword;',
            'Enter your new password. LinkedIn offers tips on how to choose a strong one;',
            'Make sure you check the “Require all devices to sign in” box. This will help keep your account safe on every device you might be logged in;',
            'Click on  “Save password”.',
          ],
        },
      },
      myfitnesspal: {
        title: 'Resetting your password on MyFitnessPal',
        subtitle: 'What version of MyFitnessPal are you using?',
        web: {
          title: 'Resetting your password on MyFitnessPal',
          platform: 'Website',
          step1: [
            'Log into your account;',
            'Under “My Home”, click on “Settings”. It’s the last item to the right on the menu.',
          ],
          step2: [
            'Under Account Settings, select the “Change Password option;',
            'Enter your current password;',
            'Enter your new password;',
            'Re-enter your new password to confirm it;',
            'Click on “Save changes”.',
          ],
        },
        mobile: {
          title: 'Resetting your password on MyFitnessPal',
          platform: 'Mobile App',
          step1: [
            'Log into your account;',
            'Click on your profile picture on the top left corner;',
            'Click on the Settings icon, on the top right corner.',
          ],
          step2: [
            'Under My Account, click on “Change Password”;',
            'Enter your new password;',
            'Re-type your new password to confirm it;',
            'Click on “Change Password”.',
          ],
        },
      },
    },
    setAccountPrivateTutorials: {
      facebookCompromised: {
        title: 'Privacy Settings on Facebook',
        subtitle: 'What version of Facebook are you using?',
        web: {
          title: 'Privacy Settings on Facebook',
          platform: 'Website',
          step1: [
            'Log into your account and click on your profile picture, on the top right corner.',
            'Select the “Settings & Privacy” option;',
            'Click on “Settings” to open the Settings Page.',
          ],
          step2: [
            'On the Settings page, navigate to “Audience and visibility” section on the side bar to see the privacy settings you can adjust.',
            'Tap any of the options within this section to adjust ‘who can see your posts’, ‘how people can find and contact you’, and ‘who can send you friend requests’.',
          ],
          step3: [
            'Tap on “How people can find and contact you” to view settings and follow the prompt. Please review this option carefully.',
          ],
          step4: [
            'Tap on “Profile and tagging” to view settings and follow the prompt. Please review this option carefully.',
            'Make sure you’re not oversharing your profile information.',
          ],
          step5: [
            'Tap on “Posts” to view settings and follow the prompt. Please review this option carefully.',
          ],
          step6: [
            'On the sidebar, scroll to find the “Tools and resources” section and click on “Privacy Checkup”',
            'Use the “Privacy Checkup” tool to ensure your settings are up-to-date.',
            'For the most up-to-date information and detailed steps on managing your privacy settings, please visit the Facebook Help Centre',
          ],
        },
        mobile: {
          title: 'Privacy Settings on Facebook',
          platform: 'Mobile App',
          step1: [
            'Log into your account and tap the menu icon to view your Menu page.',
            'Tap the “Settings” icon to go to the Settings page.',
          ],
          step2: [
            'On the Settings & privacy page, navigate to “Audience and visibility” section to see the privacy setting you can adjust.',
            'Tap any of the options within this section to adjust ‘who can see your posts’, ‘how people can find and contact you’, and ‘who can send you friend requests’.',
          ],
          step3: [
            'Tap on “How people can find and contact you” to view settings and follow the prompt. Please review this option carefully.',
          ],
          step4: [
            'Tap on “Profile and tagging” to view settings and follow the prompt. Please review this option carefully.',
            'Make sure you’re not oversharing your profile information.',
          ],
          step5: [
            'Tap on “Posts” to view settings and follow the prompt. Please review this option carefully.',
          ],
          step6: [
            'Scroll to find the “Tools and resources” section and click on “Privacy Checkup”',
            'Use the “Privacy Checkup” tool to ensure your settings are up-to-date.',
            'For the most up-to-date information and detailed steps on managing your privacy settings, please visit the Facebook Help Centre',
          ],
        },
      },
      facebookWarning: {
        title: 'Privacy Setting on Facebook',
        subtitle: 'What version of Facebook are you using?',
        web: {
          title: 'Privacy Setting on Facebook',
          platform: 'Website',
          step1: [
            'Make sure your information is available only to the people you trust:',
            'Log into your account and click on your profile picture, on the top right corner;',
            'Select the “Settings & Privacy” option;',
            'Click on “Privacy Checkup” to access the privacy shortcuts provided by Facebook.',
          ],
          step2: [
            'Select the first card titled "Who can see what you share" to examine the privacy settings for your shared posts and personal information.',
          ],
          step3: [
            'The first step is to decide who can see your profile information;',
            'Change whatever settings you see fit by clicking on the grey squares to the right:',
            'For your contact details, we recommend selecting "Only me”;',
            'Other personal information should be restricted to "Friends" only;',
            'By clicking on "Custom", you can also establish a list of friends who can view this information.',
          ],
          step4: [
            'In the following step, you may decide who can see your posts and stories;',
            'Change whatever settings you see fit by clicking on the grey squares to the right:',
            'We highly recommend that your future posts and stories be restricted to “Friends” only;',
            'You may also choose to hide your posts from a few friends by selecting "Friends except..." or "Specific friends" who will be able to view what you publish;',
            'Click "Limit" to protect your previous posts. This implies that only your Friends will be able to view anything you\'ve already shared.',
          ],
          step5: [
            "If you followed the steps in this tutorial, your privacy settings will have already improved significantly, so you're off to a good start!",
            'Feel free to review the other cards in the Privacy Checkup to discover what more Facebook has to offer to secure your privacy.',
          ],
        },
        mobile: {
          title: 'Privacy Setting on Facebook',
          platform: 'Mobile App',
          step1: [
            'Open your Instagram profile;',
            'Log into your account and select the last item to the right on the navigation icons;',
            'Click on the “Settings” icon;',
          ],
          step2: ['Under “Account, select the card titled “Privacy Checkup”.'],
          step3: [
            'Select the first card titled "Who can see what you share" to examine the privacy settings for your shared posts and personal information.',
          ],
          step4: [
            'The first step is to decide who can see your profile information;',
            'Change whatever settings you see fit by clicking on the grey squares to the right:',
            'For your contact details, we recommend selecting "Only me”;',
            'Other personal information should be restricted to "Friends" only;',
            'By clicking on "Custom," you can also establish a list of friends who can view this information.',
          ],
          step5: [
            'In the following step, you may decide who can see your posts and stories;',
            'Change whatever settings you see fit by clicking on the grey squares to the right:',
            'We highly recommend that your future posts and stories be restricted to “Friends” only;',
            'You may also choose to hide your posts from a few friends by selecting "Friends except..." or "Specific friends" who will be able to view what you publish;',
            'Click "Limit" to protect your previous posts. This implies that only your Friends will be able to view anything you\'ve already shared.',
          ],
          step6: [
            "If you followed the steps in this tutorial, your privacy settings will have already improved significantly, so you're off to a good start!",
            'Feel free to review the other cards in the Privacy Checkup to discover what more Facebook has to offer to secure your privacy.',
          ],
        },
      },
      instagram: {
        title: 'Setting your Instagram account to private',
        subtitle: 'What version of Instagram are you using?',
        web: {
          title: 'Setting your Instagram account to private',
          platform: 'Website',
          step1: [
            'Log in to your Instagram account account using your web browser;',
            'On the bottom of the sidebar, click on “More” to see the options;',
            'Click on “Settings” to open the Settings Page.',
          ],
          step2: [
            'On the Settings Page, click on “Account Privacy” on the left side of the screen to view the Account Privacy page.',
            'On the “Account Privacy”, mark the box to make your account private.',
          ],
          step3: [
            'From the previous point forward your account will already be private, but you may choose to review your followers and remove the users you no longer wish to see your posts and stories.',
            'If you don’t wish to review your followers, click on “Cancel” to finish.',
          ],
        },
        mobile: {
          title: 'Setting your Instagram account to private',
          platform: 'Mobile App',
          step1: [
            'Open your Instagram profile;',
            'Click on the Menu icon on the top right corner to view the options;',
            'Click on “Account Privacy” to open the Account Privacy Page.',
          ],
          step2: [
            'On the Account Privacy Page, click on the switch next to “Private account”. This will trigger a confirmation;',
            'Click on  “Switch to Private” to confirm your choice.',
          ],
          step3: [
            'From the previous point forward your account will already be private, but you may choose to review your followers and remove the users you no longer wish to see your posts and stories.',
            'If you don’t wish to review your followers, click on “Cancel” to finish.',
          ],
        },
      },
      tiktok: {
        title: 'Setting your TikTok account to private',
        subtitle: 'What version of TikTok are you using?',
        web: {
          title: 'Setting your TikTok account to private',
          platform: 'Website',
          step1: [
            'Log in to your TikTok account using your web browser;',
            'Click on your profile picture, located on the top right corner of the header, to view the options;',
            'Click on “Settings” to open the Settings Page;',
            'On the Settings Page, under “Privacy”, make sure the “Private account” switch is on.',
          ],
        },
        mobile: {
          title: 'Setting your TikTok account to private',
          platform: 'Mobile App',
          step1: [
            'Open your TikTok profile;',
            'Click on the menu icon on the top right corner to view the options;',
            'On the menu, click on “Settings and privacy”;',
            'On the Settings and Privacy page, click on the “Privacy” option;',
          ],
          step2: [
            'On the Privacy page, under “Discoverability”, click on the switch next to “Private account” to protect your posts. ',
          ],
        },
      },
      twitter: {
        title: 'Setting your Twitter account to private',
        subtitle: 'What version of Twitter are you using?',
        web: {
          title: 'Setting your Twitter account to private',
          platform: 'Website',
          step1: [
            'Log in to your Twitter account account using your web browser;',
            'On the left side of the screen, click the Notifications tab and then the little gear symbol to the right of it. It will take you to your Settings Page;',
          ],
          step2: [
            'On the Settings Page, choose the “Privacy and Safety” tab. This will provide a list of available settings;',
            'Click on the “Audience and tagging” option to manage what information you allow other users to see;',
          ],
          step3: [
            'Click on the empty box, and a pop-up window will appear requesting confirmation that you wish to make your Twitter account private;',
            'Click “Protect” to confirm.',
          ],
        },
        mobile: {
          title: 'Setting your Twitter account to private',
          platform: 'Mobile App',
          step1: [
            'Open your Twitter App;',
            'Click on your profile picture on the top left corner to open the sidebar menu;',
            'On the sidebar menu, scroll down to view the “Settings & Suppoert option;',
            'Under “Settings & Support”, click on  “Settings and privacy”;',
          ],
          step2: [
            'On the Settings page, click on “Privacy and safety”;',
            'Click on the “Audience and tagging” option to manage what information you allow other users to see;',
          ],
          step3: [
            'On the Audience and tagging page, click on the switch next to “Protect your Tweets” to make your account private.',
          ],
        },
      },
      uber: {
        title: 'Changing your privacy settings on Uber',
        platform: 'Mobile App',
        step1: [
          'Open your Uber app and tap the "Account" tab located in the bottom right corner of the navigation bar;',
          'Scroll down on the Account tab and select "Settings" to access the Settings page.',
        ],
        step2: ['In the App Settings section, tap "Privacy" to see the Privacy Centre.'],
        step3: [
          'Tap any of the items in the Ads and data section: "Offers and Promos from Uber”, ”Ads on Uber Eats”, and ”Ads on Rides". Please review each option carefully.',
          'Turn off the toggles to disable data sharing and collection.',
        ],
      },
      myFitnessPal: {
        title: 'Changing your privacy settings on MyFitnessPal',
        platform: 'Mobile App',
        step1: [
          'Open your MyFitnessPal app and tap the "More" tab in the bottom right corner of the navigation bar;',
          'Scroll down and select "Privacy Center”.',
        ],
        step2: [
          `In the Privacy Center, you can choose "Personalization" to stop receiving location and behavior-based ads. Note that this won't prevent data collection;`,
          `If you attempt to disable data sharing and collection in "Manage Data Consents," you'll be prompted to delete your account;`,
          `To manage in-app privacy settings, tap "Sharing & Privacy Settings”.`,
        ],
        step3: [
          'In the "Sharing and Privacy Settings" page, tap "Diary Sharing" and select Private, Friends, or Locked with a key to control who can access your content;',
          'In "Email Settings," uncheck the first option to prevent others from finding your profile using your email address;',
          'In Facebook Settings, disable the toggle to prevent your Facebook friends from finding your profile or disconnect from Facebook entirely.',
        ],
      },
      strava: {
        title: 'Changing your privacy settings on Strava',
        platform: 'Mobile App',
        step1: [
          'Open your Strava app and tap the gear icon in the top left corner to access Settings;',
          'Under Preferences, select "Privacy Controls”.',
        ],
        step2: [
          'On the Privacy Controls page, under "Where You Appear," adjust settings to allow only Followers, No One, or Only You (recommended) to view your information, activity, and location;',
        ],
        step3: [
          'Scroll down to "Additional Controls" on the same page;',
          'Tap "Map Visibility" and select the last option, "Hide your activity maps," then enable the toggle to keep your location data private;',
          `Tap "Aggregated Data Usage" and uncheck the box to stop contributing your activity data;`,
        ],
        step4: [
          'Tap "Public Photos on Routes" and uncheck the box to prevent sharing your content with strangers;',
          'Finally, tap "Do Not Share My Personal Information" and activate the option to stop sharing your personal information with third parties.',
        ],
      },
      spotify: {
        title: 'Changing your privacy settings on Spotify',
        platform: 'Web App',
        step1: [
          'To access privacy settings, log in to your Spotify account on your web browser;',
          'In the top right corner, click your profile picture and select "Account" from the dropdown menu;',
          'Click "Edit profile," then uncheck the box to stop sharing your registration data for marketing purposes.',
        ],
        step2: [
          'On the sidebar, click "Privacy Settings”;',
          'Disable the toggles to stop receiving tailored ads related to your data or to prevent Spotify from processing your Facebook data.',
        ],
        step3: [
          'On the sidebar, scroll down to the "Apps" option to manage apps with access to your Spotify account;',
          'If there are any listed apps, click "Remove Access" next to each to revoke their access.',
        ],
      },
      tinder: {
        title: 'Changing your privacy settings on Tinder',
        platform: 'Mobile App',
        step1: [
          'Open your Tinder app and tap the Profile icon on the bottom navigation, located on the right corner;',
          'On the Profile tab, tap the gear icon in the top right corner to access settings;',
          'Under Privacy, select "Privacy Preferences”.',
        ],
        step2: [
          'On the Privacy Preferences page, tap "Refuse All" to revoke permissions to store and retrieve your data;',
          'Note that some "Strictly Necessary Permissions" cannot be refused.',
        ],
      },
      grinder: {
        title: 'Changing your privacy settings on Grindr',
        platform: 'Mobile App',
        step1: [
          'Open your Grindr app and tap your profile picture in the top left corner;',
          'On the sidebar, select "Settings" to access the settings page;',
          'In the settings page, tap "Consent Preference Center”',
        ],
        step2: [
          'On the Consent Preference Center, tap "Reject All" to revoke permissions to process and share your data;',
          'Be aware that specific items on the list are "Always Active" and cannot be rejected.',
        ],
      },
    },
    app: {
      security: 'Security',
      adminUserManagement: 'Admin user management',
      myAccount: 'My account',
      signOut: 'Sign Out',
      confirmEmail_one:
        'You have {{count}} unverified email address, please confirm it to view your final score.',
      confirmEmail_other:
        'You have {{count}} unverified email addresses, please confirm them to view your final score.',
      resendEmail_one: 'Resend email',
      resendEmail_other: 'Resend emails',
      resendSuccessful: 'Verification email resent successfully',
      resendSuccessful_one: 'Verification email resent successfully',
      resendSuccessful_other: 'Verification emails resent successfully',
      resendFailure: 'Unable to resend verification email. Please try again later.',
      loading: 'Loading',
      accountSettings: 'Account Settings',
      profileInformation: 'Profile Information',
      subscription: 'Subscription',
      individualProfile: 'Individual Profile',
      companyProfile: 'Company Profile',
      account: 'Account',
      billing: 'Billing',
      batchScan: 'Batch Scan',
      companyMembers: 'Company Members',
      adminUsers: 'Admin Users',
      viewResponsePlanButton: 'View Response Plan',
      responsePlanStillInProgress:
        'Your Cybersecurity Response Plan is still in progress. Complete the steps to ensure your safety.',
    },
    partners: {
      nav: {
        ariaLabel: 'Admin sections',
        overview: 'Overview',
        companies: 'Companies',
        partners: 'Partners',
        licenses: 'Licenses',
        incidents: 'Incidents',
        platformAdmins: 'Platform admins',
        partnerAdmins: 'Partner admins',
        settings: 'Settings',
        dashboard: 'Dashboard',
      },
      list: {
        title: 'Partners',
        addPartner: 'Add partner',
        loadFailedTitle: 'Couldn\u2019t load partners',
        loadFailedMessage: 'Something went wrong while fetching partners.',
      },
      empty: {
        title: 'No partners yet',
        message: 'Create your first partner to get started.',
        filteredTitle: 'No partners match your filters',
        filteredMessage: 'Try adjusting your search or filters.',
      },
      filters: {
        searchPlaceholder: 'Search partners\u2026',
        searchLabel: 'Search partners',
        regionLabel: 'Filter by region',
        statusLabel: 'Filter by status',
        allRegions: 'All regions',
        allStatuses: 'All statuses',
      },
      regions: {
        caribbean: 'Caribbean',
        latam: 'LATAM',
        northAmerica: 'North America',
        other: 'Other',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        suspended: 'Suspended',
        pending: 'Pending',
      },
      card: {
        companies: 'Companies',
        licenses: 'Licenses',
        admins: 'Admins',
        viewAria: 'View {{name}}',
        actionsAria: 'Actions for {{name}}',
      },
      actions: {
        viewPartner: 'View partner',
        editDetails: 'Edit details',
        adjustLicenses: 'Adjust licenses',
        suspendPartner: 'Suspend partner',
        clearFilters: 'Clear filters',
        tryAgain: 'Try again',
        cancel: 'Cancel',
        edit: 'Edit',
        comingSoon: '{{action}} \u2014 coming soon',
      },
      form: {
        sectionTitle: 'Partner details',
        backToPartners: 'Back to partners',
        backToPartner: 'Back to partner',
        createTitle: 'Create partner',
        createSubtitle:
          'Onboard a new reseller or channel partner. The primary contact will receive an invitation email to activate their account.',
        createSubmit: 'Create partner',
        editTitle: 'Edit partner',
        editSubtitle: 'Update this partner\u2019s details. Changes apply immediately.',
        editSubmit: 'Save changes',
        saving: 'Saving\u2026',
        name: 'Partner name',
        industry: 'Industry',
        industryPlaceholder: 'Select industry',
        region: 'Region',
        regionPlaceholder: 'Select region',
        seats: 'Number of licenses',
        primaryEmail: 'Primary contact email',
        primaryEmailHint:
          'This person becomes the partner admin and receives the invitation email.',
      },
      validation: {
        nameRequired: 'Partner name is required',
        industryRequired: 'Industry is required',
        industryInvalid: 'Select a valid industry',
        regionRequired: 'Region is required',
        regionInvalid: 'Select a valid region',
        countryRequired: 'Country is required',
        seatsRequired: 'Number of licenses is required',
        seatsWhole: 'Must be a whole number',
        seatsMin: 'Must allocate at least 1 license',
        seatsExceedPool: 'Exceeds {{available}} seats available in the pool',
        emailRequired: 'Primary contact email is required',
        emailInvalid: 'Please enter a valid email address',
        companyNameRequired: 'Company name is required',
        billingEmailRequired: 'Billing / owner email is required',
        seatsExceedPartnerPool: 'Exceeds the {{available}} licenses available to you',
      },
      pool: {
        title: 'License pool',
        allocating: 'Licenses you\u2019re allocating',
        available: 'Available in pool',
        alreadyAllocated: 'Already allocated',
      },
      whatsNext: {
        title: 'What happens next',
        invite: 'The primary contact will receive an invitation email to set up their account.',
        onboard: 'Once accepted, they can onboard companies under their license allocation.',
        licenses: 'Licenses are drawn from the platform pool immediately on creation.',
      },
      stats: {
        companies: 'Companies',
        admins: 'Admins',
        licenseAllocation: 'License allocation',
        allocated: 'Allocated',
        issued: 'Issued',
        active: 'Active',
        available: 'Available',
        issuedOf: '{{issued}} of {{allocated}} issued',
        availableCount: '{{available}} available',
      },
      toast: {
        created: 'Partner created',
        createFailed: 'Couldn’t create the partner',
        saved: 'Changes saved',
        saveFailed: 'Couldn’t save your changes',
        adminInvited: 'Invitation sent',
        adminInviteFailed: 'Couldn’t send the invitation',
        adminRevoked: 'Access revoked',
        adminRevokeFailed: 'Couldn’t revoke access',
        suspended: 'Partner suspended',
        reactivated: 'Partner reactivated',
        statusFailed: 'Couldn’t change the partner’s status',
        companyCreated: 'Company created',
        companyCreateFailed: 'Couldn’t create the company',
        companySaved: 'Company updated',
        companySaveFailed: 'Couldn’t update the company',
        allocationSaved: 'Licenses re-allocated across {{count}} company(ies)',
        allocationFailed: 'Couldn’t save the allocation',
      },
      suspendPartner: {
        suspendAction: 'Suspend partner',
        reactivateAction: 'Reactivate partner',
        suspendTitle: 'Suspend {{name}}?',
        suspendBody:
          '{{name}} will be marked as suspended everywhere it appears. Note this does not revoke partner admin access, and the companies and users under this partner keep working as normal.',
        reactivateTitle: 'Reactivate {{name}}?',
        reactivateBody:
          '{{name}} goes back to active. Nothing about its admins, companies or users changes.',
        cancel: 'Cancel',
        close: 'Close',
      },
      revokeAdmin: {
        adminTitle: 'Remove {{name}}?',
        adminBody:
          'They lose access to {{partner}} immediately — its companies, licenses and settings — and are notified by email. Their Protexxa account stays, and they can be invited again later.',
        confirmAdmin: 'Remove access',
        keepAdmin: 'Keep access',
        inviteTitle: 'Cancel the invitation to {{name}}?',
        inviteBody:
          'Their invitation to help manage {{partner}} will be cancelled, and the link in it will stop working. You can invite them again at any time.',
        confirmInvite: 'Cancel invitation',
        keepInvite: 'Keep invitation',
        close: 'Close',
      },
      inviteAdmin: {
        title: 'Invite partner admin',
        subtitle:
          'Partner admins can manage companies, allocate licenses, and configure settings across the {{name}} environment.',
        seatsRemaining: 'You have {{available}} of {{max}} admin seats remaining.',
        seatsFull: 'All {{max}} admin seats are in use. Remove an admin to invite someone new.',
        emailLabel: 'Work email',
        emailPlaceholder: 'colleague@company.com',
        emailHint:
          'The invitation will be sent to this address. They must use this email to sign in.',
        previewLabel: 'Invitation email preview',
        previewSubject: 'You’ve been invited to manage {{name}} on Protexxa Defender',
        previewGreeting: 'Hello,',
        previewBody:
          '{{inviter}} has invited you to join {{name}} as a Partner Admin on Protexxa Defender. You’ll be able to manage companies, allocate licenses, and configure security services.',
        previewFooter: 'Invitation expires in 7 days · Reply to this email if you have questions.',
        submit: 'Send invitation',
        cancel: 'Cancel',
        close: 'Close invite panel',
      },
      detail: {
        loadFailedTitle: 'Couldn\u2019t load this partner',
        loadFailedMessage: 'Something went wrong while fetching this partner.',
        primaryContact: 'Primary contact',
        contactEmail: 'Contact email',
        industry: 'Industry',
        joined: 'Joined',
        createdBy: 'Created by',
        licenseRenewal: 'License renewal',
        adminsTitle: 'Partner admins',
        you: 'You',
        addAdmin: 'Add admin',
        removeAdmin: 'Remove admin',
        removeAdminAria: 'Remove {{name}}',
        adminName: 'Name',
        adminEmail: 'Email',
        adminStatus: 'Status',
        noAdmins: 'No admins yet.',
        adminsLoadFailed: 'Couldn\u2019t load admins.',
        companiesTitle: 'Companies under {{name}}',
        addCompany: 'Add company',
        companyName: 'Company name',
        companyAdmin: 'Company admin',
        seats: 'Seats',
        created: 'Created',
        noCompanies: 'No companies onboarded yet.',
        companiesLoadFailed: 'Couldn\u2019t load companies.',
      },
      partnerAdmin: {
        overviewTitle: 'Overview',
        loadFailedTitle: 'Couldn’t load your partner',
        loadFailedMessage: 'Something went wrong while fetching your partner details.',
        noPartnerTitle: 'No partner assigned',
        noPartnerMessage:
          'Your account has partner admin access but isn’t linked to a partner. Ask whoever invited you to restore your access.',
        editCompany: 'Edit company',
        maxAdmins: 'Max {{max}} admins per environment.',
        maxAdminsGeneric: 'There is a limit on how many admins an environment can have.',
        backToCompanies: 'Back to companies',
        companyDetails: 'Company details',
        createCompanySubtitle:
          'Set up a new company under {{name}}. The billing contact becomes the company owner and receives an invitation to activate the account.',
        companyNamePlaceholder: 'e.g. Sandals Resorts',
        billingEmail: 'Billing / owner email',
        billingEmailHint:
          'This person becomes the company owner and receives the onboarding invitation.',
        scanFrequency: 'Scan frequency',
        poolAvailableHint: '{{available}} licenses available in your pool.',
        seatsCeilingHint:
          'Up to {{max}} licenses, from your pool plus this company’s current allocation.',
        closeEdit: 'Close edit panel',
        allocateSubtitle: 'Move licenses between your companies. Changes are saved together.',
        licensesAllocated: 'Licenses allocated',
        licensesActive: 'Licenses active',
        seatsForCompany: 'Licenses for {{name}}',
        saveAllocation: 'Save {{count}} change(s)',
        overPool:
          'This allocation is {{count}} licenses over your pool. Lower another company to fund it.',
        allocationTruncated:
          'Showing the first {{shown}} of {{total}} companies. Re-allocating beyond that needs a smaller set at a time.',
        createCompany: 'Create company',
        companies: 'Companies',
        licenses: 'Licenses',
        thisMonth: '+{{count}} this month',
        used: 'Used',
        usedPercent: '{{pct}}% of licenses used',
        manageLicenses: 'Manage licenses',
        recentActivities: 'Recent activities',
        viewAll: 'View all',
        noActivities: 'No recent activity.',
        activitiesFailed: 'Couldn\u2019t load recent activity.',
        searchCompanies: 'Enter company name to search',
        dateCreated: 'Date created',
        newestFirst: 'Newest first',
        oldestFirst: 'Oldest first',
        action: 'Action',
        selectAll: 'Select all companies',
        selectRow: 'Select {{name}}',
        selectedCount: '{{count}} selected',
        viewCompany: 'View company',
        manageSeats: 'Manage seats',
        noCompanies: 'No companies onboarded yet.',
        noCompaniesMatch: 'No companies match your filters.',
        companiesFailed: 'Couldn\u2019t load companies.',
      },
    },
    notFound: {
      pageNotFound: 'Page not found',
      pageError: `We couldn't find a route to this page`,
      toHome: 'Go to Home Page',
    },
    internalError: {
      wrong: `We're sorry, something went wrong.`,
      error: 'Error',
      technicalDifficulties: `We're experiencing technical difficulties and are unable to fulfill your request at this time. Please try again later, or contact our support team for assistance.`,
      thankYou: 'Thank you for your patience.',
      contactSupport: 'Contact Support',
    },
    welcomeBatch: {
      title: 'Welcome to the Defender Platform!',
      subtitle: 'Your journey to enhanced cyber health starts here.',
      step1Title: 'Step 1: Provide Company Details',
      step1Subtitle:
        'To get started, enter your key company information. This helps us set up your dashboard and align with your organization’s unique needs.',
      step2Title: 'Step 2: Add Employee Business Data',
      step2Subtitle:
        'Include relevant employee business details so Protexxa Defender can run scans and identify areas needing attention.',
      footer:
        'This process ensures a comprehensive overview of your organization’s cyber health. Let’s work together to build a stronger, safer digital environment.',
      button: 'Begin onboarding',
    },
    components: {
      copied: 'Copied',
      editPhone: 'Edit your phone number',
      verificationPhone: ' We will send you a new security code to verify this phone number',
      sendCode: 'Send Code',
      add: 'Add',
      scoreUpdate: 'When you update your information, it will be assessed',
      nextScan: 'in your next monthly cybersecurity score evaluation.',
      yourNumber: 'Is this your phone number?',
      confirmNumber:
        'This number will receive a verification code from us following your validation. Do you wish to continue?',
      goBack: 'Go Back',
      continue: 'Continue',
    },
    auth: {
      email: 'Email',
      login: 'Login',
      logout: 'Log out',
      exitOnboarding: 'Exit onboarding?',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      welcomeBack: 'Welcome back',
      haveYouHere: 'It’s a pleasure to have you here again',
      findAndFix: 'Find and fix cyber vulnerabilities in minutes',
      leftPanelDescription:
        'Protexxa’s AI-powered tool checks to see if any of your personal information has been exposed online without your consent (including the dark web)',
      createNewAccount: 'Create a new account',
      creatNewAccountBatch: 'Create your company account',
      getStartedBatch: 'Set up your company details to get your company ready',
      agreeBatch: 'By clicking “Complete signup”, you agree with our',
      getStarted: 'Create a new account to secure your data and stay protected.',
      confirmPhone:
        'You’ll receive an OTP code to verify your phone number after you create an account.',
      passwordRequirements: 'Password requirements',
      minimumCharacters: 'At least 12 characters',
      oneNumber: 'At least one number',
      oneUppercase: 'At least one uppercase letter',
      oneLowercase: 'At least one lowercase letter',
      oneEspecial: 'At least 1 special character',
      agree: 'By clicking "Continue", you agree to our',
      terms: 'Terms of Service',
      policy: 'Privacy Policy',
      and: ' and ',
      createAccount: 'Create Account',
      completeSignup: 'Complete sign up',
      haveAccount: 'Already have an account?',
      confirmPassword: 'Confirm Password',
      phoneNumber: 'Phone Number',
      phoneNumberDescription:
        "You'll receive an OTP code to verify your phone number after you create an account.",
      otpVerificationNote:
        "You'll receive an OTP code to verify your phone number after you create an account.",
      fullName: 'Full name',
      firstName: 'First Name',
      lastName: 'Last Name',
      newPassword: 'New password',
      prepopulateCheckBox:
        'I confirm that the provided information belongs to me and I authorize Protexxa to use it to prepopulate my profile with relevant data from their database.',
      termsAnd: 'and',
      termsWarning: 'Please review and accept the Privacy Policy and Terms of Service to continue.',
      runResponsePlan: 'Run Cybersecurity Response Plan',
      runResponsePlanTitle: 'Do you need help but are unable to sign in?',
      registrationFailed: 'Failed to register. Try again.',
      invalidInvite: 'Invalid or expired invite link.',
      createYourProtexxa: 'Create your Protexxa account',
      inviteSubtitle: 'Set up your account to secure your data and stay protected.',
      placeholders: {
        fullName: 'Insert your full name',
        email: 'Insert your email',
        phoneNumber: 'Country code',
      },
      validation: {
        userEmail: {
          email: 'Email must be valid',
          required: 'Email is required',
        },
        password: 'Password is required',
        fullname: 'Full name is required',
        firstname: 'First name is required',
        lastname: 'Last name is required',
        email: {
          required: 'Email is required',
          email: 'Email is not valid',
        },
        phone: {
          required: 'Phone is required',
          matches: 'Phone is required',
          long: 'Phone number is too long',
          short: 'Phone number is too short',
          empty: 'Phone is required',
          valid: 'Phone is not valid',
        },
        passwordMin: 'Password is too short - should be 12 chars minimum.',
        passwordMatches:
          'Must Contain at least One Uppercase, One Lowercase, One Number and One Special Character',
        confirmPassword: {
          required: 'Confirm password is required',
          oneOf: 'Both passwords need to be the same',
        },
      },
    },

    thankYouPage: {
      title: 'Thanks for your submission!',
      body: "We've received your form and a member of the Protexxa team will be in touch. We appreciate your inquiry and look forward to assisting you soon.",
      button: 'Back to Dashboard',
      buttonConcierge: 'Back to Homepage',
    },
    maintenance: {
      title: 'We’ll be back soon!',
      body: "The page you're looking for is currently under maintenance and will be available as soon as possible. We apologize for any inconveniences.",
      button: 'Contact Support',
    },
    salesforce: {
      firstName: 'First Name',
      lastName: 'Last Name',
      company: 'Company',
      email: 'Email',
      country: 'Country',
      phone: 'Phone',
      industry: 'Industry',
      interest: 'What are you interested in? Select all that apply.',
      description: 'How else can we help?',
      submit: 'Submit',
      errorFirstName: 'First name is required',
      errorLastName: 'Last name is required',
      errorEmail: 'Email is required',
      errorCountry: 'Country is required',
      protexxaTerms:
        'Protexxa values your privacy and will only use your personal information to manage your account and fulfill your requested products and services. Periodically, we may contact you about our offerings and other content that may interest you.',
      userConfirm:
        'By clicking submit below, you consent to allow Protexxa Inc. to store and process the personal information submitted above to provide you the content requested.',
      userAgreement: 'I agree to receive communications from Protexxa Inc.',
      firstNamePlaceholder: 'Insert your first name',
      lastNamePlaceholder: 'Insert your last name',
      companyPlaceholder: "Insert your company's name",
      countryPlaceholder: 'Insert your country',
      emailPlaceholder: 'Insert your e-mail address',
      phonePlaceholder: '+0 (00) 000-0000',
      descriptionPlaceholder: 'Write us a message.',
      interestPlaceholder: 'What are your interests?',
      industryPlaceholder: 'Select industry',
      interests: {
        defenderpricing: 'Defender Pricing',
        educationandtraining: 'Education and Training',
        consulting: 'Consulting',
        generalinformation: 'General Information',
        demonstration: 'Demonstration',
      },
      industries: {
        none: '--None--',
        agriculture: 'Agriculture',
        apparel: 'Apparel',
        banking: 'Banking',
        biotechnology: 'Biotechnology',
        chemicals: 'Chemicals',
        communications: 'Communications',
        construction: 'Construction',
        consulting: 'Consulting',
        education: 'Education',
        electronics: 'Electronics',
        energy: 'Energy',
        engineering: 'Engineering',
        entertainment: 'Entertainment',
        environmental: 'Environmental',
        finance: 'Finance',
        government: 'Government',
        healthcare: 'Healthcare',
        hospitality: 'Hospitality',
        insurance: 'Insurance',
        machinery: 'Machinery',
        manufacturing: 'Manufacturing',
        media: 'Media',
        notforprofit: 'Not For Profit',
        other: 'Other',
        recreation: 'Recreation',
        retail: 'Retail',
        shipping: 'Shipping',
        technology: 'Technology',
        telecommunications: 'Telecommunications',
        transportation: 'Transportation',
        utilities: 'Utilities',
        accounting: 'Accounting',
        airlinesaviation: 'Airlines/Aviation',
        alternativedisputeresolution: 'Alternative Dispute Resolution',
        alternativemedicine: 'Alternative Medicine',
        animation: 'Animation',
        apparelfashion: 'Apparel & Fashion',
        architectureplanning: 'Architecture & Planning',
        artsandcrafts: 'Arts and Crafts',
        automotive: 'Automotive',
        aviationaerospace: 'Aviation & Aerospace',
        broadcastmedia: 'Broadcast Media',
        buildingmaterials: 'Building Materials',
        businesssuppliesandequipment: 'Business Supplies and Equipment',
        capitalmarkets: 'Capital Markets',
        civicsocialorganization: 'Civic & Social Organization',
        civilengineering: 'Civil Engineering',
        commercialrealestate: 'Commercial Real Estate',
        computernetworksecurity: 'Computer & Network Security',
        computergames: 'Computer Games',
        computerhardware: 'Computer Hardware',
        computernetworking: 'Computer Networking',
        computersoftware: 'Computer Software',
        consumerelectronics: 'Consumer Electronics',
        consumergoods: 'Consumer Goods',
        consumerservices: 'Consumer Services',
        cosmetics: 'Cosmetics',
        dairy: 'Dairy',
        defensespace: 'Defense & Space',
        design: 'Design',
        educationmanagement: 'Education Management',
        elearning: 'E-Learning',
        electricalelectronicmanufacturing: 'Electrical/Electronic Manufacturing',
        environmentalservices: 'Environmental Services',
        eventsservices: 'Events Services',
        executiveoffice: 'Executive Office',
        facilitiesservices: 'Facilities Services',
        farming: 'Farming',
        financialservices: 'Financial Services',
        fineart: 'Fine Art',
        fishery: 'Fishery',
        foodbeverages: 'Food & Beverages',
        foodproduction: 'Food Production',
        fundraising: 'Fund-Raising',
        furniture: 'Furniture',
        gamblingcasinos: 'Gambling & Casinos',
        glassceramicsconcrete: 'Glass, Ceramics & Concrete',
        governmentadministration: 'Government Administration',
        governmentrelations: 'Government Relations',
        graphicdesign: 'Graphic Design',
        healthwellnessandfitness: 'Health, Wellness and Fitness',
        highereducation: 'Higher Education',
        hospitalhealthcare: 'Hospital & Health Care',
        humanresources: 'Human Resources',
        importandexport: 'Import and Export',
        individualfamilyservices: 'Individual & Family Services',
        industrialautomation: 'Industrial Automation',
        informationservices: 'Information Services',
        informationtechnologyandservices: 'Information Technology and Services',
        internationalaffairs: 'International Affairs',
        internationaltradeanddevelopment: 'International Trade and Development',
        internet: 'Internet',
        investmentbanking: 'Investment Banking',
        investmentmanagement: 'Investment Management',
        judiciary: 'Judiciary',
        lawenforcement: 'Law Enforcement',
        lawpractice: 'Law Practice',
        legalservices: 'Legal Services',
        legislativeoffice: 'Legislative Office',
        leisuretraveltourism: 'Leisure, Travel & Tourism',
        libraries: 'Libraries',
        logisticsandsupplychain: 'Logistics and Supply Chain',
        luxurygoodsjewelry: 'Luxury Goods & Jewelry',
        managementconsulting: 'Management Consulting',
        maritime: 'Maritime',
        marketresearch: 'Market Research',
        marketingandadvertising: 'Marketing and Advertising',
        mechanicalorindustrialengineering: 'Mechanical or Industrial Engineering',
        mediaproduction: 'Media Production',
        medicaldevices: 'Medical Devices',
        medicalpractice: 'Medical Practice',
        mentalhealthcare: 'Mental Health Care',
        military: 'Military',
        miningmetals: 'Mining & Metals',
        motionpicturesandfilm: 'Motion Pictures and Film',
        museumsandinstitutions: 'Museums and Institutions',
        music: 'Music',
        nanotechnology: 'Nanotechnology',
        newspapers: 'Newspapers',
        nonprofitorganizationmanagement: 'Non-Profit Organization Management',
        oilenergy: 'Oil & Energy',
        onlinemedia: 'Online Media',
        outsourcingoffshoring: 'Outsourcing/Offshoring',
        packagefreightdelivery: 'Package/Freight Delivery',
        packagingandcontainers: 'Packaging and Containers',
        paperforestproducts: 'Paper & Forest Products',
        performingarts: 'Performing Arts',
        pharmaceuticals: 'Pharmaceuticals',
        philanthropy: 'Philanthropy',
        photography: 'Photography',
        plastics: 'Plastics',
        politicalorganization: 'Political Organization',
        primarysecondaryeducation: 'Primary/Secondary Education',
        printing: 'Printing',
        professionaltrainingcoaching: 'Professional Training & Coaching',
        programdevelopment: 'Program Development',
        publicpolicy: 'Public Policy',
        publicrelationsandcommunications: 'Public Relations and Communications',
        publicsafety: 'Public Safety',
        publishing: 'Publishing',
        railroadmanufacture: 'Railroad Manufacture',
        ranching: 'Ranching',
        realestate: 'Real Estate',
        recreationalfacilitiesandservices: 'Recreational Facilities and Services',
        religiousinstitutions: 'Religious Institutions',
        renewablesenvironment: 'Renewables & Environment',
        research: 'Research',
        restaurants: 'Restaurants',
        securityandinvestigations: 'Security and Investigations',
        semiconductors: 'Semiconductors',
        shipbuilding: 'Shipbuilding',
        sportinggoods: 'Sporting Goods',
        sports: 'Sports',
        staffingandrecruiting: 'Staffing and Recruiting',
        supermarkets: 'Supermarkets',
        textiles: 'Textiles',
        thinktanks: 'Think Tanks',
        tobacco: 'Tobacco',
        translationandlocalization: 'Translation and Localization',
        transportationtruckingrailroad: 'Transportation/Trucking/Railroad',
        venturecapitalprivateequity: 'Venture Capital & Private Equity',
        veterinary: 'Veterinary',
        warehousing: 'Warehousing',
        wholesale: 'Wholesale',
        wineandspirits: 'Wine and Spirits',
        wireless: 'Wireless',
        writingandediting: 'Writing and Editing',
      },
    },
    cybersecurityResponsePlan: {
      createResponseIntroduction: {
        introductionTitle: 'Create your Cybersecurity Response Plan',
        introductionBodyTop:
          "We're here to help you prepare for the worst-case scenario: a cybersecurity breach.",
        introductionBodyBottom:
          "By taking a few moments to identify your critical assets, you'll be able to create a customized response plan to help you respond quickly and effectively if an incident occurs.",
        introductionButton: 'Get Started',
        modalTitle: 'Create Your Personal Cybersecurity Response Plan',
        modalBody:
          "Don't wait until it's too late to protect yourself from cyber threats. Identify your critical assets and get a step-by-step guide on how to respond to any incidents.",
        modalButtonConfirm: 'Create My Cybersecurity Response Plan',
        modalButtonCancel: 'Remind Me Later',
      },
      createResponsePlanModal: {
        modalTitle: 'Create Your Personal Cybersecurity Response Plan',
        modalBody:
          "Don't wait until it's too late to protect yourself from cyber threats. Identify your critical assets and get a step-by-step guide on how to respond to any incidents.",
        modalButtonConfirm: 'Create My Cybersecurity Response Plan',
        modalButtonCancel: 'Remind Me Later',
        success: 'Success!',
        error: 'Error trying to communicate with the API!',
      },
      form: {
        criticalContacts: {
          title: 'Critical Contacts',
          description:
            'Prepare for cybersecurity incidents by organizing your key contacts. Provide contact details for family, friends, and professional associates, for added assurance.',
          checkText: 'Not now, I will add my contacts later.',
          helpTitle: 'Why should I add critical contacts?',
          helpText:
            'During a cybersecurity emergency, timely communication and coordination are crucial. By having accurate and readily available contacts, we can ensure swift response actions and minimize the potential impact of an incident.',
        },
        bankComponent: {
          title: 'Critical Contacts',
          description:
            "Prepare yourself by keeping key bank and financial institution contacts accessible. Share the contact information for your banks, ensuring you're ready for any cyber security incidents.",
          checkText: 'Not now, I will add this information later.',
          helpTitle: 'Why should I inform my bank or financial institution?',
          helpText:
            'With this information, in the event of an incident we can help you connect with your respective financial institutions faster and more accurately.',
          saveButton: 'Save Changes',
          updateErrorMessage: 'Error while updating!',
          updateSuccessMessage: 'Updated successfully!',
        },
        steps: 'steps',
        generateResponsePlan: 'Generate Response Plan',
        card: {
          familyTitle: 'Family & Friends',
          familySubtitle:
            'In the event of a cyber breach, we will be able to send SMS notifications and customized emails to your critical contacts.',
          bankTitle: 'Banks & Financial Institutions',
          employmentProfessionalTitle: 'Employment & Professional',
          name: 'Name',
          search: 'Search',
          bankName: 'Name of the bank',
          relationship: 'Relationship',
          placeHolderRelationship: 'e.g. father, spouse, brother',
          placeHolderRelationshipWork: 'e.g. superior, colleague',
          phoneNumber: 'Phone Number',
          addMore: 'Add more',
          cancelButton: 'Cancel',
          addBankButton: 'Add Bank',
          inputLabel: 'Select the banks you currently have accounts with',
          addManually: 'Add manually',
          contactDescription:
            'In the event of a cyber breach, we will be able to send SMS notifications and customized emails to your critical contacts.',
          contact: 'Contact',
          errorGetBanks: 'Error when trying to load banks!',
          validation: {
            name: 'Name is required',
            email: 'This field is required.',
            phone: 'This field is required.',
          },
        },
        validation: {
          email: 'Must be a valid email',
          requiredField: 'This field is required.',
          name: 'Name is required',
          relationship: 'Relationship is required',
        },
        createErrorText: 'Error when trying to create a response plan.',
        createSuccess: 'Success!',
      },
      responsePlanOverview: {
        page: {
          responsePlan: 'Response Plan',
          emergencyContacts: 'Critical Contacts',
          myAssets: 'Banks & Financial Contacts',
          responsePlanAccessCode: 'Response Plan Access Code',
          responsePlanAccessCodeTooltip: {
            left: 'In case of a cyber breach and platform access loss, visit ',
            link: '{{defenderUrl}}/responseplan',
            right: 'and enter this code to access your response plan.',
          },
          listQuestions: {
            notShowing: {
              not: 'Not',
              showing: 'showing',
              ignoredActions: 'ignored actions',
            },
            hideActions: 'Hide Actions',
            showActions: 'Show Actions',
          },
          questions: {
            checks: {
              disconnectImpactedDevices:
                'Disconnect and turn off impacted device(s) from the network if endpoint related. Remove any USB drives.',
              notifyContactList:
                'Notify contact list of key stakeholders about the cyber incident.',
              notifyLocalAuthorities:
                'Report the incident to local authorities and service providers listed below, and keep note of the report number for reference.',
              notifyBanks:
                'If your bank account or credit cards are involved, report it and cancel cards right away to avoid being liable for the losses.',
              callMainCreditAgencies:
                'Call your country’s main credit reporting agencies and put a fraud alert on your credit report.',
              notifyIdentityServices:
                'If your federally issued ID, passport, social security card or passwords have been compromised, contact the services below to report it.',
              notifyCanadianAntiFraudCentre:
                'In case of incidents of scam and fraud, including phishing emails or text messages, contact the services below.',
              reviewAllAccountActivity:
                'Review all online account activity for unauthorized logins and log out of all connected devices.',
              callCompanyWhereIdentityWasUsed:
                'Call the companies where your identity was used. They will tell you what information they need, whether an investigation has been started, and how you can recover from the compromise.',
              enableGoogleAlerts:
                "Enable Google Alerts to stay on top of all the things that are related to your personal information. Once you set it up, you'll get email notifications any time Google finds new results on topics you care about.",
            },
            ignore: 'Ignore',
            restore: 'Restore',
            cards: {
              familyFriends: 'Family & Friends',
              employmentProfessional: 'Employment & Professional',
              contacts: 'Contacts',
              peopleWillBeNotified: 'People will be notified',
              findDetachment: 'Find a RCMP Detachment',
              googleAlerts: 'Learn more about Google Alerts',
            },
          },
        },
        initialModal: {
          title: 'We have generated your Cyber Security Response Plan',
          firstParagraph:
            'Your plan comes with a unique code for use in case of a cyber breach and platform access loss.',
          secondParagraph: {
            left: 'If you encounter such a situation, visit',
            right:
              'and enter the code provided below. Please keep it securely stored offline for added safety.',
          },
          checkBoxText: 'I have safely stored my unique response plan code.',
          seeResponsePlanButton: 'See Response Plan',
        },
        sendNotification: 'Send notification',
        editNotification: 'Edit information',
        textCopied: 'Text copied!',
        cardLevel: {
          title: 'Response Plan Progress',
          abortPlanButton: 'Abort Plan',
          resetPlanButton: 'Reset Plan',
          body: {
            safe: {
              textChart: 'Completed',
              textDecription:
                'Your current level of safety based on the actions you have taken in your response plan.',
            },
            riskbelowfifty: {
              textChart: 'At Risk',
              textDecription:
                'Your current level of safety based on the actions you have taken in your response plan.',
            },
            risk: {
              textChart: 'At Risk',
              textDecription:
                'Your current level of safety based on the actions you have taken in your response plan.',
            },
            disabled: {
              textDecription:
                'Once you run your response plan, we will track the actions you’ve taken and will help you determine how protected you are. You can also print these actions for later.',
            },
          },
        },
        overviewCard: {
          title: 'Your Personalized Cybersecurity Response Plan',
          bodyText:
            'Follow our recommended response plan to help you stay safe after a cyber attack.',
          runResponsePlanButton: 'Run Response Plan',
          downloadButton: 'Download',
        },
        notificationModal: {
          modalTitleEmployment: 'Notify Employment & Professional',
          modalTitleFriends: 'Notify Family & Friends',
          modalBody1:
            'Write a message to send out to your critical contacts and let them know what is happening. Everyone you added to the list will be notified.',
          modalBody2Title: 'Custom message',
          modalBody2Text:
            "Example: \n“Hey everyone, \nMy online accounts have been compromised in a cybersecurity breach. Be cautious of suspicious emails or messages from my accounts. \n\nI'm working to resolve this. Thank you for your understanding and support.”",
          modalButtonSend: 'Send notification',
          modalButtonCancel: 'Cancel',
          successSendNotifications: 'Notifications sent successfully!',
          errorSendNotifications: 'Error sending notifications!',
        },
      },
    },
    comingSoon: {
      title: 'Coming Soon!',
      body: "The page you're searching for is currently being worked on and will be unveiled in the near future. We appreciate your understanding and apologize for any inconvenience this may cause.",
      button: 'Back to Home Page',
      titleNew: 'This feature is currently development.',
      subtitleNew: 'Coming soon',
    },
    responsePlanAccessCode: {
      title: 'Incident Response Code',
      subtitle: 'Verify your information to continue',
      labelAccessCode: 'Enter your unique Response Plan Code',
      labelDateBirth: 'Date of Birth',
      continue: 'Continue',
      errorMessage: 'Failed to get response plan!',
      validation: {
        accessCode: 'Response plan code is required',
        birthDate: 'Valid Date Of Birth is required',
      },
    },
    termsOfService: {
      title: 'Terms & Conditions',
      date: 'August 28th, 2023',
      generalTerms: {
        title: 'General Terms',
        desc: {
          line1:
            'By accessing and placing an order with Protexxa, you confirm that you agree with and are bound by the terms of service in the Terms & Conditions outlined below. These terms apply to the entire website, service, and any emails or communications between you and Protexxa.',
        },
      },
      license: {
        title: 'License',
        desc: {
          line1:
            'Protexxa grants you a revocable, non-exclusive, non-transferable, limited license to download, install and use the app/platform strictly following the terms of this Agreement.',
          line2: `These Terms & Conditions are a contract between you and Protexxa (referred to in these Terms & Conditions as "Protexxa," "us," "we," or "our"), the provider of the Protexxa website and the services accessible from the Protexxa website (which are collectively referred to in these Terms & Conditions as the "Protexxa Service").`,
          line3: `You agree to be bound by these Terms & Conditions. If you disagree with these Terms & Conditions, please do not use the Protexxa Service. In these Terms & Conditions, "you" refers to you as an individual and the entity you represent. If you violate any of these Terms & Conditions, we reserve the right to cancel your account or block access to your account without notice.`,
        },
      },
      keyTerms: {
        title: 'Definitions and Key Terms',
        desc: {
          line1:
            'To help explain things as clearly as possible in this Terms & Conditions, every time any of these terms are referenced, they are strictly defined as:',
          list1:
            'Cookie: a small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, and remember information about you, such as your language preference or login information.',
          list2:
            'Company: the term refers to Protexxa Inc. (16 Industrial Parkway South #115 Aurora, Ontario L4G 0R4), responsible for your information under these Terms & Conditions.',
          list3:
            'Country: where Protexxa or the owners/founders of Protexxa are based, in this case in Ontario, Canada',
          list4:
            'Device: any internet-connected device such as a phone, tablet, computer or any other device used to visit Protexxa and use the services.',
          list5:
            'Service: refers to the service provided by Protexxa as described in the relative terms (if available) and on this platform.',
          list6:
            'Third-party service: refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you',
          list7: 'App/Application: refers to the Protexxa Defender platform and related services.',
          list8: 'You: a person or entity registered with Protexxa to use the Services.',
        },
      },
      restrictions: {
        title: 'Restrictions',
        desc: {
          line1: 'You agree not to, and you will not permit others to:',
          list1:
            'License, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the app or make the platform available to any third party.',
          list2:
            'Modify, make derivative works of, disassemble, decrypt, reverse compile or reverse engineer any part of the app.',
          list3:
            'Remove, alter or obscure any proprietary notice (including any notice of copyright or trademark) of Protexxa or its affiliates, partners, suppliers or the licensors of the app.',
        },
      },
      payment: {
        title: 'Payment',
        desc: {
          line1:
            'If you register to any of our recurring payment plans, you agree to pay all fees or charges to your account for the service following the fees, charges and billing terms in effect when each fee or charge is due and payable. Unless otherwise indicated in an order form, you must provide Protexxa with a valid credit card (Visa, MasterCard, or any other issuer accepted by us) (Payment Provider) as a condition to signing up for the service. Your Payment Provider agreement governs your use of the designated credit card account, and you must refer to that agreement and not these Terms to determine your rights and liabilities concerning your Payment Provider. By providing Protexxa with your credit card number and associated payment information, you agree that Protexxa is authorized to verify information immediately and subsequently invoice your account for all fees due and payable to Protexxa hereunder and that no additional notice or consent is required. You agree to immediately notify Protexxa of any change in your billing address or the credit card used for payment. Protexxa reserves the right to change its prices and billing methods immediately upon posting on our site or by email delivery to your organization administrator(s).',
          line2:
            'Any attorney fees, court costs, or other costs incurred in the collection of delinquent undisputed amounts shall be the responsibility of and paid for by you.',
          line3:
            'No contract will exist between you and Protexxa for the Service until Protexxa accepts your order by a confirmatory email, SMS/MMS message, or other appropriate means of communication.',
          line4:
            'You are responsible for any third-party fees you may incur when using the service.',
          line5: 'If you are a user of a paying party (a B2B customer), there may not be fees.',
        },
      },
      refund: {
        title: 'Return and Refund Policy',
        desc: {
          line1: `Once you subscribe to a plan, you're charged automatically every month/year according to your subscription date.  When you cancel your subscription, you cancel the automatic renewal, and we maintain full access to the tool until the end of your billing cycle.  We don't offer a refund for our monthly subscriptions.  You may be entitled to a partial refund if you cancel an annual subscription within the first 30 days of the renewal date.`,
        },
      },
      personalInformation: {
        title: 'Use of Personal Information',
        desc: {
          line1: `When registering for an account or using the Protexxa app, you must only provide accurate and up-to-date personal information. You are strictly prohibited from using or providing any personal information that belongs to another person without that person's explicit consent.`,
          line2: 'By signing up for and using the Protexxa app, you affirm that:',
          list1: 'You will only use your personal information to create and access your account.',
          list2: 'You have not impersonated or assumed the identity of any other individual.',
          list3: 'All personal information provided is accurate, complete, and up to date.',
          line3: `If Protexxa becomes aware of or suspects that you have provided or used
        another person's personal information without proper authorization,
        Protexxa reserves the right to suspend or terminate your account and
        access to the app. Users who engage in unauthorized use of personal
        information may be subject to legal action.`,
        },
      },
      suggestions: {
        title: 'Your Suggestions',
        desc: {
          line1: `Any feedback, comments, ideas, improvements, or suggestions (collectively, "Suggestions") provided by you to Protexxa concerning the app shall remain the sole and exclusive property of Protexxa.`,
          line2:
            'Protexxa shall be free to use, copy, modify, publish, or redistribute the Suggestions for any purpose and in any way without any credit or compensation to you.',
        },
      },
      consent: {
        title: 'Your Consent',
        desc: {
          line1: `We've updated our Terms & Conditions to provide complete transparency into what is being seen when you visit our site and how it's used. By using our app, registering an account, or making a purchase, you now consent to our Terms & Conditions.`,
        },
      },
      api: {
        title: 'Links to Other Websites or APIs',
        desc: {
          line1: `These Terms & Conditions apply only to the Protexxa Services. The Services may contain links to other websites not operated or controlled by Protexxa. We are not responsible for the content, accuracy or opinions expressed in such websites; such websites are not monitored or checked for accuracy or completeness by us. Please remember that when you use a link to go from the Services to another website, our Terms & Conditions are no longer in effect. Browsing and interaction on any other website, including those with a link on our platform, is subject to that website's rules and policies. Such third parties may use their own cookies or other methods to collect information about you.`,
        },
      },
      modifications: {
        title: 'Modifications to Our Platform',
        desc: {
          line1:
            'Protexxa reserves the right to modify, suspend or discontinue, temporarily or permanently, the app or any service to which it connects, with or without notice and without liability to you.',
        },
      },
      updates: {
        title: 'Updates to Our App',
        desc: {
          line1: `Protexxa may occasionally provide enhancements or improvements to the features/ functionality of the app, which may include patches, bug fixes, updates, upgrades and other modifications ("Updates").`,
          line2:
            'Updates may modify or delete certain features and functionalities of the app. You agree that Protexxa has no obligation to (i) provide any Updates or (ii) continue to provide or enable any features and functionalities of the app to you.',
          line3:
            'You further agree that all Updates will be (i) deemed to constitute an integral part of the app and (ii) subject to the terms and conditions of this Agreement.',
        },
      },
      thirdParty: {
        title: 'Third-Party Services',
        desc: {
          line1: `We may display, include or make available third-party content (including data, information, applications and other product and services) or provide links to third-party websites or services ("Third-Party Services").`,
          line2:
            'You acknowledge and agree that Protexxa shall not be responsible for any Third-Party Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect thereof. Protexxa does not assume and shall not have any liability or responsibility to you or any other person or entity for any Third-Party Services.',
          line3:
            'Third-Party Services and links to them are provided solely as a convenience to you, and you access and use them entirely at your own risk and subject to such third parties’ terms and conditions.',
        },
      },
      termination: {
        title: 'Term and Termination',
        desc: {
          line1: 'This Agreement shall remain in effect until terminated by you or Protexxa.',
          line2:
            'Protexxa may, in its sole discretion, at any time and for any or no reason, suspend or terminate this Agreement with or without prior notice.',
          line3:
            'This Agreement will terminate immediately, without prior notice from Protexxa, if you fail to comply with any provision of this Agreement. You may terminate this Agreement by closing your account and removing the app from your device.',
          line4: 'Upon termination of this Agreement, you shall cease all app use.',
          line5: `Termination of this Agreement will not limit any of Protexxa's rights or
          remedies at law or in equity in case of breach by you (during the term
          of this Agreement) of any of your obligations under the present
          Agreement.`,
        },
      },
      copyRight: {
        title: 'Copyright Infringement Notice',
        desc: {
          line1: `If you are a copyright owner or such owner's agent and believe any material on our app constitutes an infringement on your copyright, please get in touch with us setting forth the following information: (a) a physical or electronic signature of the copyright owner or a person authorized to act on his behalf; (b) identification of the material that claimed to be infringing; (c) your contact information, including your address, telephone number, and an email; (d) a statement by you that you have a good faith belief that the copyright owners do not authorize the use of the material; and (e) the statement that the information in the notification is accurate, and, under penalty of perjury you are authorized to act on behalf of the owner.`,
        },
      },
      indemnification: {
        title: 'Indemnification',
        desc: {
          line1: `You agree to indemnify and hold Protexxa and its parents, subsidiaries, affiliates, officers, employees, agents, partners and licensors (if any) harmless from any claim or demand, including reasonable attorneys' fees, due to or arising out of your:`,
          list1: '1. Use of the app.',
          list2: '2. Violation of this Agreement or any law or regulation.',
          list3: '3. Violation of any right of a third party.',
        },
      },
      warranties: {
        title: 'No Warranties',
        desc: {
          line1: `The app is provided "AS IS" and "AS AVAILABLE" with all faults and defects without warranty. To the maximum extent permitted under applicable law, Protexxa, on its own behalf and on behalf of its affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the app, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, Protexxa provides no warranty or undertaking and makes no representation of any kind that the app will meet your requirements, achieve any intended results, be compatible or work with any other software, apps, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.`,
          line2: `Without limiting the foregoing, neither Protexxa nor any of Protexxa's providers make any representation or warranty of any kind, express or implied:`,
          list1: `1.	The app's operation or availability, or the information, content, and materials or products included thereon.`,
          list2: '2. The app will be uninterrupted or error-free.',
          list3:
            '3. The accuracy, reliability, or currency of any information or content provided through the app.',
          list4:
            '4. The app, its servers, the content, or emails sent from or on behalf of Protexxa are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.',
          line3:
            'Some jurisdictions do not allow the exclusion of or limitations on implied warranties or the constraints of the applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to you.',
        },
      },
      limitation: {
        title: 'Limitation of Liability',
        desc: {
          line1:
            'Notwithstanding any damages you might incur, the entire liability of Protexxa and any of its suppliers under any provision of this Agreement and your exclusive remedy for all the foregoing shall be limited to the amount paid by you for the app.',
          line2:
            'To the maximum extent permitted by applicable law, in no event shall Protexxa or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, for loss of data or other information, for business interruption, for personal injury, for loss of privacy arising out of or in any way related to the use of or inability to use the app, third-party software and third-party hardware used with the app, or otherwise in connection with any provision of this Agreement), even if Protexxa or any supplier has advised of the possibility of such damages and even if the remedy fails of its essential purpose.',
          line3:
            'Some states/jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the above limitation or exclusion may not apply to you.',
        },
      },
      severability: {
        title: 'Severability',
        desc: {
          line1:
            'If any provision of this Agreement is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law, and the remaining provisions will continue in full force and effect.',
          line2: `This Agreement, together with the Privacy Policy and any other legal notices published by Protexxa on the Services, shall constitute the entire agreement between you and Protexxa concerning the Services. If any provision of this Agreement is deemed invalid by a court of competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of this Agreement, which shall remain in full force and effect. No waiver of any term of this Agreement shall be deemed a further or continuing waiver of such term or any other term, and Protexxa's failure to assert any right or provision under this Agreement shall not constitute a waiver of such right or provision. YOU AND Protexxa AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICES MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.`,
        },
      },
      waiver: {
        title: 'Waiver',
        desc: {
          line1: `Except as provided herein, the failure to exercise a right or to require the performance of an obligation under this Agreement shall not affect a party's ability to exercise such right or require such performance at any time after that, nor shall the waiver of a breach constitute waiver of any subsequent breach.`,
          line2:
            'No failure to exercise, and no delay in exercising, on the part of either party, any right or any power under this Agreement shall operate as a waiver of that right or power. Nor shall any single or partial exercise of any right or power under this Agreement preclude further exercise of that or any other right granted herein. In the event of a conflict between this Agreement and any applicable purchase or other terms, the terms of this Agreement shall govern.',
        },
      },
      amendments: {
        title: 'Amendments to terms and conditions',
        desc: {
          line1:
            'Protexxa reserves the right, at its sole discretion, to modify or replace these terms and conditions at any time. If a revision is material, we will provide notice before any new terms take effect. What constitutes a material change will be determined at our sole discretion.',
          line2:
            'By continuing to access or use our app after any revisions become effective, you agree to be bound by the revised terms. If you disagree with the new terms, you can no longer use Protexxa.',
        },
      },
      entireTerms: {
        title: 'Entire Terms and Conditions',
        desc: {
          line1:
            'These terms and conditions constitute the entire terms and conditions between you and Protexxa regarding your app use and supersedes all prior and contemporaneous written or oral terms and conditions between you and Protexxa.',
          line2:
            'You may be subject to additional terms and conditions when you use or purchase other Protexxa services, which Protexxa will provide to you at the time of such use or purchase.',
        },
      },
      updatesTerms: {
        title: 'Updates to Our Terms',
        desc: {
          line1:
            'We may change our service and policies and need to make changes to these Terms so that they accurately reflect our service and policies. Unless otherwise required by law, we will notify you (for example, through our service) before we make changes to these Terms and allow you to review them before they go into effect. Then, if you continue to use the service, you will be bound by the updated Terms. If you do not want to agree to these or any updated Terms, you can delete your account.',
        },
      },
      intellectualProperty: {
        title: 'Intellectual Property',
        desc: {
          line1:
            'The app and its entire contents, features and functionality (including but not limited to all information, software, text, displays, images, video and audio, and the design, selection and arrangement thereof) are owned by Protexxa, its licensors or other providers of such material. They are protected by the Province of Ontario and international copyright, trademark, patent, trade secret and other intellectual property or proprietary rights laws. The material may not be copied, modified, reproduced, downloaded or distributed in any way, in whole or in part, without the express prior written permission of Protexxa, unless and except as is expressly provided in these Terms & Conditions. Any unauthorized use of the material is prohibited.',
        },
      },
      agreementArbitrate: {
        title: 'Agreement to Arbitrate',
        desc: {
          line1: `This section applies to any dispute EXCEPT IT DOESN'T INCLUDE A DISPUTE RELATING TO CLAIMS FOR INJUNCTIVE OR EQUITABLE RELIEF REGARDING THE ENFORCEMENT OR VALIDITY OF YOUR OR Protexxa's INTELLECTUAL PROPERTY RIGHTS. The term dispute means any dispute, action, or other controversy between you and Protexxa concerning the Services or this agreement, whether in contract, warranty, tort, statute, regulation, ordinance, or any other legal or equitable basis. The dispute will be given the broadest possible meaning allowable under the law.`,
        },
      },
      dispute: {
        title: 'Notice of Dispute',
        desc: {
          line1:
            'In the event of a dispute, you or Protexxa must give the other a Notice of Dispute, a written statement that sets forth the name, address, and contact information of the party granting it, the facts giving rise to the dispute, and the relief requested. You must send any Notice of Dispute via email to: learn@protexxa.com. Protexxa will send any Notice of Dispute to you by mail to your address if we have it or otherwise to your email address. You and Protexxa will attempt to resolve any dispute through informal negotiation within sixty (60) days from the date the Notice of Dispute is sent. After sixty (60) days, you or Protexxa may commence arbitration.',
        },
      },
      arbitration: {
        title: 'Binding Arbitration',
        desc: {
          line1: `If you and Protexxa don't resolve any dispute by informal negotiation, any other effort to resolve the dispute will be conducted exclusively by binding arbitration, as described in this section. You are giving up the right to litigate (or participate in as a party or class member) all disputes in court before a judge or jury. The dispute will be settled by binding arbitration under the commercial arbitration rules of the American Arbitration Association. Either party may seek any interim or preliminary injunctive relief from any court of competent jurisdiction as necessary to protect the party's rights or property pending the completion of arbitration. All legal, accounting, and other costs, fees, and expenses incurred by the prevailing party shall be borne by the non-prevailing party.`,
        },
      },
      submissions: {
        title: 'Submissions and Privacy',
        desc: {
          line1:
            'If you submit or post any ideas, creative suggestions, designs, photographs, information, advertisements, data or proposals, including ideas for new or improved products, services, features, technologies or promotions, you expressly agree that such submissions will automatically be treated as non-confidential and non-proprietary and will become the sole property of Protexxa without any compensation or credit to you whatsoever. Protexxa and its affiliates shall have no obligations concerning such submissions or posts. They may use the ideas contained in such submissions or posts for any purposes in any medium in perpetuity, including, but not limited to, developing, manufacturing, and marketing products and services using such ideas.',
        },
      },
      promotions: {
        title: 'Promotions',
        desc: {
          line1:
            'Protexxa may occasionally include contests, promotions, sweepstakes, or other activities (Promotions) that require you to submit material or information concerning yourself. Please note that all Promotions may be governed by separate rules containing specific eligibility requirements, such as restrictions as to age and geographic location. You are responsible for reading all Promotions rules to determine whether or not you are eligible to participate. If you enter any Promotion, you agree to abide by and comply with all Promotions Rules.',
          line2:
            'Additional terms and conditions may apply to purchases of goods or services on or through the Services, which terms and conditions are made a part of this Agreement by this reference.',
        },
      },
      typographicalErrors: {
        title: 'Typographical Errors',
        desc: {
          line1:
            'If a product and service is listed at an incorrect price or with incorrect information due to a typographical error, we shall have the right to refuse or cancel any orders placed for the product and service listed at the incorrect price. We shall have the right to refuse or cancel any such order whether the order has been confirmed and your credit card has been charged. If your credit card has already been charged for the purchase and you cancel your order, we shall immediately issue a credit to your credit card account or another payment account in the amount of the charge.',
        },
      },
      miscellaneous: {
        title: 'Miscellaneous',
        desc: {
          line1:
            'If, for any reason, a court of competent jurisdiction finds any provision or portion of these Terms & Conditions to be unenforceable, the remainder of these Terms & Conditions will continue in full force and effect. Any waiver of any provision of these Terms & Conditions will be effective only if in writing and signed by an authorized representative of Protexxa. Protexxa will be entitled to injunctive or other equitable relief (without the obligations of posting any bond or surety) in the event of any breach or anticipatory breach by you. Protexxa operates and controls the Protexxa Service from its offices in Ontario, Canada. The service is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation. Accordingly, those persons who choose to access the Protexxa Service from other locations do so on their initiative and are solely responsible for compliance with local laws if and to the extent local laws are applicable. These Terms & Conditions (which include and incorporate the Protexxa Privacy Policy) contain the entire understanding and supersede all prior understandings between you and Protexxa concerning its subject matter and cannot be changed or modified by you. The section headings used in this Agreement are for convenience only and will not be given any legal import.',
        },
      },
      disclaimer: {
        title: 'Disclaimer',
        desc: {
          line1: 'Protexxa is not responsible for any content, code or any other imprecision.',
          line2: 'Protexxa does not provide warranties or guarantees.',
          line3:
            'In no event shall Protexxa be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the service or the contents of the service. The Company reserves the right to make additions, deletions, or modifications to the contents of the service at any time without prior notice.',
          line4: `The Protexxa Service and its contents are "as is" and "as available" without any warranty or representations, whether express or implied. Protexxa is a distributor and not a publisher of the content supplied by third parties; as such, Protexxa exercises no editorial control over such content and makes no warranty or representation as to the accuracy, reliability or currency of any information, content, service or merchandise provided through or accessible via the Protexxa Service. Without limiting the foregoing, Protexxa expressly disclaims all warranties and representations in any content transmitted on or in connection with the Protexxa Service or on sites that may appear as links on the Protexxa Service or in the products provided as a part of, or otherwise in connection with, the Protexxa Service, including without limitation any warranties of merchantability, fitness for a particular purpose or non-infringement of third-party rights. No oral advice or written information from Protexxa or any of its affiliates, employees, officers, directors, agents, or the like will create a warranty. Price and availability information is subject to change without notice. Without limiting the foregoing, Protexxa does not warrant that the Protexxa Service will be uninterrupted, uncorrupted, timely, or error-free.`,
        },
      },
      contactUs: {
        title: 'Contact Us',
        desc: {
          line1: `Don't hesitate to contact us if you have any questions.`,
          list1: 'Via email: learn@protexxa.com',
        },
      },
    },
    privacyPolicy: {
      title: 'PROTEXXA PRIVACY POLICY',
      date: 'August 1st, 2023',
      desc: {
        line1:
          'Protexxa Inc. (“Protexxa,” “we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by Protexxa.',
        line2:
          'This Privacy Policy applies to our website and its associated subdomains (collectively, our “Service”) alongside our applications. By accessing or using our service, you signify that you have read, understood, and agree to our collection, storage, use, and disclosure of your personal information as described in this Privacy Policy and our Terms of Service.',
      },
      definitionsTerms: {
        title: 'Definitions and key terms',
        desc: {
          line1:
            'To help explain things as clearly as possible in this Privacy Policy, every time any of these terms are referenced, are strictly defined as:',
          list1:
            'Cookie: small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, remember information about you such as your language preference or login information.',
          list2:
            'Company: when this policy mentions “Company,” “Protexxa,” “we,” “us,” or “our,” it refers to Protexxa Inc., (16 Industrial Parkway South #115 Aurora, Ontario L4G 0R4), that is responsible for your information under this Privacy Policy.',
          list3:
            'Country: where Protexxa or the owners/founders of Protexxa are based, in this case is Canada',
          list4:
            'Customer: refers to the company, organization or person that signs up to use the Protexxa Service to manage the relationships with your consumers or service users.',
          list5:
            'Device: any internet connected device such as a phone, tablet, computer or any other device that can be used to visit Protexxa and use the services.',
          list6:
            'IP address: Every device connected to the Internet is assigned a number known as an Internet protocol (IP) address. These numbers are usually assigned in geographic blocks. An IP address can often be used to identify the location from which a device is connecting to the Internet.',
          list7:
            'Personnel: refers to those individuals who are employed by Protexxa or are under contract to perform a service on behalf of one of the parties.',
          list8:
            'Personal Data: any information that directly, indirectly, or in connection with other information — including a personal identification number — allows for the identification or identifiability of a natural person.',
          list9:
            'Service: refers to the service provided by Protexxa as described in the relative terms (if available) and on this platform. ',
          list10:
            'Third-party service: refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you.',
          list11:
            'You (and end-user): a person or entity that is registered with Protexxa to use the Services.',
        },
      },
      collection: {
        title: 'What Information Do We Collect?',
        desc: {
          line1:
            'We collect information from you when you visit our website/app, register on our site, place an order,use the Protexxa Defender platform, subscribe to our newsletter, respond to a survey or fill out a form.',
          list1: 'Name / Username',
          list2: 'Phone Numbers',
          list3: 'Email Addresses',
          list4: 'Mailing Addresses',
          list5: 'Billing Addresses',
          list6: 'Debit/credit card numbers (for paying customers only)  ',
          list7: 'Age',
          list8: 'Password',
          list9: 'Images',
          list10: 'Information to improve user experience and services',
        },
      },
      endUserInfo: {
        title: 'When does Protexxa use end-user information from third parties?',
        desc: {
          line1:
            'Protexxa will collect end-user data necessary to provide the Protexxa services to our customers. End users may voluntarily provide us with information they have made available on public  websites. Where you have provided this information, Protexxa may collect publicly available information from third-parties.',
        },
      },
      ecustomerInfo: {
        title: 'When does Protexxa use customer information from third parties?',
        desc: {
          line1:
            'Protexxa uses information from third parties to imporve user experience and services. This includes information provided when registering on the platform.',
        },
      },
      shareInfo: {
        title: 'Do we share the information we collect with third parties?',
        desc: {
          line1:
            'We may share the information that we collect, both personal and non-personal, with third parties  who provide our content or whose products or services will add incremental value to your experienceas and/or we think may interest you. We may also share it with our current and future affiliated companies and business partners, and if we are involved in a merger, asset sale or other business reorganization, we may also share or transfer your personal and non-personal information to our successors-in-interest.',
          line2:
            'We may engage trusted third-party service providers to perform functions and provide services to us, such as hosting and maintaining our servers and the website/app, database storage and management, e-mail management, storage marketing, credit card processing, customer service, session management, and fulfilling orders for products and services you may purchase through the website/app. We will likely share your personal information, and possibly some non-personal information, with these third parties to enable them to perform these services for us and for you.',
          line3:
            'We may share portions of our log file data, including IP addresses, for analytics purposes with third parties such as web analytics partners, application developers, and ad networks. If your IP address is shared, it may be used to estimate general location and other technographics such as connection speed, whether you have visited the website/app in a shared location, and type of the device used to visit the website/app. They may aggregate information about our advertising and what you see on the website/app and then provide auditing, research and reporting for us and our advertisers.',
          line4:
            'We may also disclose personal and non-personal information about you to government or law enforcement officials or private parties as we, in our sole discretion, believe necessary or appropriate in order to respond to claims, legal process (including subpoenas), to protect our rights and interests or those of a third party, the safety of the public or any person, to prevent or stop any illegal, unethical, or legally actionable activity, or to otherwise comply with applicable court orders, laws, rules and regulations.',
        },
      },
      whenCollectInfo: {
        title: 'Where and when is information collected from customers and end users?',
        desc: {
          line1:
            'Protexxa will collect personal information that you submit to us. We may also receive personal information about you from third parties as described above.',
        },
      },
      useInfo: {
        title: 'How Do We Use the Information We Collect?',
        desc: {
          line1:
            'Any of the information we collect from you may be used in one of the following ways: ',
          list1: 'To generate end-user personalized cybersecurity assessments',
          list2: 'To generated aggregate scores and recommenations ',
          list3:
            'To personalize your experience (your information helps us to better respond to your individual needs)',
          list4:
            'To improve our website/app (we continually strive to improve our website/app offerings based on the information and feedback we receive from you)',
          list5:
            'To improve customer service (your information helps us to more effectively respond to your customer service requests and support needs)',
          list6: 'To process transactions',
          list7: 'To administer a contest, promotion, survey or other site feature',
          list8: 'To send periodic emails',
        },
      },
      emailUse: {
        title: 'How Do We Use Your Email Address?',
        desc: {
          line1:
            'Your email is used to provide you our services and by submitting your email address on this website/app, you agree to receive emails from us. You can cancel your participation in any of these email lists at any time by clicking on the opt-out link or other unsubscribe option that is included in the respective email. We only send emails to people who have authorized us to contact them, either directly, or through a third party. By submitting your email address, you also agree to allow us to use your email address for customer audience targeting on sites like Facebook, where we display custom advertising to specific people who have opted-in to receive communications from us. Email addresses submitted only through the order processing page will be used for the sole purpose of sending you information and updates pertaining to your order. If, however, you have provided the same email to us through another method, we may use it for any of the purposes stated in this Policy. Note: If at any time you would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email.',
        },
      },
      keepInfo: {
        title: 'How Long Do We Keep Your Information?',
        desc: {
          line1:
            "We keep your information only so long as we need it to provide services to you and fulfill the purposes described in this policy. This is also the case for anyone that we share your information with and who carries out services on our behalf. When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we’ll either remove it from our systems or depersonalize it so that we can't identify you.",
        },
      },
      infoProtect: {
        title: 'How Do We Protect Your Information?',
        desc: {
          line1:
            'We implement a variety of security measures to maintain the safety of your personal information when you place an order or enter, submit, or access your personal information. We offer the use of a secure server. All supplied sensitive/credit information is transmitted via Secure Socket Layer (SSL) technology and then encrypted into our Payment gateway providers database only to be accessible by those authorized with special access rights to such systems and are required to keep the information confidential. After a transaction, your private information (credit cards, social security numbers, financials, etc.) is never kept on file. We cannot, however, ensure or warrant the absolute security of any information you transmit to Protexxa or guarantee that your information on the Service may not be accessed, disclosed, altered, or destroyed by a breach of any of our physical, technical, or managerial safeguards.',
        },
      },
      infoTransfer: {
        title: 'Could my information be transferred to other countries?',
        desc: {
          line1:
            'Protexxa is incorporated in Ontario, Canada. Information collected via our website/app, through direct interactions with you, or from use of our help services may be transferred from time to time to our offices or personnel, or to third parties, located throughout the world, and may be viewed and hosted anywhere in the world, including countries that may not have laws of general applicability regulating the use and transfer of such data. To the fullest extent allowed by applicable law, by using any of the above, you voluntarily consent to the trans-border transfer and hosting of such information.',
        },
      },
      infoSecure: {
        title: 'Is the information collected through the Protexxa Service secure?',
        desc: {
          line1:
            'We take precautions to protect the security of your information. We have physical, electronic, and managerial procedures to help safeguard, prevent unauthorized access, maintain data security, and correctly use your information. However, neither people nor security systems are foolproof, including encryption systems. In addition, people can commit intentional crimes, make mistakes or fail to follow policies. Therefore, while we make reasonable efforts to protect your personal information, we cannot guarantee its absolute security. ',
        },
      },
      infoUpdate: {
        title: 'Can I update or correct my information?',
        desc: {
          line1:
            'Your right to request updates or corrections to the information Protexxa collects depend on your relationship with Protexxa. Personnel may update or correct their information as detailed in our internal company employment policies.',
          line2:
            'Customers have the right to request the restriction of certain uses and disclosures of personally identifiable information as follows. You can contact us in order to (1) update or correct your personally identifiable information, (2) change your preferences with respect to communications and other information you receive from us, or (3) delete the personally identifiable information maintained about you on our systems (subject to the following paragraph), by cancelling your account. Such updates, corrections, changes and deletions will have no effect on other information that we maintain, or information that we have provided to third parties in accordance with this Privacy Policy prior to such update, correction, change or deletion. To protect your privacy and security, we may take reasonable steps (such as requesting a unique password) to verify your identity before granting you profile access or making corrections. You are responsible for always maintaining the secrecy of your unique password and account information.',
          line3:
            'You should be aware that it is not technologically possible to remove each record of the information you have provided to us from our system. The need to back up our systems to protect information from inadvertent loss means that a copy of your information may exist in a non-erasable form that will be difficult or impossible for us to locate. Promptly after receiving your request, all personal information stored in databases we actively use, and other readily searchable media will be updated, corrected, changed or deleted, as appropriate, as soon as and to the extent reasonably and technically practicable.',
          line4:
            'If you are an end user and wish to update, delete, or receive any information we have about you, you may do so by contacting Protexxa.',
        },
      },
      personnel: {
        title: 'Personnel',
        desc: {
          line1:
            'If you are a Protexxa worker or applicant, we collect information you voluntarily provide to us. We use the information collected for Human Resources purposes in order to administer benefits to workers and screen applicants.',
          line2:
            'You may contact us in order to (1) update or correct your information, (2) change your preferences with respect to communications and other information you receive from us, or (3) receive a record of the information we have relating to you. Such updates, corrections, changes and deletions will have no effect on other information that we maintain, or information that we have provided to third parties in accordance with this Privacy Policy prior to such update, correction, change or deletion.',
        },
      },
      saleBusiness: {
        title: 'Sale of Business',
        desc: {
          line1:
            'We reserve the right to transfer information to a third party in the event of a sale, merger or other transfer of all or substantially all of the assets of Protexxa or any of its Corporate Affiliates (as defined herein), or that portion of Protexxa or any of its Corporate Affiliates to which the Service relates, or in the event that we discontinue our business or file a petition or have filed against us a petition in bankruptcy, reorganization or similar proceeding, provided that the third party agrees to adhere to the terms of this Privacy Policy.',
        },
      },
      affiliates: {
        title: 'Affiliates',
        desc: {
          line1: `We may disclose information (including personal information) about you to our Corporate Affiliates. For purposes of this Privacy Policy, "Corporate Affiliate" means any person or entity which directly or indirectly controls, is controlled by or is under common control with Protexxa, whether by ownership or otherwise. Any information relating to you that we provide to our Corporate Affiliates will be treated by those Corporate Affiliates in accordance with the terms of this Privacy Policy.`,
        },
      },
      governingLaw: {
        title: 'Governing Law',
        desc: {
          line1:
            'This Privacy Policy is governed by the laws of the Province of Ontario, Canada without regard to its conflict of laws provision. You consent to the exclusive jurisdiction of the courts in connection with any action or dispute arising between the parties under or in connection with this Privacy Policy.',
          line2:
            'The laws of Ontario, excluding its conflicts of law rules, shall govern this Agreement and your use of the website/app. Your use of the website/app may also be subject to other local, provincial, national, or international laws.',
          line3:
            'By using Protexxa or contacting us directly, you signify your acceptance of this Privacy Policy. If you do not agree to this Privacy Policy, you should not engage with our website/app, or use our services. Continued use of the website/app, direct engagement with us, or following the posting of changes to this Privacy Policy that do not significantly affect the use or disclosure of your personal information will mean that you accept those changes.',
        },
      },
      consent: {
        title: 'Your Consent',
        desc: {
          line1:
            "We've updated our Privacy Policy to provide you with complete transparency into what is being set when you visit our site and how it's being used. By using our application, registering an account, or making a purchase, you hereby consent to our Privacy Policy and agree to its terms.",
        },
      },
      linksWeb: {
        title: 'Links to Other Websites',
        desc: {
          line1:
            'This Privacy Policy applies only to Protexxa’s Products and Services. The Services may contain links to other websites not operated or controlled by Protexxa. We are not responsible for the content, accuracy or opinions expressed in such websites, and such websites are not investigated, monitored or checked for accuracy or completeness by us. Please remember that when you use a link to go from the Services to another website, our Privacy Policy is no longer in effect. Browsing and interaction on any other website, including those that have a link on our platform, is subject to that website’s own rules and policies. Third-parties may use their own cookies or other methods to collect information about you.',
        },
      },
      cookies: {
        title: 'Cookies',
        desc: {
          line1: `Protexxa uses "Cookies" to identify the areas of our website/app that you have visited. A Cookie is a small piece of data stored on your computer or mobile device by your web browser. We use Cookies to enhance the performance and functionality of our website/app but are non-essential to their use. However, without these cookies, certain functionality like videos may become unavailable or you would be required to enter your login details every time you visit the website/app as we would not be able to remember that you had logged in previously. Most web browsers can be set to disable the use of Cookies. However, if you disable Cookies, you may not be able to access functionality on our website/app correctly or at all. We never place Personally Identifiable Information in Cookies.`,
        },
      },
      blocking: {
        title: 'Blocking and disabling cookies and similar technologies',
        desc: {
          line1:
            "Wherever you're located you may also set your browser to block cookies and similar technologies, but this action may block our essential cookies and prevent our website/app from functioning properly, and you may not be able to fully utilize all of its features and services. You should also be aware that you may also lose some saved information (e.g. saved login details, site preferences) if you block cookies on your browser. Different browsers make different controls available to you. Disabling a cookie or category of cookie does not delete the cookie from your browser, you will need to do this yourself from within your browser, you should visit your browser's help menu for more information.",
        },
      },
      remarketing: {
        title: 'Remarketing Services',
        desc: {
          line1:
            "We use remarketing services. What Is Remarketing? In digital marketing, remarketing (or retargeting) is the practice of serving ads across the internet to people who have already visited your website/app. It allows your company to seem like they're “following” people around the internet by serving ads on the websites and platforms they use most.",
        },
      },
      payment: {
        title: 'Payment Details',
        desc: {
          line1:
            'In respect to any credit card or other payment processing details you have provided us, we commit that this confidential information will be stored in the most secure manner possible.',
        },
      },
      kidsPrivacy: {
        title: "Kids' Privacy",
        desc: {
          line1:
            'Our application is available to everyone, however, anyone under the age of 13 requires parental consent. If you are a parent or guardian and you are aware that your child has provided us with Personal Data without your consent, please contact us. If we become aware that we have collected personal data from anyone under the age of 13 without parental consent, we may take steps to remove that information.',
        },
      },
      changesPrivacyPolicy: {
        title: 'Changes To Our Privacy Policy',
        desc: {
          line1:
            'We may change our Service and policies, and we may need to make changes to this Privacy Policy so that they accurately reflect our Service and policies. Unless otherwise required by law, we will notify you (for example, through our Service) of changes to this Privacy Policy. If you continue to use the Services, you will be bound by the updated Privacy Policy. If you do not want to agree to this or any updated Privacy Policy, you can delete your account.',
        },
      },
      thirdParty: {
        title: 'Third-Party Services',
        desc: {
          line1: `We may display, include or make available third-party content (including data, information, applications and other products services) or provide links to third-party websites or services ("Third- Party Services").`,
          line2:
            'You acknowledge and agree that Protexxa shall not be responsible for any Third-Party Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect thereof. Protexxa does not assume and shall not have any liability or responsibility to you or any other person or entity for any Third-Party Services.',
          line3:
            "Third-Party Services and links thereto are provided solely as a convenience to you, and you access and use them entirely at your own risk and subject to such third parties' terms and conditions.",
        },
      },
      tracking: {
        title: 'Tracking Technologies',
        desc: {
          list1:
            'Cookies: we use Cookies to enhance the performance and functionality of our platform but are non-essential to their use. However, without these cookies, certain functionality like videos may become unavailable or you would be required to enter your login details every time you visit the platform as we would not be able to remember that you had logged in previously.',
          list2:
            'Sessions: we use "Sessions" to identify the areas of our platform that you have visited. A Session is a small piece of data stored on your computer or mobile device by your web browser.',
        },
      },
      generalData: {
        title: 'Information about General Data Protection Regulation (GDPR)',
        desc: {
          line1:
            'We may be collecting and using information from you if you are from the European Economic Area (EEA), and in this section of our Privacy Policy we are going to explain exactly how and why is this data collected, and how we maintain this data under protection from being replicated or used in the wrong way.',
        },
      },
      gdpr: {
        title: 'What is GDPR?',
        desc: {
          line1:
            "GDPR is an EU-wide privacy and data protection law that regulates how EU residents' data is protected by companies and enhances the control the EU residents have, over their personal data.",
          line2:
            'The GDPR is relevant to any globally operating company and not just the EU-based businesses and EU residents. Our customers’ data is important irrespective of where they are located, which is why we have implemented GDPR controls as our baseline standard for all our operations worldwide.',
        },
      },
      personalData: {
        title: 'What is personal data?',
        desc: {
          line1:
            'Any data that relates to an identifiable or identified individual. GDPR covers a broad spectrum of information that could be used on its own, or in combination with other pieces of information, to identify a person. Personal data extends beyond a person’s name or email address. Some examples include financial information, political opinions, genetic data, biometric data, IP addresses, physical address, sexual orientation, and ethnicity.',
          line2: 'The Data Protection Principles include requirements such as:',
          list1:
            'Personal data collected must be processed in a fair, legal, and transparent way and should only be used in a way that a person would reasonably expect.',
          list2:
            'Personal data should only be collected to fulfil a specific purpose and it should only be used for that purpose. Organizations must specify why they need the personal data when they collect it.',
          list3: 'Personal data should be held no longer than necessary to fulfil its purpose.',
          list4:
            'People covered by the GDPR have the right to access their own personal data. They can also request a copy of their data, and that their data be updated, deleted, restricted, or moved to another organization.',
        },
      },
      gdprImportant: {
        title: 'Why is GDPR important?',
        desc: {
          line1:
            "GDPR adds some new requirements regarding how companies should protect individuals' personal data that they collect and process. It also raises the stakes for compliance by increasing enforcement and imposing greater fines for breach. Beyond these facts it's simply the right thing to do. At Protexxa we strongly believe that your data privacy is very important, and we already have solid security and privacy practices in place that go beyond the requirements of this new regulation.",
        },
      },
      individualData: {
        title: "Individual Data Subject's Rights - Data Access, Portability and Deletion",
        desc: {
          line1:
            'We are committed to helping our customers meet the data subject rights requirements of GDPR. Protexxa processes or stores all personal data in fully vetted, DPA compliant vendors. We do store all conversation and personal data for up to 6 years unless your account is deleted. In which case, we dispose of all data in accordance with our Terms of Service and Privacy Policy, but we will not hold it longer than 60 days.',
          line2:
            "We are aware that if you are working with EU customers, you need to be able to provide them with the ability to access, update, retrieve and remove personal data. We got you! We've been set up as self-service from the start and have always given you access to your data and your customers data. Our customer support team is here for you to answer any questions you might have about working with the API.",
        },
      },
      contactUs: {
        title: 'Contact Us',
        desc: {
          line1: "Don't hesitate to contact us if you have any questions.",
          list1: 'Via Email: learn@protexxa.com',
        },
      },
    },
    charts: {
      tooltip: {
        invalid: 'Invalid values',
        have_one: '{{count}} out of {{maxValue}} users has',
        have_other: '{{count}} out of {{maxValue}} users have',
        dontHave_one: "{{count}} out of {{maxValue}} users doesn't have",
        dontHave_other: "{{count}} out of {{maxValue}} users don't have",
        notRecognized: 'Values not recognized.',
        default: 'Default values.',
        cybersecurity: 'Cyber Security Insurance.',
        nameExposed: 'their name exposed online.',
        passwordManager: 'a Password Manager.',
        mfa: 'MFA enabled on all their accounts.',
        responsePlan: 'an Incident Response Plan.',
        privateAccounts: 'all their socials set to private.',
        imageExposed: 'their image exposed online.',
        domainCompromised: 'a compromised web domain.',
        passwordCompromised: 'compromised passwords.',
        phoneExposed: 'their phone number exposed online.',
        addressExposed: 'their address exposed online.',
      },
      analytics: {
        fullname: 'Name',
        address: 'Address',
        phoneNumber: 'Phone Number',
        email: 'Password',
        webDomains: 'Domains',
        monthly: 'Monthly',
        image: 'Image',
        useMFA: 'MFA',
        haveResponsePlan: 'Incident Response Plan',
        top10Apps: 'Private Social Media',
        allSocialMediasInPrivate: 'Private Social Media',
        havePasswordManager: 'Password Manager',
        haveCyberSecurityInsurance: 'Cybersecurity Insurance',
        backtoDashboard: 'Back to Dashboard',
        analyticsOverview: 'Analytics Overview',
        companyName: 'Company Name',
        filterBy: 'Filter by: ',
        lastYear: 'Last Year',
        lastSixMonths: 'Last 6 Months',
        last365Days: 'Last 365 Days',
        last180days: 'Last 180 Days',
        last90days: 'Last 90 Days',
        lastTreeMonths: 'Last 3 Months',
        cybersecurityScores: 'Protexxa Score',
        monthlyScoreOverTime: 'Monthly Score Over Time',
        indicatorsOfCompromise: 'Vulnerabilities',
        avarageNumberOfUserswithIncidentsOverTime:
          'Average Number of Users With Incidents Over Time',
        showing: 'Showing: ',
        all: 'All Indicators',
        exploreButton: 'Track Score Progress',
        noDataTitle: 'This section requires more data',
        noDataDescription:
          'Your score trend will be displayed after subsequent scans on your account.',
        scoreTrend: 'Score trend',
        cyberHealthScoreTrendOverTime: 'Cyber health score trend over time',
      },
    },
    dashboardReviewCards: {
      updateButton: {
        haveYouFixed: 'Have you fixed this issue?',
        update: 'Update Information',
      },
      confirmModal: {
        title: 'Confirm that you fixed this issue',
        subTitle:
          'When you update your information, it will be assessed in your next monthly cybersecurity score evaluation.',
        useMFA:
          "I confirm that I've either enabled multi-factor authentication (MFA) for added security or implemented measures to protect my personal information on platforms that do not support MFA",
        havePasswordManager:
          'I confirm that I have acquired a password manager to safeguard all my accounts and protect my personal information.',
        top10Apps:
          'Review the list of invasive apps and unmark those you no longer have an account with.',
        socialMedia:
          "I confirm that I've either set my social media profiles to private or taken measures to protect my personal information on platforms that lack total privacy settings.",
        button: {
          update: 'Update Information',
          close: 'Close',
        },
      },
      toast: {
        success: 'information updated successfully!',
      },
    },
    notifications: {
      notificationsModal: {
        title: 'Notifications',
        tabs: {
          unread: 'Unread',
          all: 'All',
        },
      },
      emptyState: {
        all: {
          title: "There aren't news for you.",
          description: 'Check back later to see if there are any notifications.',
        },
        unread: {
          title: "You've read all notifications!",
          description: "Check back later to see if there's any news.",
        },
      },
      domainNotification: {
        title: 'Web Domain Compromised',
        description: ' of your web domain(s) might have been compromised in the last month.',
      },
      passwordNotification: {
        title: 'Potential Password Leak',
        description: [
          'New potential leak: ',
          ' of your confirmed email accounts has been leaked this month.',
        ],
      },
      adressNotification: {
        title: 'Address Exposed',
        description: [
          'New leak: We discovered your address has been leaked in ',
          ' websites this month.',
        ],
      },
      mfaNotification: {
        title: 'Multi-Factor Authentication',
        description:
          "We've noticed that you do not use MFA. Click here to review this critical area.",
      },
      scoreNotification: {
        title: 'New Score of {{score}}',
        titleDefault: 'New score available',
        description: [
          'On our last scan, on ',
          ' your Protexxa Score went up by ',
          ' your Protexxa Score went down by ',
          ' points.',
        ],
      },
      safeNotification: {
        title: 'No new threats!',
        description: [
          "We haven't found any ",
          'new',
          ' threats in the last scan on ',
          '. Remember to fix any issues that is still unresolved!',
        ],
      },
      imageNotification: {
        title: 'New Image Found!',
        description: 'We discovered new instances of your personal image being used online.',
      },
      nameNotification: {
        title: 'Name Exposed',
        description: ['New discovery of your name that has been leaked in ', ' sites last month.'],
      },
      phoneNotification: {
        title: 'Phone Number Exposed',
        description: ['New discovery: your phone number has been leaked in ', ' sites last month.'],
      },
      otherNotification: {
        title: 'Other important threats',
        description: [
          'You have ',
          ' new issues',
          " that could expose you to a cyber attack. Let's fix them now.",
        ],
      },
      reportStatusNotification: {
        pending: {
          title: 'Reported Image Request Received',
          description:
            "We've received your request for the image report and will be processing it shortly.",
        },
        accepted: {
          title: 'Reported Image is in Progress',
          description:
            "We've assigned your report to our team. We'll update you on your request status when there's a change.",
        },
        requestDenied: {
          title: 'Reported Image Removal Unsuccessful',
          description: 'The image cannot be removed. See details for common reasons why.',
        },
        waitingFeedback: {
          title: 'Action Needed in Reported Image Process',
          description:
            'We require your input to proceed with the image removal process. Please click here to follow the instructions.',
        },
        userAction: {
          title: 'Action Needed in Reported Image Process',
          description:
            'We require your input to proceed with the image removal process. Please click here to follow the instructions.',
        },
        remove: {
          title: 'Reported Image Solved',
          description: 'This image has been successfully removed.',
        },
        solved: {
          title: 'Reported Image Solved',
          description: 'This image has been successfully removed.',
        },
        failed: {
          title: 'Reported Image Removal Unsuccessful',
          description: 'The image cannot be removed. See details for common reasons why.',
        },
      },
      responsePlanNotification: {
        title: 'Incident Report Plan',
        description: 'Create your own customized Response Plan to improve your cyber security.',
      },
      unresolvedNotification: {
        title: 'Unresolved issues',
        description:
          "There are still unresolved threats found in your last scan. Let's make your data more secure!",
      },
      companyScoreNotification: {
        title: 'New Company Score: ',
        description: [
          'After your last scan, on ',
          ' your Protexxa Score ',
          'went up ',
          'went down ',
          ' points. Check out the details.',
        ],
      },
      companyUpdatesNotification: {
        title: 'Updated analytics indicators!',
        description:
          'Check out the latest report and trends, comparing this scan to previous scans.',
      },
      settings: {
        title: 'Notifications',
        subtitle: {
          category: 'Category',
          push: 'Push',
          email: 'Email',
        },
        settingsData: {
          critical: {
            title: 'Critical Threats',
            subtitle:
              'Get notified when we detect that your address, password or domain have been compromised.',
          },
          important: {
            title: 'Important Threats',
            subtitle:
              'Get notified when we discover new instances of your personal information are being used online.',
          },
          image: {
            title: 'Reported Exposures',
            subtitle:
              'Get notified when we update a report of personal image, name, phone number or address that is being used online.',
          },
          reminders: {
            title: 'Reminders',
            subtitle:
              "Get notified for reminders such as cyber hygiene processes and issues that haven't been fixed.",
          },
          company: {
            title: 'Company Notifications',
            subtitle: 'Get notified when we scan for the company: new score and analytics updates.',
          },
        },
        button: {
          save: 'Save Changes',
        },
        toast: {
          success: 'Information updated successfully!',
          error: 'An error occurred',
        },
      },
    },
    externalLink: {
      title: 'You are leaving Protexxa',
      description:
        'While we make every effort to verify the safety of external links, please double-check the URL before proceeding.',
      button: 'Continue',
      back: 'Back to Protexxa',
    },
    authVerification: {
      title: 'Verify your details',
      subtitle: 'Verify your details to continue',
      codeText: 'Enter the code in the spaces below',
      phoneNumberDescription: 'We have sent the security code to the phone number',
      editPhoneNumber: 'Edit phone number',
      emailDescription: 'We have sent the security code to',
      retryText: 'Didn’t receive the code?',
      resendCode: 'Resend the code',
      sendToEmail: 'Send code to email instead',
      sendToPhone: 'Send code to phone number instead',
      wrongCode: 'Wrong code',
      smsDelayWarning:
        "We're currently experiencing delays with text message delivery for two-factor verification codes affecting some users in Canada. If this impacts you, please use Email Verification to continue. We apologize for the inconvenience. Thank you for your patience while we work to resolve this!",
    },
    dashboardV2: {
      common: {
        error: 'Something went wrong.',
        noData: 'No data available.',
        loading: 'Loading…',
        viewAll: 'View all',
      },
      severity: {
        critical: 'CRITICAL',
        high: 'HIGH',
        medium: 'MEDIUM',
        low: 'LOW',
      },
      riskLevel: {
        critical: 'Critical',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
      },
      speedometer: {
        criticalRisk: 'Critical Risk',
        highRisk: 'High Risk',
        mediumRisk: 'Medium Risk',
        lowRisk: 'Low Risk',
        sinceLastScan: 'since last scan',
      },
      welcomeHeader: {
        greeting: 'Welcome back,',
        subtitle: "Here's an overview of your current cyber health.",
        downloadReport: 'Download report',
      },
      securityRiskSummary: {
        title: 'Security risk summary',
        lastScan: 'Last scan:',
        nextScan: 'Next scan:',
        noScoreData: 'No score data available.',
      },
      scoreTrend: {
        title: 'Score trend',
        noTrendData: 'No trend data available.',
      },
      criticalIssues: {
        title: 'Critical issues to treat immediately',
        viewAll: 'View all scan results',
        noIssues: 'No critical issues found.',
      },
      recommendations: {
        title: 'Recommendations',
        subtitle:
          'Complete these actions to secure your personal data and improve your risk score!',
        noRecommendations: 'No recommendations available.',
        viewFindings: 'View related findings',
        viewAllFindings_one: 'View all {{count}} finding',
        viewAllFindings_other: 'View all {{count}} findings',
        priority: {
          immediate: 'Immediate',
          important: 'Important',
          awareness: 'Awareness',
        },
      },
      riskFindings: {
        title: 'Risk findings',
        subtitle: 'The kinds of issues we found from your scan',
        issueCount_one: '{{count}} issue',
        issueCount_other: '{{count}} issues',
        noFindings: 'No risk findings found.',
      },
      possibleAttacks: {
        title: 'Possible attacks',
        subtitle: 'Unfinished recommendations may expose you to these attacks!',
        noAttacks: 'No possible attacks identified.',
        issues: 'issues',
        relatedFindings: '{{count}} related findings',
        cta: {
          intro: 'Learn what these cyber attacks mean and how to protect yourself.',
          label: 'Most common cyber attacks',
        },
      },
      training: {
        title: 'Training',
        startTraining: 'Start training',
        recentLearning: 'Recent learning',
        skillsAcquired: 'Skills acquired',
        noTrainingData: 'No training data available.',
      },
      jobMatching: {
        title: 'Job matching',
        viewJobs: 'View jobs',
        recentActivity: 'Recent job activity',
        noActivity: 'No recent job activity.',
      },
      breachNarrative: {
        reviewAction: 'Review and take action',
      },
      findings: {
        title: 'Findings',
        lastScan: 'Last scan:',
        nextScan: 'Next scan:',
        sectionTitle:
          'Your personal data is exposed or at risk in these places. Review and fix them now',
        sectionSubtitle:
          'Focus on the critical and high risk issues first to secure your account faster.',
        emptyState: 'No findings available.',
        viewMore: 'View more',
        dataExposedLabel: 'Data exposed:',
        breachedLabel: 'Breached:',
        seeDetails: 'See details',
        summary: {
          criticalIssues_one: '{{count}} Critical issue',
          criticalIssues_other: '{{count}} Critical issues',
          criticalSubtitle: 'Fix these immediately',
          fixCritical: 'Fix critical issues',
          importantIssues_one: '{{count}} Important issue',
          importantIssues_other: '{{count}} Important issues',
          importantSubtitle: 'Review these soon',
          resolvedIssues_one: '{{count}} Resolved issue',
          resolvedIssues_other: '{{count}} Resolved issues',
          resolvedSubtitle: 'Issues addressed and pose less risk',
        },
        controls: {
          searchPlaceholder: 'Search by website, data type, or keyword',
          sortBy: 'Sort by:',
          sortDefault: 'Most recent',
          filters: 'Filters',
          bulkAction: 'Bulk action',
          listView: 'Detailed list view',
          gridView: 'Grid view',
        },
        filters: {
          byRecommendation: 'Recommendation: {{name}}',
          byAttack: 'Attack: {{name}}',
          bySeverity: 'Severity: {{name}}',
          byFinding: 'Specific finding',
        },
        riskPill: {
          critical: 'Critical risk',
          high: 'High risk',
          medium: 'Medium risk',
          low: 'Low risk',
        },
        dataType: {
          password: 'Password',
          name: 'Name',
          email: 'Email',
          username: 'Username',
          image: 'Image',
          phone: 'Phone',
          address: 'Address',
          domain: 'Domain',
        },
        cta: {
          placeholder: 'Take action',
        },
        groupCard: {
          issuesFound_one: '{{count}} issue found',
          issuesFound_other: '{{count}} issues found',
          fixAll_one: 'Fix {{count}} issue',
          fixAll_other: 'Fix all {{count}} issues',
          expand: 'Expand to view',
          collapse: 'Collapse',
        },
        leakRow: {
          unknownSource: 'Unknown source',
          defaultDescription: 'This can expose you to fraudulent email scams and identity theft.',
        },
        modal: {
          dateFound: 'Date found:',
          leakDetails: 'Leak details',
          source: 'Source',
          breachDate: 'Breach date',
          dataTypesLeaked: 'Data types leaked',
          personalDataFound: 'Personal data found',
          noPersonalData: 'No exposed personal data on this record.',
          recommendations: 'Recommendations',
          noRecommendations: 'No recommendations for this leak.',
          markResolved: 'Mark as resolved',
          resolved: 'Resolved',
          resolveSuccess: 'Marked as resolved.',
          resolveError: 'Failed to mark as resolved.',
          title: {
            password: 'Password leak',
            email: 'Email leak',
            phone: 'Phone leak',
            name: 'Name leak',
            address: 'Address leak',
            image: 'Image leak',
            domain: 'Domain leak',
          },
          field: {
            username: 'Username',
            password: 'Password',
            name: 'Name',
            breachType: 'Breach type',
          },
        },
      },
    },
    '0001': 'Register not found',
    '0002': 'User email not found',
    '0003': 'Company email already set up!',
    '0004': 'Company not found',
    '0005': 'Companies not found',
    '0006': 'User not found',
    '0007': `User doesn't have access to a company`,
    '0008':
      'Your company has exceeded the number of seats within the license. Please contact your administrator to expand the number of seats with Protexxa.',
    '0009': 'Invalid email domain',
    '0010': 'Leak not found',
    '0011':
      'Domain name belongs to a company. Check if you have received an invitation to this company.',
    '0012': `Previous Register doesn't have credits`,
    '0013': `Register doesn't have credits`,
    '0014': 'Users admin not found',
    '0015': 'Please authenticate',
    '0016': 'Forbidden',
    '0017': 'Incorrect token',
    '0018': 'Invite not found',
    '0019': 'Email already taken',
    '0020': 'Register already with 0 credits',
    '0021': 'Previous Register not found',
    '0022': 'Incorrect credentials.',
    '0022e': 'Please try again.',
    '0023': 'Code not found',
    '0024': 'Code not valid',
    '0025': 'Code is expired',
    '0026': 'Report not found',
    '0027': 'Report conflict',
    '0028': 'Your account access has been temporarily disabled.',
    '0029': 'Please contact your system administrator for further assistance.',
    '0030': 'Failed to update phone number.',
    '0031': 'Unexpected sign-in step: ',
    '0032': 'Failed to resend code.',
    '0033': 'Failed to update MFA options.',
    '0034': 'An error occurred during sign in.',
    '0035': 'The {{domain}} domain is being used by a company, please sign up by the invite link',
    '0036': 'Failed to send verification code',
    '0037': 'An error occurred during sign up.',
    '0038': 'An error occurred during confirmation.',
    '0039': 'No MFA method selected.',
    '0040': 'Validation error. Please check your input.',
    '0000': 'An error occurred.',
  },
}
